import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /** A scalar to support any type of data. */
  Any: any
  /** A date string with format `Y-m-d`, e.g. `2011-05-23`. */
  Date: any
  /** A datetime string with format `Y-m-d H:i:s`, e.g. `2018-05-23 13:43:32`. */
  DateTime: any
  /** A datetime and timezone string in ISO 8601 format `Y-m-dTH:i:sO`, e.g. `2020-04-20T13:53:12+02:00`. */
  DateTimeTz: any
  /** A file upload. */
  Upload: any
}

export type AcceptAgreementInput = {
  /** The global ID of the agreement to accept. */
  id: Scalars['ID']
}

export type Account = BalanceOwner &
  ContractOwner &
  Node &
  ScaleTicketOwner &
  SettlementOwner &
  User & {
    __typename?: 'Account'
    /** The balances connected to the account. */
    balances?: Maybe<BalanceConnection>
    /** The balances connected to the account, grouped by the given type. */
    balancesBy?: Maybe<Array<Maybe<BalanceBy>>>
    /** The company connected to the ticket. */
    company?: Maybe<Company>
    /** Contract stats for the company. */
    contractStats?: Maybe<ContractStatsConnection>
    /** The contracts connected to the account. */
    contracts?: Maybe<ContractConnection>
    /** The customers connected to the account. */
    customers: CustomerConnection
    /** A human-readable ID for display. */
    displayId: Scalars['ID']
    /** The name to be used for display. */
    displayName?: Maybe<Scalars['String']>
    /** The email address connected to the account. */
    email?: Maybe<Scalars['String']>
    /** The given and family name of the account. */
    fullName?: Maybe<Scalars['String']>
    /** Unique global ID. */
    id: Scalars['ID']
    /** The mobile number connected to the account in E.164 format. */
    mobilePhone?: Maybe<Scalars['String']>
    /** The offers connected to the account. */
    offers: OfferConnection
    /**
     * The mobile number connected to the account.
     * @deprecated Use `mobilePhone`.
     */
    phone?: Maybe<Scalars['String']>
    /** The scale tickets connected to the account. */
    scaleTickets?: Maybe<ScaleTicketConnection>
    /** The settlements connected to the account. */
    settlements?: Maybe<SettlementConnection>
  }

export type AccountBalancesArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
}

export type AccountBalancesByArgs = {
  type: BalanceByType
}

export type AccountContractStatsArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<ContractStatsFilter>
  first?: InputMaybe<Scalars['Int']>
  group?: InputMaybe<Array<InputMaybe<ContractStatsGroup>>>
  orderBy?: InputMaybe<ContractStatsOrderBy>
  sort?: InputMaybe<Array<InputMaybe<ContractStatsSort>>>
}

export type AccountContractsArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<ContractFilter>
  first?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<ContractOrderBy>
  sort?: InputMaybe<Array<InputMaybe<ContractSort>>>
  updatedAfter?: InputMaybe<Scalars['DateTimeTz']>
}

export type AccountCustomersArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

export type AccountOffersArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

export type AccountScaleTicketsArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<ScaleTicketFilter>
  first?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<ScaleTicketOrderBy>
  sort?: InputMaybe<Array<InputMaybe<ScaleTicketSort>>>
  updatedAfter?: InputMaybe<Scalars['DateTimeTz']>
}

export type AccountSettlementsArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<SettlementFilter>
  first?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<SettlementOrderBy>
  sort?: InputMaybe<Array<InputMaybe<SettlementSort>>>
  updatedAfter?: InputMaybe<Scalars['DateTimeTz']>
}

/** A paginated list of Account edges. */
export type AccountConnection = {
  __typename?: 'AccountConnection'
  /** A list of Account edges. */
  edges: Array<AccountEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type Account and a cursor. */
export type AccountEdge = {
  __typename?: 'AccountEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The Account node. */
  node: Account
}

export type AccountFilter = {
  /** Group filters with the `and` operator. */
  and?: InputMaybe<Array<InputMaybe<AccountFilter>>>
  /** Filter on the `displayId` field. */
  displayId?: InputMaybe<IdFilter>
  /** Filter on the `id` field. */
  id?: InputMaybe<IdFilter>
  /** Group filters with the `or` operator. */
  or?: InputMaybe<Array<InputMaybe<AccountFilter>>>
}

export type AccountOrderBy = {
  /** Sort on the `displayId` field. */
  displayId?: InputMaybe<SortOrder>
}

export type AccountSort = {
  /** Sort on the `displayId` field. */
  displayId?: InputMaybe<SortOrder>
}

export type AccountingDocument = Document &
  Node & {
    __typename?: 'AccountingDocument'
    /** The account connected to the document. */
    account?: Maybe<Account>
    /** Indicates whether the document can be signed. */
    canSign?: Maybe<Scalars['Boolean']>
    /** The file contents of the document. */
    content?: Maybe<Scalars['String']>
    /** The date and time the document was created. */
    createdAt?: Maybe<Scalars['DateTimeTz']>
    /** The ID to be used for display on the document. */
    displayId?: Maybe<Scalars['ID']>
    /** The data model the document is connected to. */
    documentable?: Maybe<Documentable>
    /** The file name of the document. */
    fileName?: Maybe<Scalars['String']>
    /** The URL to view the document. */
    fileUrl?: Maybe<Scalars['String']>
    /** Unique global ID for the document. */
    id: Scalars['ID']
    /** Indicates whether the document has been signed. */
    isSigned?: Maybe<Scalars['Boolean']>
    /** Indicates whether the document was voided. */
    isVoid?: Maybe<Scalars['Boolean']>
    /** The location connected to the document. */
    location?: Maybe<Location>
    /** The signature request for the document. */
    signatureRequest?: Maybe<SignatureRequest>
    /** The current state of the document's signature. */
    signatureState?: Maybe<DocumentSignatureState>
    /** The account connected to the document. */
    submitter?: Maybe<DocumentSubmitter>
    /** The title of the document. */
    title?: Maybe<Scalars['String']>
    /** The document type. */
    type?: Maybe<DocumentType>
  }

export type AccountingDocumentFileUrlArgs = {
  ttl?: InputMaybe<Scalars['Int']>
}

export type Agreement = {
  __typename?: 'Agreement'
  /** The contents of the agreement in HTML. */
  content: Scalars['String']
  /** Unique global ID for the agreement. */
  id: Scalars['ID']
  /** The tile of the agreement. */
  title: Scalars['String']
}

export type Anonymous = User & {
  __typename?: 'Anonymous'
  /** The company the user is connected to. */
  company?: Maybe<Company>
  /** The email address connected to the user. */
  email?: Maybe<Scalars['String']>
  /** The given and family name of the user. */
  fullName?: Maybe<Scalars['String']>
  /** Unique global ID. */
  id: Scalars['ID']
  /** The mobile number connected to the user in E.164 format. */
  mobilePhone?: Maybe<Scalars['String']>
  /** The anonymous user's notifications. */
  notifications: NotificationConnection
}

export type AnonymousNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

export type Attributable = {
  /** A specific attribute for the attributable type. */
  attribute?: Maybe<CustomAttributeValue>
  /** The attribute values for the attributable type. */
  attributes?: Maybe<CustomAttributeValueConnection>
}

export type AttributableAttributeArgs = {
  name: Scalars['String']
}

export enum AttributableType {
  /** Indicates the custom attribute is for the `Customer` type. */
  Customer = 'CUSTOMER'
}

export type Balance = {
  __typename?: 'Balance'
  /** The account the balance is for. */
  account?: Maybe<Account>
  /**
   * Account connected to the balance.
   * @deprecated Use `account.displayId`.
   */
  accountId?: Maybe<Scalars['ID']>
  /** The total balance amount. */
  amount?: Maybe<Scalars['Float']>
  /** The commodity connected to the balance. */
  commodity?: Maybe<Commodity>
  /** The company connected to the balance. */
  company?: Maybe<Company>
  /** Unique global ID. */
  id: Scalars['ID']
  /** The location connected to the balance. */
  location?: Maybe<Location>
  /**
   * Unique position ID.
   * @deprecated Use `type.id`.
   */
  positionId?: Maybe<Scalars['ID']>
  /**
   * The name of the position.
   * @deprecated Use `type.name`.
   */
  positionName?: Maybe<Scalars['String']>
  /** The type of balance. */
  type?: Maybe<BalanceType>
  /** The date and time the balance was last updated. */
  updatedAt?: Maybe<Scalars['DateTimeTz']>
}

export type BalanceBy = {
  __typename?: 'BalanceBy'
  /** The total balance of all items connected to the entity. */
  amount?: Maybe<Scalars['Float']>
  /** Unique entity type ID. */
  id: Scalars['ID']
  /** The balances connected to this entity. */
  items?: Maybe<Array<Maybe<BalanceBy>>>
  /** The entity type's name. */
  name?: Maybe<Scalars['String']>
}

export type BalanceByItemsArgs = {
  type: BalanceByType
}

export enum BalanceByType {
  /** Indicates to group by account. */
  Account = 'ACCOUNT',
  /** Indicates to group by commodity. */
  Commodity = 'COMMODITY',
  /** Indicates to group by location. */
  Location = 'LOCATION',
  /** Indicates to group by position. */
  Position = 'POSITION'
}

/** A paginated list of Balance edges. */
export type BalanceConnection = {
  __typename?: 'BalanceConnection'
  /** A list of Balance edges. */
  edges: Array<BalanceEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type Balance and a cursor. */
export type BalanceEdge = {
  __typename?: 'BalanceEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The Balance node. */
  node: Balance
}

export type BalanceOwner = {
  /** The balances connected to the user. */
  balances?: Maybe<BalanceConnection>
  /** The balances connected to the user, grouped by the given type. */
  balancesBy?: Maybe<Array<Maybe<BalanceBy>>>
}

export type BalanceOwnerBalancesByArgs = {
  type: BalanceByType
}

export type BalanceType = {
  __typename?: 'BalanceType'
  /** Unique global ID. */
  id: Scalars['ID']
  /** A name for the balance type. */
  name?: Maybe<Scalars['String']>
}

/** A paginated list of BalanceType edges. */
export type BalanceTypeConnection = {
  __typename?: 'BalanceTypeConnection'
  /** A list of BalanceType edges. */
  edges: Array<BalanceTypeEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type BalanceType and a cursor. */
export type BalanceTypeEdge = {
  __typename?: 'BalanceTypeEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The BalanceType node. */
  node: BalanceType
}

export type BillOfLading = {
  __typename?: 'BillOfLading'
  /** The ID of the BOL for display. */
  displayId?: Maybe<Scalars['ID']>
}

export type Booking = Node & {
  __typename?: 'Booking'
  /** The account connected to the booking. */
  account?: Maybe<Account>
  /** The date and time the booking was created. */
  createdAt?: Maybe<Scalars['DateTimeTz']>
  /** The booking ID used for display. */
  displayId?: Maybe<Scalars['ID']>
  /** The date the booking expires. */
  endDate?: Maybe<Scalars['Date']>
  /** Unique global identifier for the booking. */
  id: Scalars['ID']
  /** The products included in the booking. */
  items: BookingItemConnection
  /** The location the booking was made at. */
  location?: Maybe<Location>
  /** The date the booking starts. */
  startDate?: Maybe<Scalars['Date']>
  /** The current booking status. */
  status?: Maybe<BookingStatus>
  /** The total price booked. */
  totalBooked?: Maybe<Scalars['Float']>
  /** The total amount paid. */
  totalPaid?: Maybe<Scalars['Float']>
  /** The total amount remaining. */
  totalRemaining?: Maybe<Scalars['Float']>
  /** The date and time the booking was last updated. */
  updatedAt?: Maybe<Scalars['DateTimeTz']>
}

export type BookingItemsArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

/** A paginated list of Booking edges. */
export type BookingConnection = {
  __typename?: 'BookingConnection'
  /** A list of Booking edges. */
  edges: Array<BookingEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type Booking and a cursor. */
export type BookingEdge = {
  __typename?: 'BookingEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The Booking node. */
  node: Booking
}

export type BookingFilter = {
  /** Filter on the `account` field. */
  account?: InputMaybe<AccountFilter>
  /** Filter on the `createdAt` field. */
  createdAt?: InputMaybe<DateTimeTzFilter>
  /** Filter on the `endDate` field. */
  endDate?: InputMaybe<DateFilter>
  /** Filter on the `location` field. */
  location?: InputMaybe<LocationFilter>
  /** Filter on the `startDate` field. */
  startDate?: InputMaybe<DateFilter>
  /** Filter on the `status` field. */
  status?: InputMaybe<BookingStatusFilter>
}

export enum BookingFilterField {
  /** Indicates filtering on the `account` field. */
  Account = 'ACCOUNT',
  /** Indicates filtering on the `createdAt` field. */
  CreatedAt = 'CREATED_AT',
  /** Indicates filtering on the `endDate` field. */
  EndDate = 'END_DATE',
  /** Indicates filtering on the `location` field. */
  Location = 'LOCATION',
  /** Indicates filtering on the `startDate` field. */
  StartDate = 'START_DATE',
  /** Indicates filtering on the `status` field. */
  Status = 'STATUS'
}

export type BookingItem = Node & {
  __typename?: 'BookingItem'
  /** The account connected to the booking item. */
  account?: Maybe<Account>
  /** The booking this item is related to. */
  booking?: Maybe<Booking>
  /** The ID of the booking item for display. */
  displayId?: Maybe<Scalars['ID']>
  /** Unique global identifier for the booking item. */
  id: Scalars['ID']
  /** Whether or not the item was prepaid. */
  isPrepaid?: Maybe<Scalars['Boolean']>
  /** The location the booking item is for. */
  location?: Maybe<Location>
  /** The percentage remaining on the booking item. */
  percentRemaining?: Maybe<Scalars['Float']>
  /** The product the booking item is for. */
  product?: Maybe<BookingProduct>
  /** Total quantity of the product booked. */
  quantityBooked?: Maybe<Scalars['Float']>
  /** Total quantity of the product that has been paid for. */
  quantityPaid?: Maybe<Scalars['Float']>
  /** Total quantity of the product that is remaining. */
  quantityRemaining?: Maybe<Scalars['Float']>
  /** The total price of the booked product. */
  totalBooked?: Maybe<Scalars['Float']>
  /** The amount of the booked product that has been paid. */
  totalPaid?: Maybe<Scalars['Float']>
  /** The amount that is still owed on the product. */
  totalRemaining?: Maybe<Scalars['Float']>
  /** The unit of measure of the product. */
  unitOfMeasure?: Maybe<Scalars['String']>
  /** The unit price of the product. */
  unitPrice?: Maybe<Scalars['Float']>
}

/** A paginated list of BookingItem edges. */
export type BookingItemConnection = {
  __typename?: 'BookingItemConnection'
  /** A list of BookingItem edges. */
  edges: Array<BookingItemEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type BookingItem and a cursor. */
export type BookingItemEdge = {
  __typename?: 'BookingItemEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The BookingItem node. */
  node: BookingItem
}

export type BookingOrderBy = {
  /** Sort on the `account` field. */
  account?: InputMaybe<AccountOrderBy>
  /** Sort on the `createdAt` field. */
  createdAt?: InputMaybe<SortOrder>
}

export enum BookingOrderByField {
  /** Indicates sorting on the `account` field. */
  Account = 'ACCOUNT',
  /** Indicates sorting on the `createdAt` field. */
  CreatedAt = 'CREATED_AT'
}

export type BookingProduct = {
  __typename?: 'BookingProduct'
  /** Unique global identifier for the booking product. */
  id: Scalars['ID']
  /** The name of the product. */
  name?: Maybe<Scalars['String']>
}

/** Booking-specific settings. */
export type BookingSettings = {
  __typename?: 'BookingSettings'
  /** The fields bookings can be filtered on. */
  filterFields: Array<BookingFilterField>
  /** The fields bookings can be sorted on. */
  sortFields: Array<BookingSortField>
}

export type BookingSort = {
  /** Sort on the `account` field. */
  account?: InputMaybe<AccountSort>
  /** Sort on the `createdAt` field. */
  createdAt?: InputMaybe<SortOrder>
}

export enum BookingSortField {
  /** Indicates sorting on the `account` field. */
  Account = 'ACCOUNT',
  /** Indicates sorting on the `createdAt` field. */
  CreatedAt = 'CREATED_AT'
}

export enum BookingStatus {
  /** Indicates the booking is complete. */
  Closed = 'CLOSED',
  /** Indicates the booking is still open. */
  Open = 'OPEN'
}

export type BookingStatusFilter = {
  /** Equal to the given `BookingStatus`. */
  eq?: InputMaybe<BookingStatus>
  /** Equal to any of the given `BookingStatus`. */
  in?: InputMaybe<Array<BookingStatus>>
}

export type BooleanAttributeValue = CustomAttributeValue & {
  __typename?: 'BooleanAttributeValue'
  /** The custom attribute. */
  customAttribute?: Maybe<CustomAttribute>
  /** The value normalized as a string. */
  normalizedValue: Scalars['Any']
  /** The actual value of the attribute. */
  value?: Maybe<Scalars['Boolean']>
}

export type BooleanFilter = {
  /** Equal to the given boolean value. */
  eq?: InputMaybe<Scalars['Boolean']>
}

/** Prices for a commodity at a given location and delivery date range. */
export type CashBid = Loggable &
  Node &
  OfferOwner & {
    __typename?: 'CashBid'
    /** The basis for the cash bid. */
    basis?: Maybe<Scalars['Float']>
    /** The commodity the cash bid is for. */
    commodity: Commodity
    /** The company the cash bid is for. */
    company: Company
    /** The end of the delivery range for the cash bid. */
    deliveryEnd: Scalars['Date']
    /** The start of the delivery range for the cash bid. */
    deliveryStart: Scalars['Date']
    /**
     * The futures symbol the cash bid is based off of.
     * @deprecated Use `futuresSymbol`.
     */
    futureSymbol?: Maybe<Scalars['String']>
    /** The month of the futures contract. */
    futuresMonth?: Maybe<Scalars['Date']>
    /** The futures symbol the cash bid is based off of. */
    futuresSymbol?: Maybe<Scalars['String']>
    /** The futures symbol the cash bid is hedged off of. */
    hedgeSymbol?: Maybe<Scalars['String']>
    /** The unique global ID for the given cash bid. */
    id: Scalars['ID']
    /** Whether or not the bid is public or not. */
    isPublic?: Maybe<Scalars['Boolean']>
    /** The location the cash bid is for. */
    location: Location
    /** Extra information about the bid. */
    notes?: Maybe<Scalars['String']>
    /** The types of offers the company supports. */
    offerTypes?: Maybe<Array<Maybe<OfferType>>>
    /** Offers using the bid. */
    offers: OfferConnection
    /** The sum of the commodity's last price and the basis. */
    price?: Maybe<Scalars['Float']>
    /** The price data for the future symbol the cash bid is based off of. */
    quote?: Maybe<Quote>
    /** The fraction of a cent where prices should be rounded up. Compare this value to the fractional part of the price. If the fraction >= to this value, then round up. Otherwise, round down. */
    roundAt?: Maybe<Scalars['Float']>
    /** The order of the bid. */
    sortOrder?: Maybe<Scalars['Int']>
    /** History of updates to the cash bid. */
    updates: CashBidUpdateConnection
  }

/** Prices for a commodity at a given location and delivery date range. */
export type CashBidBasisArgs = {
  format?: CashBidBasisFormat
}

/** Prices for a commodity at a given location and delivery date range. */
export type CashBidOffersArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
  status?: InputMaybe<Array<InputMaybe<OfferStatus>>>
}

/** Prices for a commodity at a given location and delivery date range. */
export type CashBidPriceArgs = {
  useConversion?: InputMaybe<Scalars['Boolean']>
}

/** Prices for a commodity at a given location and delivery date range. */
export type CashBidUpdatesArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

export enum CashBidBasisFormat {
  /** Indicates the basis should return in cent format (ex: 55). */
  Cent = 'CENT',
  /** Indicates the basis should return in decimal format (ex: 0.55). */
  Decimal = 'DECIMAL'
}

/** A paginated list of CashBid edges. */
export type CashBidConnection = {
  __typename?: 'CashBidConnection'
  /** A list of CashBid edges. */
  edges: Array<CashBidEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type CashBid and a cursor. */
export type CashBidEdge = {
  __typename?: 'CashBidEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The CashBid node. */
  node: CashBid
}

export type CashBidFilter = {
  /** Group filters with the `and` operator. */
  and?: InputMaybe<Array<InputMaybe<CashBidFilter>>>
  /** Filter on the `commodity` field. */
  commodity?: InputMaybe<CommodityFilter>
  /** Filter on the `company` field. */
  company?: InputMaybe<CompanyFilter>
  /** Filter on the `deliveryEnd` field. */
  deliveryEnd?: InputMaybe<DateFilter>
  /** Filter on the `deliveryStart` field. */
  deliveryStart?: InputMaybe<DateFilter>
  /** Filter on the `location` field. */
  location?: InputMaybe<LocationFilter>
  /** Group filters with the `or` operator. */
  or?: InputMaybe<Array<InputMaybe<CashBidFilter>>>
  /** Filter on the `price` field. */
  price?: InputMaybe<FloatFilter>
}

export type CashBidOrderBy = {
  /** Sort on the `commodity` field. */
  commodity?: InputMaybe<CommodityOrderBy>
  /** Sort on the `company` field. */
  company?: InputMaybe<CompanyOrderBy>
  /** Sort on the `deliveryStart` field. */
  deliveryStart?: InputMaybe<SortOrder>
  /** Sort on the `location` field. */
  location?: InputMaybe<LocationOrderBy>
  /** Sort on the `sortOrder` field. */
  sortOrder?: InputMaybe<SortOrder>
}

/** The fraction of a cent where prices should be rounded up on a bid. */
export enum CashBidRounding {
  /** Indicates to always round down. */
  Down = 'DOWN',
  /** Indicates no rounding (may result in partial cents). */
  None = 'NONE',
  /** Indicates to round up 1/4 cent. */
  OneFourth = 'ONE_FOURTH',
  /** Indicates to round up 1/2 cent. */
  OneHalf = 'ONE_HALF',
  /** Indicates to round up 3/4 cent. */
  ThreeFourths = 'THREE_FOURTHS'
}

export type CashBidSort = {
  /** Sort on the `commodity` field. */
  commodity?: InputMaybe<CommoditySort>
  /** Sort on the `company` field. */
  company?: InputMaybe<CompanySort>
  /** Sort on the `deliveryStart` field. */
  deliveryStart?: InputMaybe<SortOrder>
  /** Sort on the `location` field. */
  location?: InputMaybe<LocationSort>
  /** Sort on the `sortOrder` field. */
  sortOrder?: InputMaybe<SortOrder>
}

/** A historical update of a cash bid. */
export type CashBidUpdate = {
  __typename?: 'CashBidUpdate'
  /** The basis for the cash bid. */
  basis?: Maybe<Scalars['Float']>
  /** The commodity the cash bid is for. */
  commodity?: Maybe<Commodity>
  /** The date and time the update was made at. */
  createdAt?: Maybe<Scalars['DateTimeTz']>
  /** The end of the delivery range for the cash bid. */
  deliveryEnd: Scalars['Date']
  /** The start of the delivery range for the cash bid. */
  deliveryStart: Scalars['Date']
  /** The futures symbol the cash bid is based off of. */
  futuresSymbol?: Maybe<Scalars['String']>
  /** The futures symbol the cash bid is hedged off of. */
  hedgeSymbol?: Maybe<Scalars['String']>
  /** The unique global ID for the given cash bid. */
  id: Scalars['ID']
  /** Whether or not the bid is public or not. */
  isPublic?: Maybe<Scalars['Boolean']>
  /** The location the cash bid is for. */
  location?: Maybe<Location>
  /** The price of the bid if `actualPrice` or `null` otherwise. */
  price?: Maybe<Scalars['Float']>
  /** The fraction of a cent where prices should be rounded up. Compare this value to the fractional part of the price. If the fraction >= to this value, then round up. Otherwise, round down. */
  roundAt?: Maybe<Scalars['Float']>
}

/** A paginated list of CashBidUpdate edges. */
export type CashBidUpdateConnection = {
  __typename?: 'CashBidUpdateConnection'
  /** A list of CashBidUpdate edges. */
  edges: Array<CashBidUpdateEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type CashBidUpdate and a cursor. */
export type CashBidUpdateEdge = {
  __typename?: 'CashBidUpdateEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The CashBidUpdate node. */
  node: CashBidUpdate
}

export enum CashBidVisibility {
  /** Indicates the cash bids are visible only to approved customers. */
  ApprovalRequired = 'APPROVAL_REQUIRED',
  /** Indicates the cash bids are visible only to employees. */
  EmployeesOnly = 'EMPLOYEES_ONLY',
  /** Indicates the cash bids are visible only to authenticated customers. */
  LoginRequired = 'LOGIN_REQUIRED',
  /** Indicates the cash bids are visible to everyone. */
  Public = 'PUBLIC'
}

export type Commodity = Node & {
  __typename?: 'Commodity'
  /** The ID of the commodity in the elevator's accounting provider, if applicable. */
  accountingId?: Maybe<Scalars['ID']>
  /** Commodity conversion settings. */
  conversion?: Maybe<CommodityConversion>
  /** Unique global ID for the commodity. */
  id: Scalars['ID']
  /** The name of the commodity. */
  name?: Maybe<Scalars['String']>
  /** Elevator specific quantity settings. */
  quantities?: Maybe<CommodityQuantity>
  /** Retrieve a custom setting for the commodity. */
  setting?: Maybe<Scalars['String']>
  /** Get all custom settings for the commodity. */
  settings?: Maybe<Array<Maybe<CustomSetting>>>
  /** The order in which the commodity should be sorted. If `null`, then sort by `name`. */
  sortOrder?: Maybe<Scalars['Int']>
}

export type CommoditySettingArgs = {
  name: Scalars['String']
}

/** A paginated list of Commodity edges. */
export type CommodityConnection = {
  __typename?: 'CommodityConnection'
  /** A list of Commodity edges. */
  edges: Array<CommodityEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

export type CommodityConversion = {
  __typename?: 'CommodityConversion'
  /** The divisor to use for commodity conversion. */
  divisor?: Maybe<Scalars['Float']>
  /** A multiplier to use for commodity conversion. */
  multiplier?: Maybe<Scalars['Float']>
  /** The unit of measure to convert the commodity to. */
  unitOfMeasure?: Maybe<UnitOfMeasure>
}

export type CommodityConversionInput = {
  /** A multiplier for the unit conversion. */
  multiplier?: InputMaybe<Scalars['Float']>
  /** The unique ID for the unit of measurement to convert bids to. */
  unitOfMeasure?: InputMaybe<Scalars['ID']>
}

/** An edge that contains a node of type Commodity and a cursor. */
export type CommodityEdge = {
  __typename?: 'CommodityEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The Commodity node. */
  node: Commodity
}

export type CommodityFilter = {
  /** Filter on the `accountingId` field. */
  accountingId?: InputMaybe<IdFilter>
  /** Group filters with the `and` operator. */
  and?: InputMaybe<Array<InputMaybe<CommodityFilter>>>
  /** Filter on the `id` field. */
  id?: InputMaybe<IdFilter>
  /** Group filters with the `or` operator. */
  or?: InputMaybe<Array<InputMaybe<CommodityFilter>>>
}

export type CommodityOrderBy = {
  /** Sort on the `name` field. */
  name?: InputMaybe<SortOrder>
  /** Sort on the `sortOrder` field. */
  sortOrder?: InputMaybe<SortOrder>
}

/** Settings for minimum, maximum, and step values for the bushel quantity on an offer. */
export type CommodityQuantity = {
  __typename?: 'CommodityQuantity'
  /** Whether the customer can set "custom" values for the amount. When true, this ignores the `step` field. */
  canUseCustomValues?: Maybe<Scalars['Boolean']>
  /** The maximum amount of bushels that can be set. */
  max?: Maybe<Scalars['Float']>
  /** The minimum amount of bushels that can be set. */
  min?: Maybe<Scalars['Float']>
  /** The amount at which to increase and decrease the bushels. */
  step?: Maybe<Scalars['Float']>
}

export type CommodityQuantityInput = {
  /** Whether the customer can set "custom" values for the amount. When true, this ignores the `step` field. */
  canUseCustomValues: Scalars['Boolean']
  /** The maximum amount of bushels that can be set. */
  max?: InputMaybe<Scalars['Float']>
  /** The minimum amount of bushels that can be set. */
  min?: InputMaybe<Scalars['Float']>
  /** The amount at which to increase and decrease the bushels. */
  step?: InputMaybe<Scalars['Float']>
}

export type CommoditySort = {
  /** Sort on the `name` field. */
  name?: InputMaybe<SortOrder>
  /** Sort on the `sortOrder` field. */
  sortOrder?: InputMaybe<SortOrder>
}

export type Company = ContractOwner &
  Node &
  OfferOwner & {
    __typename?: 'Company'
    /** The accounts connected to the company. */
    accounts?: Maybe<AccountConnection>
    /** The types of balances the company supports. */
    balanceTypes: BalanceTypeConnection
    /** The balances for the company. */
    balances?: Maybe<BalanceConnection>
    /** The settlements for the company. */
    bookings?: Maybe<BookingConnection>
    /** The cash bids data connected to the location. */
    cashBids: CashBidConnection
    /** Commodities connected to the company. */
    commodities: CommodityConnection
    /** Contact information for the company. */
    contact?: Maybe<CompanyContact>
    /** Contract stats for the company. */
    contractStats?: Maybe<ContractStatsConnection>
    /** The types of contracts the company supports. */
    contractTypes?: Maybe<ContractTypeConnection>
    /** The contracts for the company. */
    contracts?: Maybe<ContractConnection>
    /** The custom attributes defined for the company. */
    customAttributes: CustomAttributeConnection
    /** The customers of the company. */
    customers: CustomerConnection
    /** Unique database ID, used for external services. */
    databaseId: Scalars['ID']
    /** Human-readable identifier for the elevator. */
    displayId?: Maybe<Scalars['ID']>
    /** The company's document types. */
    documentTypes: DocumentTypeConnection
    /** The documents for the company. */
    documents: DocumentConnection
    /** The employees of the company. */
    employees: EmployeeConnection
    /** The features that the company supports. */
    features?: Maybe<Array<Maybe<CompanyFeature>>>
    /** Unique global ID for the company. */
    id: Scalars['ID']
    /** Custom links defined by the company. */
    links?: Maybe<Array<Maybe<Link>>>
    /** The types of locations this company supports. */
    locationTypes: LocationTypeConnection
    /** Locations connected to the company. */
    locations: LocationConnection
    /** Messages logged for the company. */
    logMessages: LogMessageConnection
    /** URL to the logo for the company. */
    logo?: Maybe<Scalars['String']>
    /** The host marketplace is hosted on. */
    marketplaceHost?: Maybe<Scalars['String']>
    /** The company name. */
    name?: Maybe<Scalars['String']>
    /** The types of offers the company supports. */
    offerTypes?: Maybe<Array<Maybe<OfferType>>>
    /** The offers connected to the company. */
    offers: OfferConnection
    /** The scale tickets for the company. */
    scaleTickets?: Maybe<ScaleTicketConnection>
    /** The available filters for the company's data. */
    settings?: Maybe<CompanySettings>
    /** The settlements for the company. */
    settlements?: Maybe<SettlementConnection>
    /** The signature requests for the company. */
    signatureRequests: SignatureRequestConnection
    /** The signature requests for the company. */
    signatures: SignatureConnection
    /** The website for the company. */
    website?: Maybe<Scalars['String']>
  }

export type CompanyAccountsArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
}

export type CompanyBalanceTypesArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

export type CompanyBalancesArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  updatedAfter?: InputMaybe<Scalars['DateTimeTz']>
}

export type CompanyBookingsArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<BookingFilter>
  first?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<BookingOrderBy>
  sort?: InputMaybe<Array<InputMaybe<BookingSort>>>
}

export type CompanyCashBidsArgs = {
  after?: InputMaybe<Scalars['String']>
  commodity?: InputMaybe<Scalars['ID']>
  filter?: InputMaybe<CashBidFilter>
  first?: Scalars['Int']
  location?: InputMaybe<Scalars['ID']>
  orderBy?: InputMaybe<CashBidOrderBy>
  sort?: InputMaybe<Array<InputMaybe<CashBidSort>>>
}

export type CompanyCommoditiesArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<CommodityFilter>
  first?: Scalars['Int']
  orderBy?: InputMaybe<CommodityOrderBy>
  sort?: InputMaybe<Array<InputMaybe<CommoditySort>>>
}

export type CompanyContractStatsArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<ContractStatsFilter>
  first?: InputMaybe<Scalars['Int']>
  group?: InputMaybe<Array<InputMaybe<ContractStatsGroup>>>
  orderBy?: InputMaybe<ContractStatsOrderBy>
  sort?: InputMaybe<Array<InputMaybe<ContractStatsSort>>>
}

export type CompanyContractTypesArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
}

export type CompanyContractsArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<ContractFilter>
  first?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<ContractOrderBy>
  sort?: InputMaybe<Array<InputMaybe<ContractSort>>>
  updatedAfter?: InputMaybe<Scalars['DateTimeTz']>
}

export type CompanyCustomAttributesArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

export type CompanyCustomersArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<CustomerFilter>
  first?: Scalars['Int']
  offerStatus?: InputMaybe<Array<InputMaybe<CustomerOfferStatus>>>
  orderBy?: InputMaybe<CustomerOrderBy>
  search?: InputMaybe<Scalars['String']>
  sort?: InputMaybe<Array<InputMaybe<CustomerSort>>>
}

export type CompanyDocumentTypesArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

export type CompanyDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<DocumentFilter>
  first?: Scalars['Int']
  sort?: InputMaybe<Array<InputMaybe<DocumentSort>>>
}

export type CompanyEmployeesArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

export type CompanyLocationTypesArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

export type CompanyLocationsArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<LocationFilter>
  first?: Scalars['Int']
  orderBy?: InputMaybe<LocationOrderBy>
  sort?: InputMaybe<Array<InputMaybe<LocationSort>>>
}

export type CompanyLogMessagesArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<LogMessageFilter>
  first?: Scalars['Int']
  orderBy?: InputMaybe<LogMessageOrderBy>
  sort?: InputMaybe<Array<InputMaybe<LogMessageSort>>>
}

export type CompanyOffersArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<OfferFilter>
  first?: Scalars['Int']
  orderBy?: InputMaybe<OfferOrderBy>
  sort?: InputMaybe<Array<InputMaybe<OfferSort>>>
  status?: InputMaybe<Array<InputMaybe<OfferStatus>>>
}

export type CompanyScaleTicketsArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<ScaleTicketFilter>
  first?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<ScaleTicketOrderBy>
  sort?: InputMaybe<Array<InputMaybe<ScaleTicketSort>>>
  updatedAfter?: InputMaybe<Scalars['DateTimeTz']>
}

export type CompanySettlementsArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<SettlementFilter>
  first?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<SettlementOrderBy>
  sort?: InputMaybe<Array<InputMaybe<SettlementSort>>>
  updatedAfter?: InputMaybe<Scalars['DateTimeTz']>
}

export type CompanySignatureRequestsArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<SignatureRequestFilter>
  first?: Scalars['Int']
  sort?: InputMaybe<Array<InputMaybe<SignatureRequestSort>>>
}

export type CompanySignaturesArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<SignatureFilter>
  first?: Scalars['Int']
  sort?: InputMaybe<Array<InputMaybe<SignatureSort>>>
}

/** A paginated list of Company edges. */
export type CompanyConnection = {
  __typename?: 'CompanyConnection'
  /** A list of Company edges. */
  edges: Array<CompanyEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** Contact information for an company. */
export type CompanyContact = {
  __typename?: 'CompanyContact'
  /** HTML-formatted additional contact information. */
  additional?: Maybe<Scalars['String']>
  /** First line of the address for the company. */
  addressOne?: Maybe<Scalars['String']>
  /** Third line of the address for the company. */
  addressThree?: Maybe<Scalars['String']>
  /** Second line of the address for the company. */
  addressTwo?: Maybe<Scalars['String']>
  /** The city the company is located in. */
  city?: Maybe<Scalars['String']>
  /** The contact email for the company. */
  email?: Maybe<Scalars['String']>
  /** The fax number of the company. */
  faxNumber?: Maybe<Scalars['String']>
  /** Notes defined by the company. */
  notes?: Maybe<Scalars['String']>
  /** The phone number of the company. */
  phoneNumber?: Maybe<Scalars['String']>
  /** The state the company is located in. */
  state?: Maybe<Scalars['String']>
  /** The postal code for the company's location. */
  zipCode?: Maybe<Scalars['String']>
}

/** An edge that contains a node of type Company and a cursor. */
export type CompanyEdge = {
  __typename?: 'CompanyEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The Company node. */
  node: Company
}

/** Features that are supported by a company. */
export enum CompanyFeature {
  /** Indicates that the company supports accounts. */
  Accounts = 'ACCOUNTS',
  /** Indicates that the company supports balances. */
  Balances = 'BALANCES',
  /** Indicates that the company supports bookings. */
  Bookings = 'BOOKINGS',
  /** Indicates that the company supports contracts. */
  Contracts = 'CONTRACTS',
  /** Indicates that the company supports customers. */
  Customers = 'CUSTOMERS',
  /** Indicates that the company supports offers. */
  Offers = 'OFFERS',
  /** Indicates that the company supports outboundn scale tickets. */
  OutboundScaleTickets = 'OUTBOUND_SCALE_TICKETS',
  /** Indicates that the company supports scale tickets. */
  ScaleTickets = 'SCALE_TICKETS',
  /** Indicates that the company supports settlements. */
  Settlements = 'SETTLEMENTS',
  /** Indicates that the company supports eSign. */
  Signatures = 'SIGNATURES',
  /** Indicates that the company supports latest generation eSign. */
  SignatureRequests = 'SIGNATURE_REQUESTS'
}

export type CompanyFilter = {
  /** Group filters with the `and` operator. */
  and?: InputMaybe<Array<InputMaybe<CompanyFilter>>>
  /** Filter on the `displayId` field. */
  displayId?: InputMaybe<IdFilter>
  /** Filter on the `id` field. */
  id?: InputMaybe<IdFilter>
  /** Filter on the `marketplaceHost` field. */
  marketplaceHost?: InputMaybe<StringFilter>
  /** Group filters with the `or` operator. */
  or?: InputMaybe<Array<InputMaybe<CompanyFilter>>>
}

export type CompanyOrderBy = {
  /** Sort on the `name` field. */
  name?: InputMaybe<SortOrder>
}

/** Company-specific settings for various data sets. */
export type CompanySettings = {
  __typename?: 'CompanySettings'
  /** The company's booking settings. */
  bookings?: Maybe<BookingSettings>
  /** The company's contract settings. */
  contracts?: Maybe<ContractSettings>
  /** The company's Marketplace settings. */
  marketplace?: Maybe<MarketplaceSettings>
  /** The company's offer settings. */
  offers?: Maybe<OfferSettings>
  /** The company's scale ticket settings. */
  scaleTickets?: Maybe<ScaleTicketSettings>
  /** The company's settlement settings. */
  settlements?: Maybe<SettlementSettings>
}

export type CompanySettingsInput = {
  /** The company offer settings. */
  offers?: InputMaybe<OfferSettingsInput>
}

export type CompanySort = {
  /** Sort on the `name` field. */
  name?: InputMaybe<SortOrder>
}

export type Contract = Documentable &
  Node &
  Signable & {
    __typename?: 'Contract'
    /** The account the contract is for. */
    account?: Maybe<Account>
    /**
     * The account ID the contract is connected to.
     * @deprecated Use `account.displayId`.
     */
    accountId?: Maybe<Scalars['ID']>
    /**
     * Amount contracted in bushels.
     * @deprecated Use `quantity`.
     */
    amountBushels?: Maybe<Scalars['Float']>
    /**
     * The amount on the contract that has already been delivered.
     * @deprecated Use `quantityDelivered`.
     */
    amountDelivered?: Maybe<Scalars['Float']>
    /**
     * Amount contracted in pounds.
     * @deprecated Use `quantity`.
     */
    amountPounds?: Maybe<Scalars['Float']>
    /**
     * The remaining amount on the contract that has not been delivered.
     * @deprecated Use `quantityRemaining`.
     */
    amountRemaining?: Maybe<Scalars['Float']>
    /** The basis price of the contract. */
    basisPrice?: Maybe<Scalars['Float']>
    /** The commodity connected to the contract. */
    commodity: Commodity
    /** The company connected to the contract. */
    company?: Maybe<Company>
    /**
     * Unique elevator contract ID.
     * @deprecated Use `displayId`.
     */
    contractNumber?: Maybe<Scalars['ID']>
    /** The deferred payment date. */
    deferDate?: Maybe<Scalars['Date']>
    /** The delivery basis of the contract. */
    deliveryBasis?: Maybe<Scalars['String']>
    /** The delivery end date for the contract. */
    deliveryEnd?: Maybe<Scalars['Date']>
    /** The delivery start date for the contract. */
    deliveryStart?: Maybe<Scalars['Date']>
    /** The delivery terms of the contract. */
    deliveryTerms?: Maybe<Scalars['String']>
    /** Contract display ID. */
    displayId: Scalars['ID']
    /** List of documents attached to the contract. */
    documents: DocumentConnection
    /**
     * The elevator connected to the contract.
     * @deprecated Use `company`.
     */
    elevator: Elevator
    /** The expiration date. */
    expiration?: Maybe<Scalars['Date']>
    /** The third party ID for the contract. */
    externalId?: Maybe<Scalars['ID']>
    /** Any fees on the contract. */
    feePrice?: Maybe<Scalars['Float']>
    /** The freight price of the contract. */
    freightPrice?: Maybe<Scalars['Float']>
    /**
     * The future price of the contract.
     * @deprecated Use `futuresPrice`.
     */
    futurePrice?: Maybe<Scalars['Float']>
    /** The futures month connected to the contract. */
    futuresMonth?: Maybe<Scalars['String']>
    /** The futures price of the contract. */
    futuresPrice?: Maybe<Scalars['Float']>
    /** The futures symbol used for the contract. */
    futuresSymbol?: Maybe<Scalars['String']>
    /** Unique global ID. */
    id: Scalars['ID']
    /** Indicates whether the contract is complete. */
    isComplete?: Maybe<Scalars['Boolean']>
    /** Indicates whether the contract has been signed. */
    isSigned?: Maybe<Scalars['Boolean']>
    /** The date the contract was issued on. */
    issueDate?: Maybe<Scalars['Date']>
    /** The location connected to the contract. */
    location?: Maybe<Location>
    /** List of free-form text about the contract. */
    notes: ContractNoteConnection
    /** The price of the contract. */
    price?: Maybe<Scalars['Float']>
    /** A list of amendments to the contract. */
    pricing: ContractPricingConnection
    /** Quantity contracted. */
    quantity?: Maybe<Scalars['Float']>
    /** The quantity that was canceled on the contract. */
    quantityCanceled?: Maybe<Scalars['Float']>
    /** The quantity on the contract that has already been delivered. */
    quantityDelivered?: Maybe<Scalars['Float']>
    /** The remaining quantity on the contract that has not been delivered. */
    quantityRemaining?: Maybe<Scalars['Float']>
    /** The remaining unpriced quantity on the contract. */
    quantityUnpriced?: Maybe<Scalars['Float']>
    /** List of scale tickets related to the contract. */
    scaleTickets: ScaleTicketConnection
    /** A contract signature request. */
    signature?: Maybe<Signature>
    /** Indicates whether the contract is still open or not. */
    status?: Maybe<ContractStatus>
    /** Whether the quantity is being purchased or sold. */
    transactionType?: Maybe<ContractTransactionType>
    /** The contract type. */
    type?: Maybe<ContractType>
    /**
     * The contract type for display.
     * @deprecated Use `type.name`.
     */
    typeDisplay?: Maybe<Scalars['String']>
    /** The units the contract is measured in. */
    unitOfMeasure?: Maybe<UnitOfMeasure>
    /** The date and time the contract was last updated. */
    updatedAt?: Maybe<Scalars['DateTimeTz']>
  }

export type ContractDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

export type ContractNotesArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

export type ContractPricingArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

export type ContractScaleTicketsArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

/** A paginated list of Contract edges. */
export type ContractConnection = {
  __typename?: 'ContractConnection'
  /** A list of Contract edges. */
  edges: Array<ContractEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type Contract and a cursor. */
export type ContractEdge = {
  __typename?: 'ContractEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The Contract node. */
  node: Contract
}

export type ContractFilter = {
  /** Filter on the `account` field. */
  account?: InputMaybe<AccountFilter>
  /** Filter on the `commodity` field. */
  commodity?: InputMaybe<CommodityFilter>
  /** Filter on the `deliveryEnd` field. */
  deliveryEnd?: InputMaybe<DateFilter>
  /** Filter on the `deliveryStart` field. */
  deliveryStart?: InputMaybe<DateFilter>
  /** Filter on the `displayId` field. */
  displayId?: InputMaybe<IdFilter>
  /** Filter on the `isSigned` field. */
  isSigned?: InputMaybe<BooleanFilter>
  /** Filter on the `issueDate` field. */
  issueDate?: InputMaybe<DateFilter>
  /** Filter on the `location` field. */
  location?: InputMaybe<LocationFilter>
  /** Filter on the `status` field. */
  status?: InputMaybe<ContractStatusFilter>
  /** Filter on the `type` field. */
  type?: InputMaybe<ContractTypeFilter>
}

export enum ContractFilterField {
  /** Indicates filtering on the `account` field. */
  Account = 'ACCOUNT',
  /** Indicates filtering on the `commodity` field. */
  Commodity = 'COMMODITY',
  /** Indicates filtering on the `deliveryEnd` field. */
  DeliveryEnd = 'DELIVERY_END',
  /** Indicates filtering on the `deliveryStart` field. */
  DeliveryStart = 'DELIVERY_START',
  /** Indicates filtering on the `displayId` field. */
  DisplayId = 'DISPLAY_ID',
  /** Indicates filtering on the `issueDate` field. */
  IssueDate = 'ISSUE_DATE',
  /** Indicates filtering on the `isSigned` field. */
  IsSigned = 'IS_SIGNED',
  /** Indicates filtering on the `location` field. */
  Location = 'LOCATION',
  /** Indicates filtering on the `status` field. */
  Status = 'STATUS',
  /** Indicates filtering on the `type` field. */
  Type = 'TYPE'
}

export type ContractNote = {
  __typename?: 'ContractNote'
  /** A human-readable identifier for the note. */
  displayId?: Maybe<Scalars['ID']>
  /** Unique global ID. */
  id: Scalars['ID']
  /** The text of the note. */
  value?: Maybe<Scalars['String']>
}

/** A paginated list of ContractNote edges. */
export type ContractNoteConnection = {
  __typename?: 'ContractNoteConnection'
  /** A list of ContractNote edges. */
  edges: Array<ContractNoteEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type ContractNote and a cursor. */
export type ContractNoteEdge = {
  __typename?: 'ContractNoteEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The ContractNote node. */
  node: ContractNote
}

export type ContractNoteInput = {
  /** Free-form text. */
  value: Scalars['String']
}

export type ContractOrderBy = {
  /** Sort on the `account` field. */
  account?: InputMaybe<AccountOrderBy>
  /** Sort on the `commodity` field. */
  commodity?: InputMaybe<CommodityOrderBy>
  /** Sort on the `deliveryEnd` field. */
  deliveryEnd?: InputMaybe<SortOrder>
  /** Sort on the `deliveryStart` field. */
  deliveryStart?: InputMaybe<SortOrder>
  /** Sort on the `displayId` field. */
  displayId?: InputMaybe<SortOrder>
  /** Sort on the `isSigned` field. */
  isSigned?: InputMaybe<SortOrder>
  /** Sort on the `issueDate` field. */
  issueDate?: InputMaybe<SortOrder>
  /** Sort on the `location` field. */
  location?: InputMaybe<LocationOrderBy>
  /** Sort on the `status` field. */
  status?: InputMaybe<SortOrder>
}

export enum ContractOrderByField {
  /** Indicates sorting on the `account` field. */
  Account = 'ACCOUNT',
  /** Indicates sorting on the `commodity` field. */
  Commodity = 'COMMODITY',
  /** Indicates sorting on the `deliveryEnd` field. */
  DeliveryEnd = 'DELIVERY_END',
  /** Indicates sorting on the `deliveryStart` field. */
  DeliveryStart = 'DELIVERY_START',
  /** Indicates sorting on the `displayId` field. */
  DisplayId = 'DISPLAY_ID',
  /** Indicates sorting on the `issueDate` field. */
  IssueDate = 'ISSUE_DATE',
  /** Indicates sorting on the `isSigned` field. */
  IsSigned = 'IS_SIGNED',
  /** Indicates sorting on the `location` field. */
  Location = 'LOCATION',
  /** Indicates sorting on the `status` field. */
  Status = 'STATUS'
}

export type ContractOwner = {
  /** The contracts connected to the user. */
  contracts?: Maybe<ContractConnection>
}

export type ContractOwnerContractsArgs = {
  updatedAfter?: InputMaybe<Scalars['DateTimeTz']>
}

export type ContractPricing = Documentable &
  Node & {
    __typename?: 'ContractPricing'
    /** The account the contract is for. */
    account?: Maybe<Account>
    /** The basis price of the contract. */
    basisPrice?: Maybe<Scalars['Float']>
    /** The commodity connected to the contract. */
    commodity: Commodity
    /** The deferred payment date. */
    deferDate?: Maybe<Scalars['Date']>
    /** The delivery end date for the contract pricing. */
    deliveryEnd?: Maybe<Scalars['Date']>
    /** The delivery start date for the contract pricing. */
    deliveryStart?: Maybe<Scalars['Date']>
    /** The delivery terms of the contract. **Currently only used by AGRIS** */
    deliveryTerms?: Maybe<Scalars['String']>
    /** Human-readable contract pricing ID. */
    displayId: Scalars['ID']
    /** List of documents attached to the contract. */
    documents: DocumentConnection
    /** The expiration date. */
    expiration?: Maybe<Scalars['Date']>
    /** The third party ID for the pricing. **Currently only used by AGRIS** */
    externalId?: Maybe<Scalars['ID']>
    /** Any fees on the contract. */
    feePrice?: Maybe<Scalars['Float']>
    /** The freight price of the contract. */
    freightPrice?: Maybe<Scalars['Float']>
    /** The futures month connected to the contract. */
    futuresMonth?: Maybe<Scalars['String']>
    /** The futures price of the contract. */
    futuresPrice?: Maybe<Scalars['Float']>
    /** Unique global ID for the contract pricing. */
    id: Scalars['ID']
    /** Indicates whether the contract has been signed. */
    isSigned?: Maybe<Scalars['Boolean']>
    /** The location connected to the contract pricing. */
    location?: Maybe<Location>
    /** The price of the contract. */
    price?: Maybe<Scalars['Float']>
    /** Quantity contracted in bushels. */
    quantity?: Maybe<Scalars['Float']>
    /** The quantity that has already been delivered. */
    quantityDelivered?: Maybe<Scalars['Float']>
    /** The remaining quantity that has not been delivered. */
    quantityRemaining?: Maybe<Scalars['Float']>
    /** The employee who made the sale. **Currently only used by AGRIS** */
    salesPerson?: Maybe<Employee>
    /** Indicates whether the contract is still open or not. */
    status?: Maybe<ContractStatus>
    /** The contract pricing type. */
    type?: Maybe<ContractType>
    /** The units the contract is measured in. */
    unitOfMeasure?: Maybe<UnitOfMeasure>
  }

export type ContractPricingDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

/** A paginated list of ContractPricing edges. */
export type ContractPricingConnection = {
  __typename?: 'ContractPricingConnection'
  /** A list of ContractPricing edges. */
  edges: Array<ContractPricingEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type ContractPricing and a cursor. */
export type ContractPricingEdge = {
  __typename?: 'ContractPricingEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The ContractPricing node. */
  node: ContractPricing
}

/** Contract-specific settings. */
export type ContractSettings = {
  __typename?: 'ContractSettings'
  /** The fields contracts can be filtered on. */
  filterFields: Array<ContractFilterField>
  /**
   * The fields contracts can be sorted on.
   * @deprecated Use `sortFields`.
   */
  orderByFields: Array<ContractOrderByField>
  /** The fields contracts can be sorted on. */
  sortFields: Array<ContractSortField>
}

export type ContractSort = {
  /** Sort on the `account` field. */
  account?: InputMaybe<AccountSort>
  /** Sort on the `commodity` field. */
  commodity?: InputMaybe<CommoditySort>
  /** Sort on the `deliveryEnd` field. */
  deliveryEnd?: InputMaybe<SortOrder>
  /** Sort on the `deliveryStart` field. */
  deliveryStart?: InputMaybe<SortOrder>
  /** Sort on the `displayId` field. */
  displayId?: InputMaybe<SortOrder>
  /** Sort on the `isSigned` field. */
  isSigned?: InputMaybe<SortOrder>
  /** Sort on the `issueDate` field. */
  issueDate?: InputMaybe<SortOrder>
  /** Sort on the `location` field. */
  location?: InputMaybe<LocationSort>
  /** Sort on the `status` field. */
  status?: InputMaybe<SortOrder>
}

export enum ContractSortField {
  /** Indicates sorting on the `account` field. */
  Account = 'ACCOUNT',
  /** Indicates sorting on the `commodity` field. */
  Commodity = 'COMMODITY',
  /** Indicates sorting on the `deliveryEnd` field. */
  DeliveryEnd = 'DELIVERY_END',
  /** Indicates sorting on the `deliveryStart` field. */
  DeliveryStart = 'DELIVERY_START',
  /** Indicates sorting on the `displayId` field. */
  DisplayId = 'DISPLAY_ID',
  /** Indicates sorting on the `issueDate` field. */
  IssueDate = 'ISSUE_DATE',
  /** Indicates sorting on the `isSigned` field. */
  IsSigned = 'IS_SIGNED',
  /** Indicates sorting on the `location` field. */
  Location = 'LOCATION',
  /** Indicates sorting on the `status` field. */
  Status = 'STATUS'
}

export type ContractStats = {
  __typename?: 'ContractStats'
  /** The account the stats apply to. */
  account?: Maybe<Account>
  /** The commodity the stats apply to. */
  commodity?: Maybe<Commodity>
  /** The total number of contracts. */
  count?: Maybe<Scalars['Int']>
  /** The date the stats apply to. */
  date?: Maybe<Scalars['Date']>
  /** The commodity the stats apply to. */
  location?: Maybe<Location>
  /** The total number of bushels contracted. */
  quantity?: Maybe<Scalars['Float']>
  /** The total number of bushels delivered. */
  quantityDelivered?: Maybe<Scalars['Float']>
  /** The contract type the stats apply to. */
  type?: Maybe<ContractType>
}

/** A paginated list of ContractStats edges. */
export type ContractStatsConnection = {
  __typename?: 'ContractStatsConnection'
  /** A list of ContractStats edges. */
  edges: Array<ContractStatsEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type ContractStats and a cursor. */
export type ContractStatsEdge = {
  __typename?: 'ContractStatsEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The ContractStats node. */
  node: ContractStats
}

export type ContractStatsFilter = {
  /** Filter on the `account` field. */
  account?: InputMaybe<AccountFilter>
  /** Group filters with the `and` operator. */
  and?: InputMaybe<Array<InputMaybe<ContractStatsFilter>>>
  /** Filter on the `commodity` field. */
  commodity?: InputMaybe<CommodityFilter>
  /** Filter on the `date` field. */
  date?: InputMaybe<DateFilter>
  /** Filter on the `location` field. */
  location?: InputMaybe<LocationFilter>
  /** Group filters with the `or` operator. */
  or?: InputMaybe<Array<InputMaybe<ContractStatsFilter>>>
  /** Filter on the `type` field. */
  type?: InputMaybe<ContractTypeFilter>
}

export enum ContractStatsGroup {
  /** Indicates grouping stats by account. */
  Account = 'ACCOUNT',
  /** Indicates grouping stats by commodity. */
  Commodity = 'COMMODITY',
  /** Indicates grouping stats by location. */
  Location = 'LOCATION',
  /** Indicates grouping stats by month. */
  Month = 'MONTH',
  /** Indicates grouping stats by contract type. */
  Type = 'TYPE'
}

export type ContractStatsOrderBy = {
  /** Sort on the `count` field. */
  count?: InputMaybe<SortOrder>
  /** Sort on the `date` field. */
  date?: InputMaybe<SortOrder>
  /** Sort on the `quantity` field. */
  quantity?: InputMaybe<SortOrder>
  /** Sort on the `quantityDelivered` field. */
  quantityDelivered?: InputMaybe<SortOrder>
}

export type ContractStatsSort = {
  /** Sort on the `count` field. */
  count?: InputMaybe<SortOrder>
  /** Sort on the `date` field. */
  date?: InputMaybe<SortOrder>
  /** Sort on the `quantity` field. */
  quantity?: InputMaybe<SortOrder>
  /** Sort on the `quantityDelivered` field. */
  quantityDelivered?: InputMaybe<SortOrder>
}

export enum ContractStatus {
  /** Indicates the contract has been completed. */
  Closed = 'CLOSED',
  /** Indicates the contract has not been completed. */
  Open = 'OPEN',
  /** Indicates the contract was settled without delivery of the full quantity. */
  Settled = 'SETTLED',
  /** Indicates the contract was voided before completion. */
  Void = 'VOID'
}

export type ContractStatusFilter = {
  /** Equal to the given `ContractStatus`. */
  eq?: InputMaybe<ContractStatus>
  /** Equal to any of the given `ContractStatus`. */
  in?: InputMaybe<Array<ContractStatus>>
}

export enum ContractTransactionType {
  /** Indicates the quantity in the contract is being purchased. */
  Purchase = 'PURCHASE',
  /** Indicates the quantity in the contract is being sold. */
  Sale = 'SALE'
}

export type ContractType = {
  __typename?: 'ContractType'
  /** The global ID for the contract type. */
  id: Scalars['ID']
  /** The display name for the contract type. */
  name: Scalars['String']
}

/** A paginated list of ContractType edges. */
export type ContractTypeConnection = {
  __typename?: 'ContractTypeConnection'
  /** A list of ContractType edges. */
  edges: Array<ContractTypeEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type ContractType and a cursor. */
export type ContractTypeEdge = {
  __typename?: 'ContractTypeEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The ContractType node. */
  node: ContractType
}

export type ContractTypeFilter = {
  /** Group filters with the `and` operator. */
  and?: InputMaybe<Array<InputMaybe<ContractTypeFilter>>>
  /** Filter on the `id` field. */
  id?: InputMaybe<IdFilter>
  /** Group filters with the `or` operator. */
  or?: InputMaybe<Array<InputMaybe<ContractTypeFilter>>>
}

export type CreateCashBidInput = {
  /** Whether the basis is the actual price of the bid or it should be adjusted using the futures price. */
  actualPrice?: InputMaybe<Scalars['Boolean']>
  /** The basis to add to the futures price. */
  basis?: InputMaybe<Scalars['Float']>
  /** The commodity this bid applies to. */
  commodity: Scalars['ID']
  /** Whether the commodity is priced in hundredweight. */
  cwt?: InputMaybe<Scalars['Boolean']>
  /** The end of the delivery period. */
  deliveryEnd: Scalars['Date']
  /** The start of the delivery period. */
  deliveryStart: Scalars['Date']
  /** The futures symbol the bid is based on. */
  futuresSymbol?: InputMaybe<Scalars['String']>
  /** The futures symbol the bid should hedge on. Will default to the same as `futuresSymbol` if not specified. */
  hedgeSymbol?: InputMaybe<Scalars['String']>
  /** Whether the bid should be viewed publicly or only internally. */
  isPublic?: InputMaybe<Scalars['Boolean']>
  /** The location(s) this bid applies to. */
  location: Scalars['ID']
  /** Additional notes relating to this cash bid. */
  notes?: InputMaybe<Scalars['String']>
  /** The types of offers that can be made on the bid. When none are specified, the bid will fall back to the company's offer types. */
  offerTypes?: InputMaybe<Array<OfferType>>
  /** The fraction of a cent where prices should be rounded up. */
  roundAt?: InputMaybe<Scalars['Float']>
  /** The fraction of a cent where prices should be rounded up. */
  rounding?: InputMaybe<CashBidRounding>
}

export type CreateCommodityInput = {
  /** The ID for the commodity in the company's ERP. */
  accountingId?: InputMaybe<Scalars['String']>
  /** The conversion settings for the commodity. */
  conversion?: InputMaybe<CommodityConversionInput>
  /** The name of the commodity. */
  name: Scalars['String']
  /** Quantity values for the commodity. */
  quantities?: InputMaybe<CommodityQuantityInput>
  /** Custom settings for the commodity. */
  settings?: InputMaybe<Array<CustomSettingInput>>
  /** The order in which the commodity should be displayed. */
  sortOrder?: InputMaybe<Scalars['Int']>
}

export type CreateContractInput = {
  /** The global ID for the account the contract should be assigned to. */
  account: Scalars['ID']
  /** The basis price for the contract. */
  basisPrice?: InputMaybe<Scalars['Float']>
  /** The global ID for the commodity the contract is based on. */
  commodity: Scalars['ID']
  /** The deferred payment date. */
  deferDate?: InputMaybe<Scalars['DateTimeTz']>
  /** The date and time the contract ends on. */
  deliveryEnd?: InputMaybe<Scalars['DateTimeTz']>
  /** The date and time the contract starts on. */
  deliveryStart?: InputMaybe<Scalars['DateTimeTz']>
  /** Free-form text to specify the delivery terms of the contract. */
  deliveryTerms?: InputMaybe<Scalars['String']>
  /** The expiration date for the contract. */
  expiration: Scalars['DateTimeTz']
  /** The third party ID for the contract. */
  externalId?: InputMaybe<Scalars['ID']>
  /** A fee added to the contract. */
  feePrice?: InputMaybe<Scalars['Float']>
  /** The freight price of the contract. */
  freightPrice?: InputMaybe<Scalars['Float']>
  /** The futures price contracted. */
  futuresPrice?: InputMaybe<Scalars['Float']>
  /** The futures symbol used for the contract. */
  futuresSymbol?: InputMaybe<Scalars['String']>
  /** The global ID for the location the contract should be created with. */
  location: Scalars['ID']
  /** Free-form text about the contract. */
  notes?: InputMaybe<Array<ContractNoteInput>>
  /** The price of the contract. */
  price?: InputMaybe<Scalars['Float']>
  /** The number of bushels contracted. */
  quantity: Scalars['Float']
  /** The ID for the employee making the sale. **Currently only used by AGRIS.** */
  salesPerson?: InputMaybe<Scalars['ID']>
  /** Whether the quantity is being purchased or sold. */
  transactionType?: ContractTransactionType
  /** The global ID for the contract type. */
  type: Scalars['String']
}

export type CreateCustomAttributeInput = {
  /** The type of data to attach the custom attribute to. */
  attributableType: AttributableType
  /** A short description for what the custom attribute is for. */
  description?: InputMaybe<Scalars['String']>
  /** The label of the custom attribute. */
  label: Scalars['String']
  /** A unique name for the custom attribute. If not specified, it will be auto-generated based on `label`. Must be unique to the attributable type and consist of URL-safe characters. */
  name?: InputMaybe<Scalars['String']>
  /** Special options for the custom attribute. */
  options?: InputMaybe<CustomAttributeOptionsInput>
  /** The type of custom attribute. */
  type: CustomAttributeType
}

export type CreateCustomerInput = {
  /** List of accounts for the customer. */
  accounts?: InputMaybe<Array<Scalars['ID']>>
  /** The first line of the customer's address. */
  addressOne?: InputMaybe<Scalars['String']>
  /** The third line of the customer's address. */
  addressThree?: InputMaybe<Scalars['String']>
  /** The second line of the customer's address. */
  addressTwo?: InputMaybe<Scalars['String']>
  /** Custom attributes for the customer. */
  attributes?: InputMaybe<Array<CustomAttributeInput>>
  /** The city the customer resides in. */
  city?: InputMaybe<Scalars['String']>
  /** The customer's email address. */
  email?: InputMaybe<Scalars['String']>
  /** The customer's first name. */
  firstName?: InputMaybe<Scalars['String']>
  /** The customer's last name. */
  lastName?: InputMaybe<Scalars['String']>
  /** List of locations for the customer. */
  locations?: InputMaybe<Array<Scalars['ID']>>
  /** The customer's mobile phone number. */
  mobilePhone?: InputMaybe<Scalars['String']>
  /** The customer's status for offer management. */
  offerStatus?: InputMaybe<CustomerOfferStatus>
  /** The state the customer resides in. */
  state?: InputMaybe<Scalars['String']>
  /** The customer's work phone number. */
  workPhone?: InputMaybe<Scalars['String']>
  /** The zip code for the city the customer resides in. */
  zipCode?: InputMaybe<Scalars['String']>
}

export type CreateDocumentInput = {
  /** The unique identifier for the document type. */
  documentType: Scalars['ID']
  /** The unique identifier for the source data the document is related to. */
  documentable?: InputMaybe<Scalars['ID']>
  /** The PDF file of the document. */
  file: Scalars['Upload']
  /** Indicates whether or not the document requires a signature. */
  isSignatureRequired?: Scalars['Boolean']
  /** The unique identifier for the location the document is related to. */
  location?: InputMaybe<Scalars['ID']>
  /** The title fo the document. */
  title: Scalars['String']
  /** The unique identifier for the account the document is related to. */
  user?: InputMaybe<Scalars['ID']>
}

export type CreateLocationInput = {
  /** The unique ID connected to the location within the elevator's accounting provider. */
  accountingId?: InputMaybe<Scalars['ID']>
  /** First line of the address for the location. */
  addressOne?: InputMaybe<Scalars['String']>
  /** Third line of the address for the location. */
  addressThree?: InputMaybe<Scalars['String']>
  /** Second line of the address for the location. */
  addressTwo?: InputMaybe<Scalars['String']>
  /** The city the location is in. */
  city?: InputMaybe<Scalars['String']>
  /** The email address for the location. */
  email?: InputMaybe<Scalars['String']>
  /** Indicates whether the location should be displayed to everyone or just employees. */
  isPublic?: Scalars['Boolean']
  /** The latitude of the location. */
  latitude?: InputMaybe<Scalars['Float']>
  /** The longitude of the location. */
  longitude?: InputMaybe<Scalars['Float']>
  /** The location's name. */
  name: Scalars['String']
  /** The phone number for the location. */
  phoneNumber?: InputMaybe<Scalars['String']>
  /** Custom settings for the location. */
  settings?: InputMaybe<Array<CustomSettingInput>>
  /** The order in which the location should be sorted. If `null`, then sort by `name`. */
  sortOrder?: InputMaybe<Scalars['Int']>
  /** The 2-character abbreviation for the state the location is in. */
  state?: InputMaybe<Scalars['String']>
  /** The type of facility the location is. */
  type?: InputMaybe<Scalars['ID']>
  /** The postal code of the location. */
  zipCode?: InputMaybe<Scalars['String']>
}

export type CreateNoteInput = {
  /** The text content of the note. Can include inline markdown like bold, emphasize, underline, and links. */
  content: Scalars['String']
  /** The global ID of the object to create a note for. */
  notable: Scalars['ID']
}

export type CreateOfferInput = {
  /** The global ID for the account the offer should be assigned to within the elevator's accounting provider. */
  account?: InputMaybe<Scalars['ID']>
  /** The `CashBid` global ID for the specific delivery range the offer is being made for. */
  cashBid: Scalars['ID']
  /** The global ID for the customer making the offer. Ignored/optional if authenticated as a customer. */
  customer?: InputMaybe<Scalars['ID']>
  /** The date at which the offer is no longer valid at. */
  expiration: Scalars['Date']
  /** The global ID for the farmer making the offer. Ignored/optional if authenticated as a farmer. */
  farmer?: InputMaybe<Scalars['ID']>
  /** The order type to hedge the offer with. */
  hedgeOrderType?: HedgeOrderType
  /** Any miscellaneous information about the offer. */
  notes?: InputMaybe<Scalars['String']>
  /** The price the offer is being made at. */
  price?: InputMaybe<Scalars['Float']>
  /** The number of bushels the offer is being made for. */
  quantity: Scalars['Float']
  /** Whether a contract should be created after offer is accepted. */
  shouldCreateContract?: InputMaybe<Scalars['Boolean']>
  /** The status the new offer should be. Employees can set the status to `PENDING` or `ACKNOWLEDGED`. */
  status?: OfferStatus
  /** The type of offer being made. */
  type: OfferType
}

export type CreateSignatureInput = {
  /** A description of the signature request. */
  description?: InputMaybe<Scalars['String']>
  /** The date and time at which, if not signed, the signature request is no longer valid. */
  expiration?: InputMaybe<Scalars['DateTime']>
  /** The PDF file that needs to be signed. */
  file: Scalars['Upload']
  /** The global ID for a signable entity that the signature is being requested for. */
  signable?: InputMaybe<Scalars['ID']>
  /** The global ID of a `User` the signature request is for. */
  user: Scalars['ID']
}

export type CreateSignatureRequestInput = {
  /** The document ID to create the signature request for. */
  document: Scalars['ID']
  /** A date and time at which, if not signed, the signature request is no longer valid. */
  expiresAt?: InputMaybe<Scalars['DateTimeTz']>
  /** Skips the draft process if available. Field locations need to be known. */
  skipDraft?: InputMaybe<Scalars['Boolean']>
}

export type CustomAttribute = {
  __typename?: 'CustomAttribute'
  /** The type of data to attach the custom attribute to. */
  attributableType?: Maybe<AttributableType>
  /** A short description for what the custom attribute is for. */
  description?: Maybe<Scalars['String']>
  /** Unique global-identifier for the custom attribute. */
  id: Scalars['ID']
  /** The label of the custom attribute. */
  label?: Maybe<Scalars['String']>
  /** The unique name for the attribute. */
  name?: Maybe<Scalars['String']>
  /** Special options for the custom attribute. */
  options?: Maybe<CustomAttributeOptions>
  /** The type of custom attribute. */
  type?: Maybe<CustomAttributeType>
}

/** A paginated list of CustomAttribute edges. */
export type CustomAttributeConnection = {
  __typename?: 'CustomAttributeConnection'
  /** A list of CustomAttribute edges. */
  edges: Array<CustomAttributeEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type CustomAttribute and a cursor. */
export type CustomAttributeEdge = {
  __typename?: 'CustomAttributeEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The CustomAttribute node. */
  node: CustomAttribute
}

export type CustomAttributeInput = {
  /** The name of the attribute to create/update. */
  name: Scalars['String']
  /** The value of the attribute. */
  value?: InputMaybe<Scalars['Any']>
}

export type CustomAttributeOptions = {
  __typename?: 'CustomAttributeOptions'
  /** Restricts numbers to an exclusive maximum of the given number. */
  exclusiveMaximum?: Maybe<Scalars['Float']>
  /** Restricts numbers to an exclusive minimum of the given number. */
  exclusiveMinimum?: Maybe<Scalars['Float']>
  /** Restricts a string to a maximum length. */
  maxLength?: Maybe<Scalars['Int']>
  /** Restricts numbers to an inclusive maximum of the given number. */
  maximum?: Maybe<Scalars['Float']>
  /** Restricts a string to a minimum length. */
  minLength?: Maybe<Scalars['Int']>
  /** Restricts numbers to an inclusive minimum of the given number. */
  minimum?: Maybe<Scalars['Float']>
  /** Whether a string needs multiple lines of text. */
  multipleLines?: Maybe<Scalars['Boolean']>
  /** Restricts numbers to a multiple of the given number. */
  multipleOf?: Maybe<Scalars['Float']>
  /** Restricts a string to the given regular expression pattern. */
  pattern?: Maybe<Scalars['String']>
}

export type CustomAttributeOptionsInput = {
  /** Restricts numbers to an exclusive maximum of the given number. */
  exclusiveMaximum?: InputMaybe<Scalars['Float']>
  /** Restricts numbers to an exclusive minimum of the given number. */
  exclusiveMinimum?: InputMaybe<Scalars['Float']>
  /** Restricts a string to a maximum length. */
  maxLength?: InputMaybe<Scalars['Int']>
  /** Restricts numbers to an inclusive maximum of the given number. */
  maximum?: InputMaybe<Scalars['Float']>
  /** Restricts a string to a minimum length. */
  minLength?: InputMaybe<Scalars['Int']>
  /** Restricts numbers to an inclusive minimum of the given number. */
  minimum?: InputMaybe<Scalars['Float']>
  /** Whether a string needs multiple lines of text. */
  multipleLines?: InputMaybe<Scalars['Boolean']>
  /** Restricts numbers to a multiple of the given number. */
  multipleOf?: InputMaybe<Scalars['Float']>
  /** Restricts a string to the given regular expression pattern. */
  pattern?: InputMaybe<Scalars['String']>
}

export enum CustomAttributeType {
  /** Indicates the custom attribute is a boolean value. */
  Boolean = 'BOOLEAN',
  /** Indicates the custom attribute is a date. */
  Date = 'DATE',
  /** Indicates the custom attribute is a date and time. */
  DateTime = 'DATE_TIME',
  /** Indicates the custom attribute is a floating point number. */
  Float = 'FLOAT',
  /** Indicates the custom attribute is an integer. */
  Int = 'INT',
  /** Indicates the custom attribute is text. */
  String = 'STRING'
}

export type CustomAttributeValue = {
  /** The custom attribute. */
  customAttribute?: Maybe<CustomAttribute>
  /** The value normalized as a string. */
  normalizedValue: Scalars['Any']
}

/** A paginated list of CustomAttributeValue edges. */
export type CustomAttributeValueConnection = {
  __typename?: 'CustomAttributeValueConnection'
  /** A list of CustomAttributeValue edges. */
  edges: Array<CustomAttributeValueEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type CustomAttributeValue and a cursor. */
export type CustomAttributeValueEdge = {
  __typename?: 'CustomAttributeValueEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The CustomAttributeValue node. */
  node: CustomAttributeValue
}

export type CustomSetting = {
  __typename?: 'CustomSetting'
  /** The name of the custom setting. */
  name: Scalars['String']
  /** The value of the custom setting. */
  value: Scalars['String']
}

export type CustomSettingInput = {
  /** The name of the setting to create/update. */
  name: Scalars['String']
  /** The value of the setting. To delete a setting, set this as `null`. */
  value?: InputMaybe<Scalars['String']>
}

export type Customer = Attributable &
  Node &
  Notable &
  OfferOwner &
  SignatureOwner &
  User & {
    __typename?: 'Customer'
    /** Accounts the user is connected to. */
    accounts?: Maybe<AccountConnection>
    /** The first line of the customer's address. */
    addressOne?: Maybe<Scalars['String']>
    /** The third line of the customer's address. */
    addressThree?: Maybe<Scalars['String']>
    /** The second line of the customer's address. */
    addressTwo?: Maybe<Scalars['String']>
    /** The customer's required agreements. */
    agreements: UserAgreementConnection
    /** A specific custom attribute. */
    attribute?: Maybe<CustomAttributeValue>
    /** Custom attribute values for the customer. */
    attributes: CustomAttributeValueConnection
    /** The user's avatar. */
    avatar?: Maybe<Scalars['String']>
    /** The balances connected to the user. */
    balances?: Maybe<BalanceConnection>
    /** The balances connected to the user, grouped by the given type. */
    balancesBy?: Maybe<Array<Maybe<BalanceBy>>>
    /** The bookings connected to the user. */
    bookings?: Maybe<BookingConnection>
    /** The user's ID for chat. */
    chatId?: Maybe<Scalars['ID']>
    /** The city the customer resides in. */
    city?: Maybe<Scalars['String']>
    /** The company the user is connected to. */
    company?: Maybe<Company>
    /** Contract stats for the company. */
    contractStats?: Maybe<ContractStatsConnection>
    /** The contracts connected to the user. */
    contracts?: Maybe<ContractConnection>
    /** The documents connected to the user. */
    documents?: Maybe<DocumentConnection>
    /** The email address connected to the user. */
    email?: Maybe<Scalars['String']>
    /** The given name of the user. */
    firstName?: Maybe<Scalars['String']>
    /** The given and family name of the user. */
    fullName?: Maybe<Scalars['String']>
    /** Unique global ID. */
    id: Scalars['ID']
    /** The date and time the customer was last active. */
    lastActiveAt?: Maybe<Scalars['DateTimeTz']>
    /** The family name of the user. */
    lastName?: Maybe<Scalars['String']>
    /** Locations the user is connected to. */
    locationPreferences: CustomerLocationPreferenceConnection
    /**
     * Locations the user is connected to.
     * @deprecated Use `locationPreferences`.
     */
    locations: LocationConnection
    /** The customer's mobile phone number in E.164 format. */
    mobilePhone?: Maybe<Scalars['String']>
    /** Notes made concerning the customer. */
    notes: NoteConnection
    /** The customer's notifications. */
    notifications: NotificationConnection
    /** The current status of whether the user can make offers. */
    offerStatus?: Maybe<CustomerOfferStatus>
    /** The offers made by the user. */
    offers: OfferConnection
    /** The outbound scale tickets connected to the user. */
    outboundScaleTickets?: Maybe<ScaleTicketConnection>
    /** The current presence status of the customer. */
    presence?: Maybe<UserPresence>
    /** The scale tickets connected to the user. */
    scaleTickets?: Maybe<ScaleTicketConnection>
    /** The settlements connected to the user. */
    settlements?: Maybe<SettlementConnection>
    /** The customer's signature requests. */
    signatureRequests: SignatureRequestConnection
    /** The customer's signature requests. */
    signatures: SignatureConnection
    /** The state the customer resides in. */
    state?: Maybe<Scalars['String']>
    /** The customer's zip code. */
    zipCode?: Maybe<Scalars['String']>
  }

export type CustomerAccountsArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
}

export type CustomerAgreementsArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<UserAgreementFilter>
  first?: Scalars['Int']
}

export type CustomerAttributeArgs = {
  name: Scalars['String']
}

export type CustomerAttributesArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

export type CustomerBalancesArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
}

export type CustomerBalancesByArgs = {
  type: BalanceByType
}

export type CustomerBookingsArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<BookingFilter>
  first?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<BookingOrderBy>
  sort?: InputMaybe<Array<InputMaybe<BookingSort>>>
}

export type CustomerContractStatsArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<ContractStatsFilter>
  first?: InputMaybe<Scalars['Int']>
  group?: InputMaybe<Array<InputMaybe<ContractStatsGroup>>>
  orderBy?: InputMaybe<ContractStatsOrderBy>
  sort?: InputMaybe<Array<InputMaybe<ContractStatsSort>>>
}

export type CustomerContractsArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<ContractFilter>
  first?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<ContractOrderBy>
  sort?: InputMaybe<Array<InputMaybe<ContractSort>>>
}

export type CustomerDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
}

export type CustomerLocationPreferencesArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

export type CustomerLocationsArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

export type CustomerNotesArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

export type CustomerNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

export type CustomerOffersArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<OfferFilter>
  first?: Scalars['Int']
  orderBy?: InputMaybe<OfferOrderBy>
  sort?: InputMaybe<Array<InputMaybe<OfferSort>>>
  status?: InputMaybe<Array<InputMaybe<OfferStatus>>>
}

export type CustomerOutboundScaleTicketsArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<ScaleTicketFilter>
  first?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<ScaleTicketOrderBy>
  sort?: InputMaybe<Array<InputMaybe<ScaleTicketSort>>>
}

export type CustomerScaleTicketsArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<ScaleTicketFilter>
  first?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<ScaleTicketOrderBy>
  sort?: InputMaybe<Array<InputMaybe<ScaleTicketSort>>>
}

export type CustomerSettlementsArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<SettlementFilter>
  first?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<SettlementOrderBy>
  sort?: InputMaybe<Array<InputMaybe<SettlementSort>>>
}

export type CustomerSignatureRequestsArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<SignatureRequestFilter>
  first?: Scalars['Int']
  sort?: InputMaybe<Array<InputMaybe<SignatureRequestSort>>>
}

export type CustomerSignaturesArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<SignatureFilter>
  first?: Scalars['Int']
  sort?: InputMaybe<Array<InputMaybe<SignatureSort>>>
  status?: InputMaybe<Array<InputMaybe<SignatureStatus>>>
}

export enum CustomerCashBidStatus {
  /** Indicates the customer's access has been approved. */
  Accepted = 'ACCEPTED',
  /** Indicates the customer's access is currently awaiting action. */
  Pending = 'PENDING',
  /** Indicates the customer's access has been rejected. */
  Rejected = 'REJECTED'
}

/** A paginated list of Customer edges. */
export type CustomerConnection = {
  __typename?: 'CustomerConnection'
  /** A list of Customer edges. */
  edges: Array<CustomerEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type Customer and a cursor. */
export type CustomerEdge = {
  __typename?: 'CustomerEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The Customer node. */
  node: Customer
}

export type CustomerFilter = {
  /** Filter on the `accounts` field. */
  accounts?: InputMaybe<AccountFilter>
  /** Group filters with the `and` operator. */
  and?: InputMaybe<Array<InputMaybe<CustomerFilter>>>
  /** Filter on the `email` field. */
  email?: InputMaybe<StringFilter>
  /** Filter on the `id` field. */
  id?: InputMaybe<IdFilter>
  /** Filter on the `lastActiveAt` field. */
  lastActiveAt?: InputMaybe<DateTimeTzFilter>
  /** Filter on the `mobilePhone` field. */
  mobilePhone?: InputMaybe<StringFilter>
  /** Filter on the `offerStatus` field. */
  offerStatus?: InputMaybe<CustomerOfferStatusFilter>
  /** Group filters with the `or` operator. */
  or?: InputMaybe<Array<InputMaybe<CustomerFilter>>>
  /** Filter on the `presence` field. */
  presence?: InputMaybe<UserPresenceFilter>
}

export type CustomerLocationPreference = {
  __typename?: 'CustomerLocationPreference'
  /** The current cash bid approval status for the location. */
  cashBidStatus?: Maybe<CustomerCashBidStatus>
  /** The location the preference is for. */
  location?: Maybe<Location>
}

/** A paginated list of CustomerLocationPreference edges. */
export type CustomerLocationPreferenceConnection = {
  __typename?: 'CustomerLocationPreferenceConnection'
  /** A list of CustomerLocationPreference edges. */
  edges: Array<CustomerLocationPreferenceEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type CustomerLocationPreference and a cursor. */
export type CustomerLocationPreferenceEdge = {
  __typename?: 'CustomerLocationPreferenceEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The CustomerLocationPreference node. */
  node: CustomerLocationPreference
}

/** The current status of the customer as they relate to the company. */
export enum CustomerOfferStatus {
  /** Indicates the customer can make offers to the company. */
  Accepted = 'ACCEPTED',
  /** Indicates the customer has missing profile information and thus cannot make offers. Direct the user to their account page to update their information. */
  MissingInfo = 'MISSING_INFO',
  /** Indicates the customer has not requested access to make offers. */
  NotRequested = 'NOT_REQUESTED',
  /** Indicates the customer's request to make offers is under review. */
  Pending = 'PENDING',
  /** Indicates the customer cannot make offers to the company. */
  Rejected = 'REJECTED'
}

export type CustomerOfferStatusFilter = {
  /** Equal to the given `CustomerOfferStatus`. */
  eq?: InputMaybe<CustomerOfferStatus>
  /** Equal to any of the given `CustomerOfferStatus`. */
  in?: InputMaybe<Array<CustomerOfferStatus>>
}

export type CustomerOrderBy = {
  /** Sort on the `city` field. */
  city?: InputMaybe<SortOrder>
  /** Sort on the `firstName` field. */
  firstName?: InputMaybe<SortOrder>
  /** Sort on the `lastActiveAt` field. */
  lastActiveAt?: InputMaybe<SortOrder>
  /** Sort on the `lastName` field. */
  lastName?: InputMaybe<SortOrder>
  /** Sort on the `offerStatus` field. */
  offerStatus?: InputMaybe<SortOrder>
  /** Sort on the `presence` field. */
  presence?: InputMaybe<SortOrder>
  /** Sort on the `state` field. */
  state?: InputMaybe<SortOrder>
}

export type CustomerSort = {
  /** Sort on the `city` field. */
  city?: InputMaybe<SortOrder>
  /** Sort on the `firstName` field. */
  firstName?: InputMaybe<SortOrder>
  /** Sort on the `lastActiveAt` field. */
  lastActiveAt?: InputMaybe<SortOrder>
  /** Sort on the `lastName` field. */
  lastName?: InputMaybe<SortOrder>
  /** Sort on the `offerStatus` field. */
  offerStatus?: InputMaybe<SortOrder>
  /** Sort on the `presence` field. */
  presence?: InputMaybe<SortOrder>
  /** Sort on the `state` field. */
  state?: InputMaybe<SortOrder>
}

export type DateAttributeValue = CustomAttributeValue & {
  __typename?: 'DateAttributeValue'
  /** The custom attribute. */
  customAttribute?: Maybe<CustomAttribute>
  /** The value normalized as a string. */
  normalizedValue: Scalars['Any']
  /** The actual value of the attribute. */
  value?: Maybe<Scalars['Date']>
}

export type DateFilter = {
  /** Equal to the given date. */
  eq?: InputMaybe<Scalars['Date']>
  /** Greater than or equal to the given date. */
  ge?: InputMaybe<Scalars['Date']>
  /** Equal to any one of the given dates. */
  in?: InputMaybe<Array<Scalars['Date']>>
  /** Less than or equal to the given date. */
  le?: InputMaybe<Scalars['Date']>
}

export type DateTimeAttributeValue = CustomAttributeValue & {
  __typename?: 'DateTimeAttributeValue'
  /** The custom attribute. */
  customAttribute?: Maybe<CustomAttribute>
  /** The value normalized as a string. */
  normalizedValue: Scalars['Any']
  /** The actual value of the attribute. */
  value?: Maybe<Scalars['DateTimeTz']>
}

export type DateTimeFilter = {
  /** Equal to the given date and time. */
  eq?: InputMaybe<Scalars['DateTime']>
  /** Greater than or equal to the given date and time. */
  ge?: InputMaybe<Scalars['DateTime']>
  /** Equal to any of the given date and times. */
  in?: InputMaybe<Array<Scalars['DateTime']>>
  /** Less than or equal to the given date and time. */
  le?: InputMaybe<Scalars['DateTime']>
}

export type DateTimeTzFilter = {
  /** Equal to the given date and time. */
  eq?: InputMaybe<Scalars['DateTimeTz']>
  /** Greater than or equal to the given date and time. */
  ge?: InputMaybe<Scalars['DateTimeTz']>
  /** Equal to any of the given date and times. */
  in?: InputMaybe<Array<Scalars['DateTimeTz']>>
  /** Less than or equal to the given date and time. */
  le?: InputMaybe<Scalars['DateTimeTz']>
}

export type DeleteCashBidInput = {
  /** The global ID of the cash bid to update. */
  id: Scalars['ID']
}

export type DeleteCommodityInput = {
  /** The global ID of the commodity to delete. */
  id: Scalars['ID']
}

export type DeleteCustomAttributeInput = {
  /** The unique global identifier for the custom attribute to delete. */
  id: Scalars['ID']
}

export type DeleteCustomerInput = {
  /** The global ID of the customer to delete. */
  id: Scalars['ID']
}

export type DeleteLocationInput = {
  /** The global ID of the location to delete. */
  id: Scalars['ID']
}

export type DeleteNoteInput = {
  /** The global ID of the note to delete. */
  id: Scalars['ID']
}

export type DeleteSignatureInput = {
  /** The global ID of the signature request to delete. */
  id: Scalars['ID']
}

export type DeleteSignatureRequestInput = {
  /** The global ID for the signature request to send. */
  id: Scalars['ID']
}

export type DeleteWebhookSubscriptionInput = {
  /** The global ID of the webhook subscription to delete. */
  id: Scalars['ID']
}

/** A unique user device for anonymous requests. */
export type Device = {
  __typename?: 'Device'
  /** A unique global ID for the device. */
  id: Scalars['ID']
  /** The device token to identify anonymous requests with via the `X-Device-Token` header. */
  token?: Maybe<Scalars['String']>
  /** The type of device. */
  type?: Maybe<DeviceType>
}

/** A type of device. */
export enum DeviceType {
  /** Indicates an Android device. */
  Android = 'ANDROID',
  /** Indicates a desktop device. */
  Desktop = 'DESKTOP',
  /** Indicates an iOS device. */
  Ios = 'IOS'
}

export enum DistanceUnit {
  Kilometer = 'KILOMETER',
  Mile = 'MILE'
}

export type DocuSealSignatureRequest = Node &
  SignatureRequest & {
    __typename?: 'DocuSealSignatureRequest'
    /** The account the signature request is for. */
    account?: Maybe<Account>
    /** The URL for the request's audit log after completion. */
    auditLogUrl?: Maybe<Scalars['String']>
    /** The company the signature request is connected to. */
    company?: Maybe<Company>
    /** The date and time the request was completed. */
    completedAt?: Maybe<Scalars['DateTimeTz']>
    /** The date and time the request was created. */
    createdAt?: Maybe<Scalars['DateTimeTz']>
    /** The date and time the request was declined. */
    declinedAt?: Maybe<Scalars['DateTimeTz']>
    /** The document that the signature has been requested for. */
    document?: Maybe<Document>
    /** The URL used to review and submit a signature request draft. */
    draftUrl?: Maybe<Scalars['String']>
    /** Timeline of events for the signature request. */
    events: SignatureRequestEventConnection
    /** The date and time at which the request is no longer signable. */
    expiresAt?: Maybe<Scalars['DateTimeTz']>
    /** Unique global ID for the signature request. */
    id: Scalars['ID']
    /** The date and time the request was sent at. */
    sentAt?: Maybe<Scalars['DateTimeTz']>
    /** The URL used to sign the signature request. */
    signUrl?: Maybe<Scalars['String']>
    /** The current status of the request. */
    status?: Maybe<SignatureRequestStatus>
  }

export type DocuSealSignatureRequestEventsArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

export type DocuSealSignatureRequestSignUrlArgs = {
  redirect?: InputMaybe<Scalars['String']>
}

export type Document = {
  /** The account connected to the document. */
  account?: Maybe<Account>
  /** Indicates whether the document can be signed. */
  canSign?: Maybe<Scalars['Boolean']>
  /** The date and time the document was created. */
  createdAt?: Maybe<Scalars['DateTimeTz']>
  /** The ID to be used for display on the document. */
  displayId?: Maybe<Scalars['ID']>
  /** The data model the document is connected to. */
  documentable?: Maybe<Documentable>
  /** The file name of the document. */
  fileName?: Maybe<Scalars['String']>
  /** The URL to view the document. */
  fileUrl?: Maybe<Scalars['String']>
  /** Unique global ID for the document. */
  id: Scalars['ID']
  /** Indicates whether the document has been signed. */
  isSigned?: Maybe<Scalars['Boolean']>
  /** Indicates whether the document was voided. */
  isVoid?: Maybe<Scalars['Boolean']>
  /** The location connected to the document. */
  location?: Maybe<Location>
  /** The signature request for the document. */
  signatureRequest?: Maybe<SignatureRequest>
  /** The current state of the document's signature. */
  signatureState?: Maybe<DocumentSignatureState>
  /** The user that issued the account. */
  submitter?: Maybe<DocumentSubmitter>
  /** The title of the document. */
  title?: Maybe<Scalars['String']>
  /** The document type. */
  type?: Maybe<DocumentType>
}

export type DocumentFileUrlArgs = {
  ttl?: InputMaybe<Scalars['Int']>
}

/** A paginated list of Document edges. */
export type DocumentConnection = {
  __typename?: 'DocumentConnection'
  /** A list of Document edges. */
  edges: Array<DocumentEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type Document and a cursor. */
export type DocumentEdge = {
  __typename?: 'DocumentEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The Document node. */
  node: Document
}

export type DocumentFilter = {
  /** Filter on the `account` field. */
  account?: InputMaybe<AccountFilter>
  /** Group filters with the `and` operator. */
  and?: InputMaybe<Array<InputMaybe<DocumentFilter>>>
  /** Filter on the `canSign` field. */
  canSign?: InputMaybe<BooleanFilter>
  /** Filter on the `createdAt` field. */
  createdAt?: InputMaybe<DateTimeTzFilter>
  /** Filter on the `displayId` field. */
  displayId?: InputMaybe<IdFilter>
  /** Filter on the `documentable` field. */
  documentable?: InputMaybe<DocumentableFilter>
  /** Filter on the `isSigned` field. */
  isSigned?: InputMaybe<BooleanFilter>
  /** Filter on the `isVoid` field. */
  isVoid?: InputMaybe<BooleanFilter>
  /** Filter on the `location` field. */
  location?: InputMaybe<LocationFilter>
  /** Group filters with the `or` operator. */
  or?: InputMaybe<Array<InputMaybe<DocumentFilter>>>
  /** Filter on the `signatureRequest` field. */
  signatureRequest?: InputMaybe<SignatureRequestFilter>
  /** Filter on the `signatureState` field. */
  signatureState?: InputMaybe<DocumentSignatureStateFilter>
  /** Filter on the `type` field. */
  type?: InputMaybe<DocumentTypeFilter>
}

export type DocumentOrderBy = {
  /** Sort on the `createdAt` field. */
  createdAt?: InputMaybe<SortOrder>
}

export enum DocumentSignatureState {
  /** Indicates document has been declined. */
  Declined = 'DECLINED',
  /** Indicates signature is required but has not been requsted. */
  NotRequested = 'NOT_REQUESTED',
  /** Indicates signature is not required on the document. */
  NotRequired = 'NOT_REQUIRED',
  /** Indicates a signature has been requested. */
  Requested = 'REQUESTED',
  /** Indicates document has been signed. */
  Signed = 'SIGNED',
  /** Indicates the document signature state is not known. */
  Unknown = 'UNKNOWN',
  /** Indicates document has been voided. */
  Voided = 'VOIDED'
}

export type DocumentSignatureStateFilter = {
  /** Equal to the given `DocumentSignatureState`. */
  eq?: InputMaybe<DocumentSignatureState>
  /** Equal to any of the given `DocumentSignatureState`. */
  in?: InputMaybe<Array<DocumentSignatureState>>
}

export type DocumentSort = {
  /** Sort on the `createdAt` field. */
  createdAt?: InputMaybe<SortOrder>
}

export type DocumentSubmitter = Employee | EmployeeAccount

export type DocumentType = {
  __typename?: 'DocumentType'
  /** The ID for the document type in the accounting provider. */
  accountingId?: Maybe<Scalars['ID']>
  /** The category of data the document type is for. */
  category?: Maybe<DocumentTypeCategory>
  /** The unique global identifier for the document type. */
  id: Scalars['ID']
  /** A human-readable name for the document type. */
  name?: Maybe<Scalars['String']>
}

export enum DocumentTypeCategory {
  /** Indicates the document type is for contracts. */
  Contract = 'CONTRACT',
  /** Indicates the document type is for settlements. */
  Settlement = 'SETTLEMENT'
}

/** A paginated list of DocumentType edges. */
export type DocumentTypeConnection = {
  __typename?: 'DocumentTypeConnection'
  /** A list of DocumentType edges. */
  edges: Array<DocumentTypeEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type DocumentType and a cursor. */
export type DocumentTypeEdge = {
  __typename?: 'DocumentTypeEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The DocumentType node. */
  node: DocumentType
}

export type DocumentTypeFilter = {
  /** Filter on the `accountingId` field. */
  accountingId?: InputMaybe<IdFilter>
  /** Group filters with the `and` operator. */
  and?: InputMaybe<Array<InputMaybe<DocumentTypeFilter>>>
  /** Filter on the `id` field. */
  id?: InputMaybe<IdFilter>
  /** Group filters with the `or` operator. */
  or?: InputMaybe<Array<InputMaybe<DocumentTypeFilter>>>
}

export type Documentable = {
  /** The ID for display. */
  displayId?: Maybe<Scalars['ID']>
  /** The list of documents. */
  documents?: Maybe<DocumentConnection>
}

export type DocumentableFilter = {
  /** Group filters with the `and` operator. */
  and?: InputMaybe<Array<InputMaybe<DocumentableFilter>>>
  /** Filter on the `displayId` field. */
  displayId?: InputMaybe<IdFilter>
  /** Group filters with the `or` operator. */
  or?: InputMaybe<Array<InputMaybe<DocumentableFilter>>>
}

export type Elevator = Node & {
  __typename?: 'Elevator'
  /** The accounts connected to the elevator. */
  accounts: Array<Account>
  /**
   * First line of the address for the elevator.
   * @deprecated Use `contact` field.
   */
  addressOne?: Maybe<Scalars['String']>
  /**
   * Third line of the address for the elevator.
   * @deprecated Use `contact` field.
   */
  addressThree?: Maybe<Scalars['String']>
  /**
   * Second line of the address for the elevator.
   * @deprecated Use `contact` field.
   */
  addressTwo?: Maybe<Scalars['String']>
  /** The cash bids data connected to the location. */
  cashBids?: Maybe<Array<Maybe<CashBid>>>
  /**
   * The city the elevator is located in.
   * @deprecated Use `contact` field.
   */
  city?: Maybe<Scalars['String']>
  /**
   * Human-readable identifier for the elevator.
   * @deprecated Use `displayId`.
   */
  clientId?: Maybe<Scalars['ID']>
  /** Commodities connected to the elevator. */
  commodities?: Maybe<Array<Maybe<Commodity>>>
  /** Contact information for the elevator. */
  contact?: Maybe<ElevatorContact>
  /** The types of contracts the elevator accepts. */
  contractTypes: Array<Maybe<ContractType>>
  /** Unique database ID, used for external services. */
  databaseId: Scalars['ID']
  /** Human-readable identifier for the elevator. */
  displayId: Scalars['ID']
  /**
   * Unique elevator number.
   * @deprecated Use `databaseId`.
   */
  elevatorNumber?: Maybe<Scalars['ID']>
  /** The farmers connected to the elevator. */
  farmers: Array<Farmer>
  /** Indicates whether the elevator has any accounting data. */
  hasAccounting?: Maybe<Scalars['Boolean']>
  /** Indicates whether the elevator has accounting balance data. */
  hasBalances?: Maybe<Scalars['Boolean']>
  /** Indicates whether the elevator has accounting contract data. */
  hasContracts?: Maybe<Scalars['Boolean']>
  /** Indicates whether the elevator can accept offers. */
  hasOffers?: Maybe<Scalars['Boolean']>
  /** Indicates whether the elevator has accounting scale ticket data. */
  hasScaleTickets?: Maybe<Scalars['Boolean']>
  /** Indicates whether the elevator has accounting settlement data. */
  hasSettlements?: Maybe<Scalars['Boolean']>
  /** Indicates whether the elevator has eSign capabilities. */
  hasSignatures?: Maybe<Scalars['Boolean']>
  /** Unique global ID for the elevator. */
  id: Scalars['ID']
  /** The latitude of the elevator's location. */
  latitude?: Maybe<Scalars['Float']>
  /** Custom links defined by the elevator. */
  links?: Maybe<Array<Maybe<Link>>>
  /** Locations connected to the elevator. */
  locations?: Maybe<Array<Maybe<Location>>>
  /** URL to the logo for the elevator. */
  logo?: Maybe<Scalars['String']>
  /** The longitude of the elevator's location. */
  longitude?: Maybe<Scalars['Float']>
  /** The elevator name. */
  name?: Maybe<Scalars['String']>
  /** The types of offers the elevator accepts. */
  offerTypes: Array<Maybe<OfferType>>
  /** The offers connected to the elevator. */
  offers: Array<Maybe<Offer>>
  /**
   * The phone number of the elevator.
   * @deprecated Use `contact` field.
   */
  phoneNumber?: Maybe<Scalars['String']>
  /**
   * The state the elevator is located in.
   * @deprecated Use `contact` field.
   */
  state?: Maybe<Scalars['String']>
  /** The website for the elevator. */
  website?: Maybe<Scalars['String']>
  /**
   * The postal code for the elevator's location.
   * @deprecated Use `contact` field.
   */
  zipCode?: Maybe<Scalars['String']>
}

export type ElevatorCashBidsArgs = {
  location?: InputMaybe<Scalars['ID']>
}

export type ElevatorFarmersArgs = {
  status?: InputMaybe<Array<InputMaybe<FarmerOfferStatus>>>
}

export type ElevatorOffersArgs = {
  status?: InputMaybe<Array<InputMaybe<OfferStatus>>>
}

/** Contact information for an elevator. */
export type ElevatorContact = {
  __typename?: 'ElevatorContact'
  /** HTML-formatted additional contact information. */
  additional?: Maybe<Scalars['String']>
  /** First line of the address for the elevator. */
  addressOne?: Maybe<Scalars['String']>
  /** Third line of the address for the elevator. */
  addressThree?: Maybe<Scalars['String']>
  /** Second line of the address for the elevator. */
  addressTwo?: Maybe<Scalars['String']>
  /** The city the elevator is located in. */
  city?: Maybe<Scalars['String']>
  /** The contact email for the elevator. */
  email?: Maybe<Scalars['String']>
  /** The fax number of the elevator. */
  faxNumber?: Maybe<Scalars['String']>
  /** Elevator defined notes. */
  notes?: Maybe<Scalars['String']>
  /** The phone number of the elevator. */
  phoneNumber?: Maybe<Scalars['String']>
  /** The state the elevator is located in. */
  state?: Maybe<Scalars['String']>
  /** The postal code for the elevator's location. */
  zipCode?: Maybe<Scalars['String']>
}

export type Employee = Node &
  User & {
    __typename?: 'Employee'
    /** The employee's accounting ID. */
    accountingId?: Maybe<Scalars['ID']>
    /** The user's avatar. */
    avatar?: Maybe<Scalars['String']>
    /** Checks abilities of the employee. */
    can?: Maybe<Scalars['Boolean']>
    /** The user's ID for chat. */
    chatId?: Maybe<Scalars['ID']>
    /** The company the employee works for. */
    company?: Maybe<Company>
    /** The email address connected to the employee. */
    email?: Maybe<Scalars['String']>
    /** The given and family name of the employee. */
    fullName?: Maybe<Scalars['String']>
    /** Unique global ID. */
    id: Scalars['ID']
    /** The mobile number connected to the employee. */
    mobilePhone?: Maybe<Scalars['String']>
    /** Webhooks subscribed to by the employee. */
    webhookSubscriptions: WebhookSubscriptionConnection
  }

export type EmployeeCanArgs = {
  ability: UserAbility
}

export type EmployeeWebhookSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

export type EmployeeAccount = Node &
  User & {
    __typename?: 'EmployeeAccount'
    /** A human-readable ID for display. */
    displayId: Scalars['ID']
    /** The name to be used for display. */
    displayName?: Maybe<Scalars['String']>
    /** The email address connected to the account. */
    email?: Maybe<Scalars['String']>
    /** The given and family name of the account. */
    fullName?: Maybe<Scalars['String']>
    /** Unique global ID. */
    id: Scalars['ID']
    /** The mobile number connected to the account in E.164 format. */
    mobilePhone?: Maybe<Scalars['String']>
  }

/** A paginated list of Employee edges. */
export type EmployeeConnection = {
  __typename?: 'EmployeeConnection'
  /** A list of Employee edges. */
  edges: Array<EmployeeEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type Employee and a cursor. */
export type EmployeeEdge = {
  __typename?: 'EmployeeEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The Employee node. */
  node: Employee
}

export type Farm = {
  __typename?: 'Farm'
  /** The farm ID to use for display. */
  displayId?: Maybe<Scalars['ID']>
  /** Unique global-identifier for the farm. */
  id: Scalars['ID']
  /** The name of the farm. */
  name?: Maybe<Scalars['String']>
}

/** This type is deprecated. Use `Customer` instead. */
export type Farmer = Node &
  User & {
    __typename?: 'Farmer'
    /**
     * Accounting ID's the user is connected to.
     * @deprecated Use `accounts.displayId`.
     */
    accountIds: Array<Maybe<Scalars['ID']>>
    /** Accounts the user is connected to. */
    accounts: Array<Maybe<Account>>
    /** The balances connected to the user. */
    balances: Array<Maybe<Balance>>
    /** The balances connected to the user, grouped by the given type. */
    balancesBy: Array<Maybe<BalanceBy>>
    /** The contracts connected to the user. */
    contracts: Array<Maybe<Contract>>
    /** The elevator the user is connected to. */
    elevator?: Maybe<Elevator>
    /**
     * The elevators the user is connected to.
     * @deprecated Use `elevator`.
     */
    elevators: Array<Maybe<Elevator>>
    /** The email address connected to the user. */
    email?: Maybe<Scalars['String']>
    /** The given and family name of the user. */
    fullName?: Maybe<Scalars['String']>
    /** Unique global ID. */
    id: Scalars['ID']
    /** The mobile number connected to the user. */
    mobilePhone?: Maybe<Scalars['String']>
    /** The current status of whether the user can make offers. */
    offerStatus?: Maybe<FarmerOfferStatus>
    /** The offers made by the user. */
    offers: Array<Maybe<Offer>>
    /**
     * The mobile number connected to the user.
     * @deprecated Use `mobilePhone`.
     */
    phone?: Maybe<Scalars['String']>
    /** The scale tickets connected to the user. */
    scaleTickets: Array<Maybe<ScaleTicket>>
    /** The settlements connected to the user. */
    settlements: Array<Maybe<Settlement>>
    /** The signature requests made to the user. */
    signatures: Array<Maybe<Signature>>
  }

/** This type is deprecated. Use `Customer` instead. */
export type FarmerBalancesByArgs = {
  type: BalanceByType
}

/** This type is deprecated. Use `Customer` instead. */
export type FarmerContractsArgs = {
  updatedAfter?: InputMaybe<Scalars['DateTimeTz']>
}

/** This type is deprecated. Use `Customer` instead. */
export type FarmerOffersArgs = {
  status?: InputMaybe<Array<InputMaybe<OfferStatus>>>
}

/** The current status of the farmer as they relate to the elevator. */
export enum FarmerOfferStatus {
  /** Indicates the farmer can make offers to the elevator. */
  Accepted = 'ACCEPTED',
  /** Indicates the farmer has missing profile information and thus cannot make offers. Direct the user to their account page to update their information. */
  MissingInfo = 'MISSING_INFO',
  /** Indicates the farmer has not requested access to make offers. */
  NotRequested = 'NOT_REQUESTED',
  /** Indicates the farmer's request to make offers is under review. */
  Pending = 'PENDING',
  /** Indicates the farmer cannot make offers to the elevator. */
  Rejected = 'REJECTED'
}

export type FinalizeSignatureRequestInput = {
  /** The global ID for the signature request to send. */
  id: Scalars['ID']
}

export type FloatAttributeValue = CustomAttributeValue & {
  __typename?: 'FloatAttributeValue'
  /** The custom attribute. */
  customAttribute?: Maybe<CustomAttribute>
  /** The value normalized as a string. */
  normalizedValue: Scalars['Any']
  /** The actual value of the attribute. */
  value?: Maybe<Scalars['Float']>
}

export type FloatFilter = {
  /** Equal to the given float. */
  eq?: InputMaybe<Scalars['Float']>
  /** Greater than or equal to the given float. */
  ge?: InputMaybe<Scalars['Float']>
  /** Equal to any of the given floats. */
  in?: InputMaybe<Array<Scalars['Float']>>
  /** Less than or equal to the given float. */
  le?: InputMaybe<Scalars['Float']>
}

export type GradeFactor = {
  __typename?: 'GradeFactor'
  /** The grade factor discount. */
  discount?: Maybe<Scalars['Float']>
  /** The name of the grade factor. */
  name?: Maybe<Scalars['String']>
  /** The grade factor value. */
  value?: Maybe<Scalars['Float']>
}

/** The order type to hedge an offer on. */
export enum HedgeOrderType {
  /** Indicates an at market order. */
  AtMarket = 'AT_MARKET',
  /** Indicates a limit order. */
  Limit = 'LIMIT'
}

export type HelloSignSignature = Node &
  Signature & {
    __typename?: 'HelloSignSignature'
    /** HelloSign signature request URL for attaching signatures to the document. */
    claimUrl?: Maybe<Scalars['String']>
    /** The elevator the signature is connected to. */
    company?: Maybe<Company>
    /** The time the signature request was initiated. */
    createdAt?: Maybe<Scalars['DateTimeTz']>
    /** The customer the signature was requested for. */
    customer?: Maybe<Customer>
    /** A description of what the signature entails. */
    description?: Maybe<Scalars['String']>
    /** URL to download the signed PDF. */
    downloadUrl?: Maybe<Scalars['String']>
    /**
     * The elevator the signature is connected to.
     * @deprecated Use `company`.
     */
    elevator?: Maybe<Elevator>
    /** The date and time the signature request expires at. */
    expiresAt?: Maybe<Scalars['DateTimeTz']>
    /**
     * The date and time the signature request expires at.
     * @deprecated Use `expiresAt`
     */
    expiresOn?: Maybe<Scalars['Date']>
    /** Unique global ID. */
    id: Scalars['ID']
    /** The date and time the request was sent at. */
    sentAt?: Maybe<Scalars['DateTimeTz']>
    /** HelloSign sign URL. */
    signUrl?: Maybe<Scalars['String']>
    /** The entity the signature was made on. */
    signable?: Maybe<Signable>
    /** The date and time the contract was signed. */
    signedAt?: Maybe<Scalars['DateTimeTz']>
    /** The current status of the signature request. */
    status?: Maybe<SignatureStatus>
    /**
     * The user the signature was (or will be) made by.
     * @deprecated Use `customer`.
     */
    user?: Maybe<User>
  }

export type HelloSignSignatureDownloadUrlArgs = {
  ttl?: InputMaybe<Scalars['Int']>
}

export type HelloSignSignatureSignUrlArgs = {
  hosted?: InputMaybe<Scalars['Boolean']>
}

export type IdFilter = {
  /** Equal to the given ID. */
  eq?: InputMaybe<Scalars['ID']>
  /** Equal to any of the given IDs. */
  in?: InputMaybe<Array<Scalars['ID']>>
  /** Starts with the given ID. Note: this is not usable everywhere at this time. */
  startsWith?: InputMaybe<Scalars['ID']>
}

export type IntAttributeValue = CustomAttributeValue & {
  __typename?: 'IntAttributeValue'
  /** The custom attribute. */
  customAttribute?: Maybe<CustomAttribute>
  /** The value normalized as a string. */
  normalizedValue: Scalars['Any']
  /** The actual value of the attribute. */
  value?: Maybe<Scalars['Int']>
}

export type IntFilter = {
  /** Equal to the given integer. */
  eq?: InputMaybe<Scalars['Int']>
  /** Greater than or equal to the given integer. */
  ge?: InputMaybe<Scalars['Int']>
  /** Equal to any of the given integers. */
  in?: InputMaybe<Array<Scalars['Int']>>
  /** Less than or equal to the given integer. */
  le?: InputMaybe<Scalars['Int']>
}

export type Link = {
  __typename?: 'Link'
  /** The text that should be displayed to the user. */
  label?: Maybe<Scalars['String']>
  /** The URL to send the user to. */
  url?: Maybe<Scalars['String']>
}

export type Location = Node & {
  __typename?: 'Location'
  /** The unique ID connected to the location within the elevator's accounting provider. */
  accountingId?: Maybe<Scalars['ID']>
  /** First line of the address for the location. */
  addressOne?: Maybe<Scalars['String']>
  /** Third line of the address for the location. */
  addressThree?: Maybe<Scalars['String']>
  /** Second line of the address for the location. */
  addressTwo?: Maybe<Scalars['String']>
  /** Indicates the visibility of cash bids for the location. */
  cashBidVisibility?: Maybe<CashBidVisibility>
  /** The city the location is in. */
  city?: Maybe<Scalars['String']>
  /** The commodities that are connected to the location. */
  commodities?: Maybe<Array<Maybe<Commodity>>>
  /** The company the location belongs to. */
  company?: Maybe<Company>
  /** The coordinates of the location. */
  coordinates?: Maybe<Point>
  /** For customers, returns the current approval status for the location's cash bids. */
  customerCashBidStatus?: Maybe<CustomerCashBidStatus>
  /** The distance the location is from the given point. */
  distance?: Maybe<Scalars['Float']>
  /** The email address for the location. */
  email?: Maybe<Scalars['String']>
  /** The fax number for the location. */
  faxNumber?: Maybe<Scalars['String']>
  /** Indicates whether the location has cash bids or not. */
  hasCashBids?: Maybe<Scalars['Boolean']>
  /** The hours the location is open. */
  hours?: Maybe<Scalars['String']>
  /** Unique global ID. */
  id: Scalars['ID']
  /**
   * Indicates whether the location should be displayed to everyone or just employees.
   * @deprecated Use `cashBidVisiblity`.
   */
  isPublic?: Maybe<Scalars['Boolean']>
  /** The latitude of the location. */
  latitude?: Maybe<Scalars['Float']>
  /** The longitude of the location. */
  longitude?: Maybe<Scalars['Float']>
  /** The location's name. */
  name?: Maybe<Scalars['String']>
  /** HTML-formatted, additional information about the location. */
  notes?: Maybe<Scalars['String']>
  /** The phone number for the location. */
  phoneNumber?: Maybe<Scalars['String']>
  /** Retrieve a custom setting for the location. */
  setting?: Maybe<Scalars['String']>
  /** Get all custom settings for the commodity. */
  settings?: Maybe<Array<Maybe<CustomSetting>>>
  /** The order in which the location should be sorted. If `null`, then sort by `name`. */
  sortOrder?: Maybe<Scalars['Int']>
  /** The 2-character abbreviation of the state the location is in. */
  state?: Maybe<Scalars['String']>
  /** The toll-free phone number for the location. */
  tollFreeNumber?: Maybe<Scalars['String']>
  /** The type of location. */
  type?: Maybe<LocationType>
  /** The postal code of the location. */
  zipCode?: Maybe<Scalars['String']>
}

export type LocationDistanceArgs = {
  from: PointInput
  unit?: DistanceUnit
}

export type LocationHoursArgs = {
  format?: InputMaybe<TextFormatType>
}

export type LocationNotesArgs = {
  format?: InputMaybe<TextFormatType>
}

export type LocationSettingArgs = {
  name: Scalars['String']
}

/** A paginated list of Location edges. */
export type LocationConnection = {
  __typename?: 'LocationConnection'
  /** A list of Location edges. */
  edges: Array<LocationEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type Location and a cursor. */
export type LocationEdge = {
  __typename?: 'LocationEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The Location node. */
  node: Location
}

export type LocationFilter = {
  /** Filter on the `accountingId` field. */
  accountingId?: InputMaybe<IdFilter>
  /** Group filters with the `and` operator. */
  and?: InputMaybe<Array<InputMaybe<LocationFilter>>>
  /** Filter on the `coordinates` field. */
  coordinates?: InputMaybe<PointFilter>
  /** Filter on the `id` field. */
  id?: InputMaybe<IdFilter>
  /** Group filters with the `or` operator. */
  or?: InputMaybe<Array<InputMaybe<LocationFilter>>>
}

export type LocationOrderBy = {
  /** Sort on the `company` field. */
  company?: InputMaybe<CompanyOrderBy>
  /** Sort on the `coordinates` field. */
  coordinates?: InputMaybe<PointOrderBy>
  /** Sort on the `name` field. */
  name?: InputMaybe<SortOrder>
  /** Sort on the `sortOrder` field. */
  sortOrder?: InputMaybe<SortOrder>
}

export type LocationSort = {
  /** Sort on the `company` field. */
  company?: InputMaybe<CompanySort>
  /** Sort on the `coordinates` field. */
  coordinates?: InputMaybe<PointSort>
  /** Sort on the `name` field. */
  name?: InputMaybe<SortOrder>
  /** Sort on the `sortOrder` field. */
  sortOrder?: InputMaybe<SortOrder>
}

export type LocationType = {
  __typename?: 'LocationType'
  /** The unique global identifier for the location type. */
  id: Scalars['ID']
  /** The name of the location type. */
  name?: Maybe<Scalars['String']>
}

/** A paginated list of LocationType edges. */
export type LocationTypeConnection = {
  __typename?: 'LocationTypeConnection'
  /** A list of LocationType edges. */
  edges: Array<LocationTypeEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type LocationType and a cursor. */
export type LocationTypeEdge = {
  __typename?: 'LocationTypeEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The LocationType node. */
  node: LocationType
}

export type LogMessage = {
  __typename?: 'LogMessage'
  /** The content of the message. */
  content?: Maybe<Scalars['String']>
  /** The date and time the message was created. */
  createdAt?: Maybe<Scalars['DateTimeTz']>
  /** Unique global ID for the log message. */
  id: Scalars['ID']
  /** The level of message. */
  level: LogMessageLevel
  /** The object this log message pertains to. */
  loggable?: Maybe<Loggable>
  /** The service that logged the message. */
  service?: Maybe<Scalars['String']>
}

/** A paginated list of LogMessage edges. */
export type LogMessageConnection = {
  __typename?: 'LogMessageConnection'
  /** A list of LogMessage edges. */
  edges: Array<LogMessageEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type LogMessage and a cursor. */
export type LogMessageEdge = {
  __typename?: 'LogMessageEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The LogMessage node. */
  node: LogMessage
}

export type LogMessageFilter = {
  /** Group filters with the `and` operator. */
  and?: InputMaybe<Array<InputMaybe<LogMessageFilter>>>
  /** Filter on the `createdAt` field. */
  createdAt?: InputMaybe<DateTimeTzFilter>
  /** Filter on the `level` field. */
  level?: InputMaybe<LogMessageLevelFilter>
  /** Group filters with the `or` operator. */
  or?: InputMaybe<Array<InputMaybe<LogMessageFilter>>>
}

/** Input type for logging messages. */
export type LogMessageInput = {
  /** The content of the log entry. */
  content: Scalars['String']
  /** The level of message. */
  level?: LogMessageLevel
  /** The global ID for a loggable type. */
  loggable?: InputMaybe<Scalars['ID']>
}

/** A type of log message. */
export enum LogMessageLevel {
  /** Indicates a debug log message. */
  Debug = 'DEBUG',
  /** Indicates an error log message. */
  Error = 'ERROR',
  /** Indicates a fatal error log message. */
  Fatal = 'FATAL',
  /** Indicates a general log message. */
  Info = 'INFO',
  /** Indicates a warning log message. */
  Warn = 'WARN'
}

export type LogMessageLevelFilter = {
  /** Equal to the given `LogMessageLevel`. */
  eq?: InputMaybe<LogMessageLevel>
  /** Equal to any of the given `LogMessageLevel`. */
  in?: InputMaybe<Array<LogMessageLevel>>
}

export type LogMessageOrderBy = {
  /** Sort on the `createdAt` field. */
  createdAt?: InputMaybe<SortOrder>
}

export type LogMessageSort = {
  /** Sort on the `createdAt` field. */
  createdAt?: InputMaybe<SortOrder>
}

export type Loggable = {
  id: Scalars['ID']
}

/** Fields to be shown in Marketplace. */
export type MarketplaceField = {
  __typename?: 'MarketplaceField'
  /** An action to take on the field when clicked. */
  action?: Maybe<Scalars['String']>
  /** A JSONata expression that returns a boolean indicating whether to display the field or not. */
  display?: Maybe<Scalars['String']>
  /** A JSONata expression to print the field value. */
  jsonata?: Maybe<Scalars['String']>
  /** A descriptive label for the field. */
  label?: Maybe<Scalars['String']>
  /** A partial GraphQL query in order to form the field. */
  query?: Maybe<Scalars['String']>
  /**
   * The style to apply to the field.
   * @deprecated Use `styles`.
   */
  style?: Maybe<Scalars['String']>
  /** The styles to apply to the field. */
  styles?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type MarketplaceSettings = {
  __typename?: 'MarketplaceSettings'
  appStoreUrl?: Maybe<Scalars['String']>
  fields?: Maybe<Array<Maybe<MarketplaceField>>>
  googlePlayUrl?: Maybe<Scalars['String']>
}

export type MarketplaceSettingsFieldsArgs = {
  view: Scalars['String']
}

/** This type is deprecated. Use `Employee` instead. */
export type Merchandiser = Node &
  User & {
    __typename?: 'Merchandiser'
    /** The elevator the merchandiser is connected to. */
    elevator: Elevator
    /** The email address connected to the merchandiser. */
    email?: Maybe<Scalars['String']>
    /** The given and family name of the merchandiser. */
    fullName?: Maybe<Scalars['String']>
    /** Unique global ID. */
    id: Scalars['ID']
    /** The mobile number connected to the merchandiser. */
    mobilePhone?: Maybe<Scalars['String']>
    /** The offers connected to the merchandiser's elevator. */
    offers: Array<Maybe<Offer>>
    /**
     * The mobile number connected to the merchandiser.
     * @deprecated Use `mobilePhone`.
     */
    phone?: Maybe<Scalars['String']>
    /** The signature requests connected to the elevator. */
    signatures: Array<Maybe<Signature>>
  }

/** This type is deprecated. Use `Employee` instead. */
export type MerchandiserOffersArgs = {
  status?: InputMaybe<Array<InputMaybe<OfferStatus>>>
}

export type Mutation = {
  __typename?: 'Mutation'
  /** Accept a user agreement. */
  acceptAgreement?: Maybe<UserAgreement>
  /** Accepts an offer. Only available to merchandisers. */
  acceptOffer?: Maybe<Offer>
  /** Acknowledges the offer. Only available to merchandisers. */
  acknowledgeOffer?: Maybe<Offer>
  /** Cancels the offer. Only available to customers, employees should use `rejectOffer`. */
  cancelOffer?: Maybe<Offer>
  /** Creates cash bid(s). */
  createCashBids?: Maybe<Array<Maybe<CashBid>>>
  /** Creates a new commodity. */
  createCommodity?: Maybe<Commodity>
  /** Creates a new contract. */
  createContract?: Maybe<Contract>
  /** Creates a new custom attribute. */
  createCustomAttribute?: Maybe<CustomAttribute>
  /** Creates a new customer. */
  createCustomer?: Maybe<Customer>
  /** Creates a document. */
  createDocument?: Maybe<Document>
  /** Creates a new location. */
  createLocation?: Maybe<Location>
  /** Creates a new note on the given object. */
  createNote?: Maybe<Note>
  /** Creates a new offer. */
  createOffer?: Maybe<Offer>
  /** Creates an eSign request. */
  createSignature?: Maybe<Signature>
  /** Creates an eSign request. */
  createSignatureRequest?: Maybe<SignatureRequest>
  /** Delete cash bids. */
  deleteCashBids?: Maybe<Array<Maybe<CashBid>>>
  /** Deletes a commodity. */
  deleteCommodity?: Maybe<Commodity>
  /** Delete a custom attribute. */
  deleteCustomAttribute?: Maybe<CustomAttribute>
  /** Deletes a current customer. */
  deleteCustomer?: Maybe<Customer>
  /** Deletes a location. */
  deleteLocation?: Maybe<Location>
  /** Deletes the given note. */
  deleteNote?: Maybe<Note>
  /** Deletes an eSign request. */
  deleteSignature?: Maybe<Signature>
  /** Delete an eSign request. */
  deleteSignatureRequest?: Maybe<SignatureRequest>
  deleteWebhookSubscription?: Maybe<WebhookSubscription>
  /** Finalized a drafted eSign request. */
  finalizeSignatureRequest?: Maybe<SignatureRequest>
  /** Links ERP accounts to the current customer based on their mobile number. */
  linkAccounts: Array<Account>
  /** Logs a message. */
  logMessage?: Maybe<LogMessage>
  /** Prices the specified quantity on a contract. */
  priceContract?: Maybe<Contract>
  /** The details of the device to register. */
  registerDevice?: Maybe<Device>
  /** Rejects the offer. Only available to employees, customers should use `cancelOffer`. */
  rejectOffer?: Maybe<Offer>
  /** Request cash bid access for the given location. */
  requestCashBidAccess?: Maybe<CustomerLocationPreference>
  /** Sends a request to the elevator to make offers. Only available to customers. */
  requestOfferAccess?: Maybe<Customer>
  /**
   * Send an eSign request.
   * @deprecated Use `finalizeSignatureRequest`.
   */
  sendSignatureRequest?: Maybe<SignatureRequest>
  /** Skips a user agreement. */
  skipAgreement?: Maybe<UserAgreement>
  /** Update a single cash bid. */
  updateCashBid?: Maybe<CashBid>
  /** Batch update multiple cash bids. */
  updateCashBids?: Maybe<Array<Maybe<CashBid>>>
  /** Updates a commodity. */
  updateCommodity?: Maybe<Commodity>
  /** Updates the company. */
  updateCompany?: Maybe<Company>
  /** Updates the details on an existing contract. */
  updateContract?: Maybe<Contract>
  /** Updates a custom attribute. */
  updateCustomAttribute?: Maybe<CustomAttribute>
  /** Updates a current customer. */
  updateCustomer?: Maybe<Customer>
  /** Updates a document. */
  updateDocument?: Maybe<Document>
  /** Updates a location. */
  updateLocation?: Maybe<Location>
  /** Creates a new offer. */
  updateOffer?: Maybe<Offer>
  /** Updates an eSign request. */
  updateSignature?: Maybe<Signature>
  /** Upload cash bids as a CSV file. */
  uploadCashBids?: Maybe<Array<Maybe<CashBid>>>
}

export type MutationAcceptAgreementArgs = {
  input: AcceptAgreementInput
}

export type MutationAcceptOfferArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type MutationAcknowledgeOfferArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type MutationCancelOfferArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type MutationCreateCashBidsArgs = {
  input: Array<CreateCashBidInput>
}

export type MutationCreateCommodityArgs = {
  input: CreateCommodityInput
}

export type MutationCreateContractArgs = {
  input: CreateContractInput
}

export type MutationCreateCustomAttributeArgs = {
  input: CreateCustomAttributeInput
}

export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput
}

export type MutationCreateDocumentArgs = {
  input: CreateDocumentInput
}

export type MutationCreateLocationArgs = {
  input: CreateLocationInput
}

export type MutationCreateNoteArgs = {
  input: CreateNoteInput
}

export type MutationCreateOfferArgs = {
  input: CreateOfferInput
}

export type MutationCreateSignatureArgs = {
  input: CreateSignatureInput
}

export type MutationCreateSignatureRequestArgs = {
  input: CreateSignatureRequestInput
}

export type MutationDeleteCashBidsArgs = {
  input: Array<DeleteCashBidInput>
}

export type MutationDeleteCommodityArgs = {
  input: DeleteCommodityInput
}

export type MutationDeleteCustomAttributeArgs = {
  input: DeleteCustomAttributeInput
}

export type MutationDeleteCustomerArgs = {
  input: DeleteCustomerInput
}

export type MutationDeleteLocationArgs = {
  input: DeleteLocationInput
}

export type MutationDeleteNoteArgs = {
  input: DeleteNoteInput
}

export type MutationDeleteSignatureArgs = {
  input: DeleteSignatureInput
}

export type MutationDeleteSignatureRequestArgs = {
  input: DeleteSignatureRequestInput
}

export type MutationDeleteWebhookSubscriptionArgs = {
  input: DeleteWebhookSubscriptionInput
}

export type MutationFinalizeSignatureRequestArgs = {
  input: FinalizeSignatureRequestInput
}

export type MutationLogMessageArgs = {
  input: LogMessageInput
}

export type MutationPriceContractArgs = {
  input: PriceContractInput
}

export type MutationRegisterDeviceArgs = {
  input: RegisterDeviceInput
}

export type MutationRejectOfferArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type MutationRequestCashBidAccessArgs = {
  input: RequestCashBidAccessInput
}

export type MutationSendSignatureRequestArgs = {
  input: SendSignatureRequestInput
}

export type MutationSkipAgreementArgs = {
  input: SkipAgreementInput
}

export type MutationUpdateCashBidArgs = {
  input: UpdateCashBidInput
}

export type MutationUpdateCashBidsArgs = {
  input: Array<UpdateCashBidInput>
}

export type MutationUpdateCommodityArgs = {
  input: UpdateCommodityInput
}

export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput
}

export type MutationUpdateContractArgs = {
  input: UpdateContractInput
}

export type MutationUpdateCustomAttributeArgs = {
  input: UpdateCustomAttributeInput
}

export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput
}

export type MutationUpdateDocumentArgs = {
  input: UpdateDocumentInput
}

export type MutationUpdateLocationArgs = {
  input: UpdateLocationInput
}

export type MutationUpdateOfferArgs = {
  input: UpdateOfferInput
}

export type MutationUpdateSignatureArgs = {
  input: UpdateSignatureInput
}

export type MutationUploadCashBidsArgs = {
  input: UploadCashBidsInput
}

/** Any object implementing this type can be found by ID through `Query.node`. */
export type Node = {
  /** Global identifier that can be used to resolve any Node implementation. */
  id: Scalars['ID']
}

/** An object that can have notes written to it. */
export type Notable = {
  /** The notes for the object. */
  notes?: Maybe<NoteConnection>
}

export type Note = {
  __typename?: 'Note'
  /** The author of the note. */
  author?: Maybe<User>
  /** The text content of the note. */
  content?: Maybe<Scalars['String']>
  /** The date and time the note was created. */
  createdAt?: Maybe<Scalars['DateTimeTz']>
  /** The unique global ID for the note. */
  id: Scalars['ID']
}

export type NoteContentArgs = {
  format?: NoteFormatType
}

/** A paginated list of Note edges. */
export type NoteConnection = {
  __typename?: 'NoteConnection'
  /** A list of Note edges. */
  edges: Array<NoteEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type Note and a cursor. */
export type NoteEdge = {
  __typename?: 'NoteEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The Note node. */
  node: Note
}

export enum NoteFormatType {
  /** Indicates the note should be returned in HTML. */
  Html = 'HTML',
  /** Indicates the note should be returned in raw markdown format. */
  Markdown = 'MARKDOWN',
  /** Indicates the note should be returned in plain text. */
  PlainText = 'PLAIN_TEXT'
}

/** A notification that was sent to a user or device. */
export type Notification = {
  __typename?: 'Notification'
  /** The content of the notification. */
  body?: Maybe<Scalars['String']>
  /** The unique global ID for the notification. */
  id: Scalars['ID']
  /** The date and time the notification was sent. */
  sentAt?: Maybe<Scalars['DateTimeTz']>
  /** A title describing the notification. */
  title?: Maybe<Scalars['String']>
  /** The type of notification. */
  type?: Maybe<NotificationType>
}

/** A paginated list of Notification edges. */
export type NotificationConnection = {
  __typename?: 'NotificationConnection'
  /** A list of Notification edges. */
  edges: Array<NotificationEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type Notification and a cursor. */
export type NotificationEdge = {
  __typename?: 'NotificationEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The Notification node. */
  node: Notification
}

/** The type of user notification. */
export enum NotificationType {
  /** Indicates a notification about cash bids. */
  CashBids = 'CASH_BIDS',
  /** Indicates a futures price notification. */
  Futures = 'FUTURES',
  /** Indicates a general company notification. */
  General = 'GENERAL',
  /** Indicates a weather update notification. */
  Weather = 'WEATHER'
}

export type Offer = Loggable &
  Node & {
    __typename?: 'Offer'
    /** The account the offer is connected to. */
    account?: Maybe<Account>
    /** The basis price for the offer. */
    basisPrice?: Maybe<Scalars['Float']>
    /**
     * The number of bushels the offer was made for.
     * @deprecated Use `quantity`
     */
    bushels?: Maybe<Scalars['Int']>
    /** Whether the offer can be accepted. */
    canAccept?: Maybe<Scalars['Boolean']>
    /** Whether the offer can be acknowledged. */
    canAcknowledge?: Maybe<Scalars['Boolean']>
    /** Whether the offer can be rejected. */
    canCancel?: Maybe<Scalars['Boolean']>
    /** Whether the offer can be rejected. */
    canReject?: Maybe<Scalars['Boolean']>
    /** The cash bid data for the offer. */
    cashBid?: Maybe<CashBid>
    /** The commodity the offer was made for. */
    commodity?: Maybe<Commodity>
    /** The contract created based on a matched offer. */
    contract?: Maybe<Contract>
    /**
     * The unique identifier of the contract created based on a matched offer.
     * @deprecated Use `contract`.`id`.
     */
    contractId?: Maybe<Scalars['ID']>
    /** Date the offer was created at. */
    createdAt?: Maybe<Scalars['DateTimeTz']>
    /** The customer that made the offer. */
    customer?: Maybe<Customer>
    /** Date at which the commodity should be delivered by. */
    deliveryDate?: Maybe<Scalars['Date']>
    /** Human-readable identifier for the offer. */
    displayId: Scalars['ID']
    /** Date at which the offer is no longer valid. */
    expirationDate?: Maybe<Scalars['Date']>
    /**
     * The farmer that made the offer.
     * @deprecated Use `customer`.
     */
    farmer?: Maybe<Farmer>
    /**
     * The most recent futures price.
     * @deprecated Use `futuresPrice`.
     */
    futurePrice?: Maybe<Scalars['Float']>
    /** The futures price on the offer. */
    futuresPrice?: Maybe<Scalars['Float']>
    /** The futures symbol connected to the offer. */
    futuresSymbol?: Maybe<Scalars['String']>
    /** Whether the offer has matched. */
    hasMatched?: Maybe<Scalars['Boolean']>
    /** The ID of the account in a third party hedging system. */
    hedgeAccountId?: Maybe<Scalars['ID']>
    /** The date and time the hedge was filled at. */
    hedgeFilledAt?: Maybe<Scalars['DateTimeTz']>
    /** The ID in a third party hedging system. */
    hedgeId?: Maybe<Scalars['ID']>
    /** The ID of the account used for hedging in a third party hedging system. */
    hedgeOrderAccountId?: Maybe<Scalars['ID']>
    /** If hedged, the hedge order ID. */
    hedgeOrderId?: Maybe<Scalars['ID']>
    /** The order type to hedge the offer with. */
    hedgeOrderType?: Maybe<HedgeOrderType>
    /**
     * History of changes to the offer.
     * @deprecated Use `updates`.
     */
    history: Array<Maybe<Offer>>
    /** Unique global ID. */
    id: Scalars['ID']
    /** Indicates whether the offer still has a valid cash bid connected to it. Orphaned offers will not match correctly. */
    isOrphaned?: Maybe<Scalars['Boolean']>
    /** The location the offer was made to. */
    location?: Maybe<Location>
    /** Free-form text about the offer. */
    notes: OfferNoteConnection
    /** The price at which the offer was made at. */
    price?: Maybe<Scalars['Float']>
    /** The difference between the target price and the current price. */
    priceDifference?: Maybe<Scalars['Float']>
    /** The number of bushels the offer was made for. */
    quantity?: Maybe<Scalars['Float']>
    /** Whether a contract should be created after offer is accepted. */
    shouldCreateContract?: Maybe<Scalars['Boolean']>
    /** The current offer status. */
    status?: Maybe<OfferStatus>
    /** The user who submitted the offer. Can be a `Customer` or `Employee`. */
    submitter?: Maybe<OfferSubmitter>
    /** The target at which this offer should match at. */
    targetPrice?: Maybe<Scalars['Float']>
    /** The type of offer. */
    type?: Maybe<OfferType>
    /** Date the offer was last updated at. */
    updatedAt?: Maybe<Scalars['DateTimeTz']>
    /** History of updates to the offer. */
    updates: OfferUpdateConnection
    /** Total value of the offer (`price` * `quantity`). */
    value?: Maybe<Scalars['Float']>
  }

export type OfferBasisPriceArgs = {
  format?: CashBidBasisFormat
}

export type OfferNotesArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

export type OfferUpdatesArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

/** A paginated list of Offer edges. */
export type OfferConnection = {
  __typename?: 'OfferConnection'
  /** A list of Offer edges. */
  edges: Array<OfferEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type Offer and a cursor. */
export type OfferEdge = {
  __typename?: 'OfferEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The Offer node. */
  node: Offer
}

export type OfferFilter = {
  /** Filter on the `account` field. */
  account?: InputMaybe<AccountFilter>
  /** Group filters with the `and` operator. */
  and?: InputMaybe<Array<InputMaybe<OfferFilter>>>
  /** Filter on the `commodity` field. */
  commodity?: InputMaybe<CommodityFilter>
  /** Filter on the `createdAt` field. */
  createdAt?: InputMaybe<DateTimeTzFilter>
  /** Filter on the `customer` field. */
  customer?: InputMaybe<CustomerFilter>
  /** Filter on the `deliveryDate` field. */
  deliveryDate?: InputMaybe<DateFilter>
  /** Filter on the `displayId` field. */
  displayId?: InputMaybe<IdFilter>
  /** Filter on the `expirationDate` field. */
  expirationDate?: InputMaybe<DateFilter>
  /** Filter on the `hasMatched` field. */
  hasMatched?: InputMaybe<BooleanFilter>
  /** Filter on the `id` field. */
  id?: InputMaybe<IdFilter>
  /** Filter on the `location` field. */
  location?: InputMaybe<LocationFilter>
  /** Group filters with the `or` operator. */
  or?: InputMaybe<Array<InputMaybe<OfferFilter>>>
  /** Filter on the `status` field. */
  status?: InputMaybe<OfferStatusFilter>
  /** Filter on the `type` field. */
  type?: InputMaybe<OfferTypeFilter>
  /** Filter on the `updatedAt` field. */
  updatedAt?: InputMaybe<DateTimeTzFilter>
}

export type OfferNote = {
  __typename?: 'OfferNote'
  /** The date and time the note was created. */
  createdAt?: Maybe<Scalars['DateTimeTz']>
  /** Unique global ID. */
  id: Scalars['ID']
  /** The user, either `Employee` or `Customer`, that made the note. */
  user?: Maybe<User>
  /** The content of the note. */
  value?: Maybe<Scalars['String']>
}

/** A paginated list of OfferNote edges. */
export type OfferNoteConnection = {
  __typename?: 'OfferNoteConnection'
  /** A list of OfferNote edges. */
  edges: Array<OfferNoteEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type OfferNote and a cursor. */
export type OfferNoteEdge = {
  __typename?: 'OfferNoteEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The OfferNote node. */
  node: OfferNote
}

export type OfferOrderBy = {
  /** Sort on the `commodity` field. */
  commodity?: InputMaybe<CommodityOrderBy>
  /** Sort on the `createdAt` field. */
  createdAt?: InputMaybe<SortOrder>
  /** Sort on the `customer` field. */
  customer?: InputMaybe<CustomerOrderBy>
  /** Sort on the `deliveryDate` field. */
  deliveryDate?: InputMaybe<SortOrder>
  /** Sort on the `expirationDate` field. */
  expirationDate?: InputMaybe<SortOrder>
  /** Sort on the `location` field. */
  location?: InputMaybe<LocationOrderBy>
  /** Sort on the `priceDifference` field. */
  priceDifference?: InputMaybe<SortOrder>
  /** Sort on the `updatedAt` field. */
  updatedAt?: InputMaybe<SortOrder>
}

export type OfferOwner = {
  /** The offers made by the user. */
  offers?: Maybe<OfferConnection>
}

export type OfferOwnerOffersArgs = {
  status?: InputMaybe<Array<InputMaybe<OfferStatus>>>
}

/** Offer-specific settings. */
export type OfferSettings = {
  __typename?: 'OfferSettings'
  /** Indicates whether to notify customers on offer updates. */
  shouldNotifyCustomers?: Maybe<Scalars['Boolean']>
  /** The terms and conditions for making an offer. */
  terms?: Maybe<Scalars['String']>
  /** The offer types enabled for the company. */
  types?: Maybe<Array<OfferTypeSetting>>
}

/** Offer-specific settings. */
export type OfferSettingsTermsArgs = {
  format?: InputMaybe<TextFormatType>
}

export type OfferSettingsInput = {
  /** Whether or not to send to notifications to customers on offer updates. */
  shouldNotifyCustomers?: InputMaybe<Scalars['Boolean']>
  /** The offer types to configure for the company. */
  types?: InputMaybe<Array<OfferTypeSettingInput>>
}

export type OfferSort = {
  /** Sort on the `commodity` field. */
  commodity?: InputMaybe<CommoditySort>
  /** Sort on the `createdAt` field. */
  createdAt?: InputMaybe<SortOrder>
  /** Sort on the `customer` field. */
  customer?: InputMaybe<CustomerSort>
  /** Sort on the `deliveryDate` field. */
  deliveryDate?: InputMaybe<SortOrder>
  /** Sort on the `expirationDate` field. */
  expirationDate?: InputMaybe<SortOrder>
  /** Sort on the `location` field. */
  location?: InputMaybe<LocationSort>
  /** Sort on the `priceDifference` field. */
  priceDifference?: InputMaybe<SortOrder>
  /** Sort on the `updatedAt` field. */
  updatedAt?: InputMaybe<SortOrder>
}

/** The current status of the offer. */
export enum OfferStatus {
  /** Indicates the offer has been accepted by the elevator. */
  Accepted = 'ACCEPTED',
  /** Indicates the offer has been acknowledged by the elevator, but no action has been taken. */
  Acknowledged = 'ACKNOWLEDGED',
  /** Indicates the offer has been canceled by the customer. */
  Canceled = 'CANCELED',
  /** Indicates the offer has expired. */
  Expired = 'EXPIRED',
  /** Indicates the offer has matched its target price. Only used in offer history, use the `hasMatched` field on an Offer to determine whether it has matched. */
  Matched = 'MATCHED',
  /** Indicates the offer has an invalid delivery date. An offer in this state is not guaranteed to match. */
  Orphaned = 'ORPHANED',
  /** Indicates the offer has been created and no action has been taken yet. */
  Pending = 'PENDING',
  /** Indicates the offer has been rejected by the elevator. */
  Rejected = 'REJECTED'
}

export type OfferStatusFilter = {
  /** Equal to the given `OfferStatus`. */
  eq?: InputMaybe<OfferStatus>
  /** Equal to any of the given `OfferStatus`. */
  in?: InputMaybe<Array<OfferStatus>>
}

export type OfferSubmitter = Customer | Employee

/** The type of offer that was made. */
export enum OfferType {
  /** Indicates the offer will match based on the basis price for the commodity. */
  Basis = 'BASIS',
  /** Indicates the offer will match based on the difference of the price and basis for the commodity. */
  Cash = 'CASH',
  /** Indicates the offer will match based on the futures price. */
  Future = 'FUTURE',
  /** Identical to Cash offers except the delivery date will dynamically roll over to the closest date as long as the offer has not expired. */
  Spot = 'SPOT'
}

export type OfferTypeFilter = {
  /** Equal to the given `OfferType`. */
  eq?: InputMaybe<OfferType>
  /** Equal to any of the given `OfferType`. */
  in?: InputMaybe<Array<OfferType>>
}

/** Offer type settings. */
export type OfferTypeSetting = {
  __typename?: 'OfferTypeSetting'
  /** The contract type to assign accepted offers to. */
  contractType?: Maybe<ContractType>
  /** Whether or not this offer type should create a contract (when available) on offer acceptance. */
  shouldCreateContract?: Maybe<Scalars['Boolean']>
  /** The type of offer the settings are for. */
  type: OfferType
}

export type OfferTypeSettingInput = {
  /** The contract ID in the company's ERP to assign when creating contracts. */
  contractType?: InputMaybe<Scalars['ID']>
  /** Whether or not the offer type should create a contract by default. */
  shouldCreateContract?: InputMaybe<Scalars['Boolean']>
  /** The offer type. */
  type: OfferType
}

export type OfferUpdate = {
  __typename?: 'OfferUpdate'
  /** The basis price at the time of the update. */
  basisPrice?: Maybe<Scalars['Float']>
  /** The cash bid data for the offer. */
  cashBid?: Maybe<CashBid>
  /** Date and time the offer update happened at. */
  createdAt?: Maybe<Scalars['DateTimeTz']>
  /** Date at which the commodity should be delivered by. */
  deliveryDate?: Maybe<Scalars['Date']>
  /** Date at which the offer is no longer valid. */
  expirationDate?: Maybe<Scalars['Date']>
  /**
   * The futures price at the time of the update.
   * @deprecated Use `futuresPrice`.
   */
  futurePrice?: Maybe<Scalars['Float']>
  /** The futures price at the time of the update. */
  futuresPrice?: Maybe<Scalars['Float']>
  /** The futures symbol at the time of the update. */
  futuresSymbol?: Maybe<Scalars['String']>
  /** Unique global ID. */
  id: Scalars['ID']
  /** Free-form text about the offer update. */
  notes?: Maybe<Scalars['String']>
  /** The price at which the offer was made at. */
  price?: Maybe<Scalars['Float']>
  /** The number of bushels the offer was made for. */
  quantity?: Maybe<Scalars['Float']>
  /** The current offer status. */
  status?: Maybe<OfferStatus>
  /** The target price at the time of the update. */
  targetPrice?: Maybe<Scalars['Float']>
  /** The user that performed the update. */
  user?: Maybe<User>
  /** Total value of the offer (`price` * `quantity`). */
  value?: Maybe<Scalars['Float']>
}

/** A paginated list of OfferUpdate edges. */
export type OfferUpdateConnection = {
  __typename?: 'OfferUpdateConnection'
  /** A list of OfferUpdate edges. */
  edges: Array<OfferUpdateEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type OfferUpdate and a cursor. */
export type OfferUpdateEdge = {
  __typename?: 'OfferUpdateEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The OfferUpdate node. */
  node: OfferUpdate
}

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']
  /** The direction that is used for ordering. */
  order: SortOrder
}

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

export type Origin = {
  __typename?: 'Origin'
  /** The ID of the origin for display. */
  displayId?: Maybe<Scalars['ID']>
}

/** Information about pagination using a Relay style cursor connection. */
export type PageInfo = {
  __typename?: 'PageInfo'
  /** Number of nodes in the current page. */
  count: Scalars['Int']
  /** Index of the current page. */
  currentPage: Scalars['Int']
  /** The cursor to continue paginating forwards. */
  endCursor?: Maybe<Scalars['String']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']
  /** Index of the last available page. */
  lastPage: Scalars['Int']
  /** The cursor to continue paginating backwards. */
  startCursor?: Maybe<Scalars['String']>
  /** Total number of nodes in the paginated connection. */
  total: Scalars['Int']
}

export type Point = {
  __typename?: 'Point'
  latitude?: Maybe<Scalars['Float']>
  longitude?: Maybe<Scalars['Float']>
}

export type PointFilter = {
  within?: InputMaybe<PointWithinFilter>
}

export type PointInput = {
  latitude?: InputMaybe<Scalars['Float']>
  longitude?: InputMaybe<Scalars['Float']>
}

export type PointOrderBy = {
  direction?: InputMaybe<SortOrder>
  latitude?: InputMaybe<Scalars['Float']>
  longitude?: InputMaybe<Scalars['Float']>
}

export type PointSort = {
  latitude?: InputMaybe<Scalars['Float']>
  longitude?: InputMaybe<Scalars['Float']>
  order?: InputMaybe<SortOrder>
}

export type PointWithinFilter = {
  distance?: InputMaybe<Scalars['Float']>
  from?: InputMaybe<PointInput>
  unit?: InputMaybe<DistanceUnit>
}

export type PriceContractInput = {
  /** The basis price to set. */
  basisPrice?: InputMaybe<Scalars['Float']>
  /** The deferred payment date. */
  deferDate?: InputMaybe<Scalars['DateTimeTz']>
  /** The date and time the pricing ends on. */
  deliveryEnd: Scalars['DateTimeTz']
  /** The date and time the pricing starts on. */
  deliveryStart: Scalars['DateTimeTz']
  /** Free-form text to specify the delivery terms of the contract. */
  deliveryTerms?: InputMaybe<Scalars['String']>
  /** The expiration date for the pricing. */
  expiration: Scalars['DateTimeTz']
  /** The third party ID for the pricing. */
  externalId?: InputMaybe<Scalars['ID']>
  /** A fee added to the contract. */
  feePrice?: InputMaybe<Scalars['Float']>
  /** The freight price of the contract. */
  freightPrice?: InputMaybe<Scalars['Float']>
  /** The futures price to set. */
  futuresPrice?: InputMaybe<Scalars['Float']>
  /** The futures symbol used for the pricing. */
  futuresSymbol: Scalars['String']
  /** The global ID of the contract to price. */
  id: Scalars['ID']
  /** Free-form text about the contract amendment. */
  notes?: InputMaybe<Array<ContractNoteInput>>
  /** The price of the contract. */
  price?: InputMaybe<Scalars['Float']>
  /** The number of bushels to price. */
  quantity: Scalars['Float']
  /** The ID for the employee making the sale. **Currently only used by AGRIS.** */
  salesPerson?: InputMaybe<Scalars['ID']>
  /** The global ID for the contract type to price with. */
  type: Scalars['String']
}

export type Query = {
  __typename?: 'Query'
  cashBids: CashBidConnection
  /** Gets a list of companies. */
  companies: CompanyConnection
  /** Gets a list of elevators which can accept offers. */
  elevators?: Maybe<Array<Maybe<Elevator>>>
  /** Gets a list of locations. */
  locations: LocationConnection
  node?: Maybe<Node>
  search: SearchResultConnection
  /** Retrieves a token to be used with the specified service. */
  serviceToken?: Maybe<ServiceToken>
  /** Gets a list of companies. */
  unitsOfMeasure: UnitOfMeasureConnection
  /** Get the currently authenticated user. */
  viewer?: Maybe<User>
}

export type QueryCashBidsArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<CashBidFilter>
  first?: Scalars['Int']
  orderBy?: InputMaybe<CashBidOrderBy>
  sort?: InputMaybe<Array<InputMaybe<CashBidSort>>>
}

export type QueryCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<CompanyFilter>
  first?: Scalars['Int']
}

export type QueryLocationsArgs = {
  after?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<LocationFilter>
  first?: Scalars['Int']
  sort?: InputMaybe<Array<InputMaybe<LocationSort>>>
}

export type QueryNodeArgs = {
  id: Scalars['ID']
}

export type QuerySearchArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
  query: Scalars['String']
  type: SearchType
}

export type QueryServiceTokenArgs = {
  type?: InputMaybe<ServiceTokenType>
}

export type QueryUnitsOfMeasureArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

/** Price data for a specific instrument. */
export type Quote = {
  __typename?: 'Quote'
  /** The last price the instrument traded at. */
  lastPrice?: Maybe<Scalars['Float']>
  /** The percent difference between the last traded price and the previous close. */
  percentChange?: Maybe<Scalars['Float']>
  /** The difference between the last traded price and the previous close. */
  priceChange?: Maybe<Scalars['Float']>
  /** The symbol that identifies the instrument. */
  symbol?: Maybe<Scalars['String']>
  /** The unit code for the instrument, used for formatting prices. */
  unitCode?: Maybe<Scalars['Int']>
}

/** Registers an anonymous device to make requests and receive push notifications. */
export type RegisterDeviceInput = {
  /** The global ID for the company to register the device to. */
  company?: InputMaybe<Scalars['ID']>
  /** The unique identifier for the device to register. */
  identifier: Scalars['String']
  /** The device token used to send to push notifications. */
  pushToken?: InputMaybe<Scalars['String']>
  /** The type of device to register. */
  type: DeviceType
}

export type RequestCashBidAccessInput = {
  /** The location to request access for. */
  location: Scalars['ID']
}

export type ScaleTicket = Node & {
  __typename?: 'ScaleTicket'
  /** The account the ticket is for. */
  account?: Maybe<Account>
  /**
   * The account ID the ticket is connected to.
   * @deprecated Use `account.displayId`.
   */
  accountId?: Maybe<Scalars['ID']>
  /** An alternate ID for the ticket. */
  alternateId?: Maybe<Scalars['ID']>
  /** The BOL for the ticket. */
  billOfLading?: Maybe<BillOfLading>
  /** A description of the business. */
  businessDescription?: Maybe<Scalars['String']>
  /** The name of the business. */
  businessName?: Maybe<Scalars['String']>
  /** The commodity connected to the ticket. */
  commodity?: Maybe<Commodity>
  /** The company connected to the ticket. */
  company?: Maybe<Company>
  /** The contracts connected to the ticket. */
  contracts: ContractConnection
  /** The date and time the ticket was created. */
  createdAt?: Maybe<Scalars['DateTimeTz']>
  /** The total discounts on the ticket. */
  discounts?: Maybe<Scalars['Float']>
  /** Scale ticket display ID. */
  displayId: Scalars['ID']
  /**
   * The elevator connected to the ticket.
   * @deprecated Use `company`.
   */
  elevator?: Maybe<Elevator>
  /** The farm the grain originated from. */
  farm?: Maybe<Farm>
  /** Grain grade determined during sampling. */
  grade?: Maybe<Scalars['String']>
  /** The grade factors on the ticket. */
  gradeFactors?: Maybe<Array<Maybe<GradeFactor>>>
  /** Gross units on the ticket. */
  grossUnits?: Maybe<Scalars['Float']>
  /** Gross weight on the ticket. */
  grossWeight?: Maybe<Scalars['Float']>
  /** The date and time the gross weight was taken. */
  grossWeightAt?: Maybe<Scalars['DateTimeTz']>
  /** Unique global ID. */
  id: Scalars['ID']
  /** Whether the ticket is part of a split between multiple accounts. */
  isSplit?: Maybe<Scalars['Boolean']>
  /** The load number assigned to the ticket. */
  loadNumber?: Maybe<Scalars['String']>
  /** The location connected to the ticket. */
  location?: Maybe<Location>
  /** Moisture on the ticket. */
  moisture?: Maybe<Scalars['Float']>
  /** Net units on the ticket. */
  netUnits?: Maybe<Scalars['Float']>
  /** Net weight on the ticket. */
  netWeight?: Maybe<Scalars['Float']>
  /** A list of notes pertaining to the ticket. */
  notes?: Maybe<Array<ScaleTicketNote>>
  /** The origin of the grain. */
  origin?: Maybe<Origin>
  /** The cash price of the ticket. */
  price?: Maybe<Scalars['Float']>
  /** The splits on the ticket. */
  splits: ScaleTicketSplitConnection
  /** Tare weight on the ticket. */
  tareWeight?: Maybe<Scalars['Float']>
  /** The date and time the tare weight was taken. */
  tareWeightAt?: Maybe<Scalars['DateTimeTz']>
  /** Test weight on the ticket. */
  testWeight?: Maybe<Scalars['Float']>
  /**
   * Unique elevator ticket ID.
   * @deprecated Use `displayId`.
   */
  ticketNumber?: Maybe<Scalars['ID']>
  /** Indicates whether it's an inbound or outbound ticket. */
  type: ScaleTicketType
  /** The units the ticket is measured in. */
  unitOfMeasure?: Maybe<UnitOfMeasure>
  /** The date and time the ticket was last updated. */
  updatedAt?: Maybe<Scalars['DateTimeTz']>
  /** The vehicle that made the delivery. */
  vehicle?: Maybe<Vehicle>
  /** The name of the weigh master. */
  weighMaster?: Maybe<Scalars['String']>
  /** The weight units the ticket is measured in. */
  weightUnitOfMeasure?: Maybe<UnitOfMeasure>
}

export type ScaleTicketContractsArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

export type ScaleTicketSplitsArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

/** A paginated list of ScaleTicket edges. */
export type ScaleTicketConnection = {
  __typename?: 'ScaleTicketConnection'
  /** A list of ScaleTicket edges. */
  edges: Array<ScaleTicketEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type ScaleTicket and a cursor. */
export type ScaleTicketEdge = {
  __typename?: 'ScaleTicketEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The ScaleTicket node. */
  node: ScaleTicket
}

export type ScaleTicketFilter = {
  /** Filter on the `account` field. */
  account?: InputMaybe<AccountFilter>
  /** Filter on the `commodity` field. */
  commodity?: InputMaybe<CommodityFilter>
  /** Filter on the `contracts` field. */
  contracts?: InputMaybe<ContractFilter>
  /** Filter on the `createdAt` field. */
  createdAt?: InputMaybe<DateTimeTzFilter>
  /** Filter on the `location` field. */
  location?: InputMaybe<LocationFilter>
}

export enum ScaleTicketFilterField {
  /** Indicates filtering on the `account` field. */
  Account = 'ACCOUNT',
  /** Indicates filtering on the `commodity` field. */
  Commodity = 'COMMODITY',
  /** Indicates filtering on the `contracts` field. */
  Contracts = 'CONTRACTS',
  /** Indicates filtering on the `createdAt` field. */
  CreatedAt = 'CREATED_AT',
  /** Indicates filtering on the `location` field. */
  Location = 'LOCATION'
}

export type ScaleTicketNote = {
  __typename?: 'ScaleTicketNote'
  /** The text of the note. */
  value?: Maybe<Scalars['String']>
}

export type ScaleTicketOrderBy = {
  /** Sort on the `account` field. */
  account?: InputMaybe<AccountOrderBy>
  /** Sort on the `commodity` field. */
  commodity?: InputMaybe<CommodityOrderBy>
  /** Sort on the `createdAt` field. */
  createdAt?: InputMaybe<SortOrder>
  /** Sort on the `location` field. */
  location?: InputMaybe<LocationOrderBy>
}

export enum ScaleTicketOrderByField {
  /** Indicates sorting on the `account` field. */
  Account = 'ACCOUNT',
  /** Indicates sorting on the `commodity` field. */
  Commodity = 'COMMODITY',
  /** Indicates sorting on the `createdAt` field. */
  CreatedAt = 'CREATED_AT',
  /** Indicates sorting on the `location` field. */
  Location = 'LOCATION'
}

export type ScaleTicketOwner = {
  /** The scale tickets connected to the user. */
  scaleTickets?: Maybe<ScaleTicketConnection>
}

/** Scale ticket-specific settings. */
export type ScaleTicketSettings = {
  __typename?: 'ScaleTicketSettings'
  /** The fields scale tickets can be filtered on. */
  filterFields: Array<ScaleTicketFilterField>
  /**
   * The fields scale tickets can be sorted on.
   * @deprecated Use `sortFields`.
   */
  orderByFields: Array<ScaleTicketOrderByField>
  /** The fields scale tickets can be sorted on. */
  sortFields: Array<ScaleTicketSortField>
}

export type ScaleTicketSort = {
  /** Sort on the `account` field. */
  account?: InputMaybe<AccountSort>
  /** Sort on the `commodity` field. */
  commodity?: InputMaybe<CommoditySort>
  /** Sort on the `createdAt` field. */
  createdAt?: InputMaybe<SortOrder>
  /** Sort on the `location` field. */
  location?: InputMaybe<LocationSort>
}

export enum ScaleTicketSortField {
  /** Indicates sorting on the `account` field. */
  Account = 'ACCOUNT',
  /** Indicates sorting on the `commodity` field. */
  Commodity = 'COMMODITY',
  /** Indicates sorting on the `createdAt` field. */
  CreatedAt = 'CREATED_AT',
  /** Indicates sorting on the `location` field. */
  Location = 'LOCATION'
}

export type ScaleTicketSplit = Node & {
  __typename?: 'ScaleTicketSplit'
  /** The account the ticket split is for. */
  account?: Maybe<Account>
  /** The date and time the ticket split was created. */
  createdAt?: Maybe<Scalars['DateTimeTz']>
  /** Scale ticket split display ID. */
  displayId: Scalars['ID']
  /** Gross units on the ticket split. */
  grossUnits?: Maybe<Scalars['Float']>
  /** Unique global ID. */
  id: Scalars['ID']
  /** The location connected to the ticket split */
  location?: Maybe<Location>
  /** Net units on the ticket split. */
  netUnits?: Maybe<Scalars['Float']>
  /** The percentage of the ticket that the split contains. */
  percentage?: Maybe<Scalars['Float']>
  /** The primary units the split is measured in. */
  unitOfMeasure?: Maybe<UnitOfMeasure>
  /** The date and time the ticket split was last updated. */
  updatedAt?: Maybe<Scalars['DateTimeTz']>
  /** The weight units the split is measured in. */
  weightUnitOfMeasure?: Maybe<UnitOfMeasure>
}

/** A paginated list of ScaleTicketSplit edges. */
export type ScaleTicketSplitConnection = {
  __typename?: 'ScaleTicketSplitConnection'
  /** A list of ScaleTicketSplit edges. */
  edges: Array<ScaleTicketSplitEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type ScaleTicketSplit and a cursor. */
export type ScaleTicketSplitEdge = {
  __typename?: 'ScaleTicketSplitEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The ScaleTicketSplit node. */
  node: ScaleTicketSplit
}

export enum ScaleTicketType {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type SearchResult = Account | Customer | Employee

/** A paginated list of SearchResult edges. */
export type SearchResultConnection = {
  __typename?: 'SearchResultConnection'
  /** A list of SearchResult edges. */
  edges: Array<SearchResultEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type SearchResult and a cursor. */
export type SearchResultEdge = {
  __typename?: 'SearchResultEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The SearchResult node. */
  node: SearchResult
}

export enum SearchType {
  /** Indicates search on `Account` type. */
  Account = 'ACCOUNT',
  /** Indicates search on `Customer` type. */
  Customer = 'CUSTOMER',
  /** Indicates search on `Employee` type. */
  Employee = 'EMPLOYEE'
}

export type SendSignatureRequestInput = {
  /** The global ID for the signature request to send. */
  id: Scalars['ID']
}

/** A token for another Barchart service. */
export type ServiceToken = {
  __typename?: 'ServiceToken'
  type?: Maybe<ServiceTokenType>
  value?: Maybe<Scalars['String']>
}

/** Types of access tokens for other Barchart services. */
export enum ServiceTokenType {
  /** Indicates a token for the Barchart Alerts service. */
  Alerts = 'ALERTS',
  /** Indicates a token for Barchart Chat. */
  Chat = 'CHAT'
}

/** Custom settings for various entities. */
export type Setting = {
  __typename?: 'Setting'
  /** The setting name. */
  name?: Maybe<Scalars['String']>
  /** The setting value. */
  value?: Maybe<Scalars['String']>
}

export type Settlement = Documentable & {
  __typename?: 'Settlement'
  /** The account the settlement is for. */
  account?: Maybe<Account>
  /**
   * Account connected to the settlement.
   * @deprecated Use `account.displayId`.
   */
  accountId?: Maybe<Scalars['ID']>
  /** The commodity connected to the settlement. */
  commodity?: Maybe<Commodity>
  /** The company connected to the settlement. */
  company?: Maybe<Company>
  /** The date and time the settlement was created. */
  createdAt?: Maybe<Scalars['DateTimeTz']>
  /** Settlement display ID. */
  displayId: Scalars['ID']
  /** List of documents attached to the contract. */
  documents: DocumentConnection
  /**
   * The elevator connected to the settlement.
   * @deprecated Use `company`.
   */
  elevator?: Maybe<Elevator>
  /** Unique settlement ID. */
  id: Scalars['ID']
  /** The line items on the settlement, if available. */
  items: SettlementItemConnection
  /** The settlement's net payment. */
  netPayment?: Maybe<Scalars['Float']>
  /** The settlement's net units. */
  netUnits?: Maybe<Scalars['Float']>
  /** The settled on date. */
  settledDate?: Maybe<Scalars['Date']>
  /**
   * Unique elevator settlement ID.
   * @deprecated Use `displayId`.
   */
  settlementNumber?: Maybe<Scalars['ID']>
  /** The current status of the settlement. */
  status?: Maybe<Scalars['String']>
  /** The units the settlement is measured in. */
  unitOfMeasure?: Maybe<UnitOfMeasure>
  /** The date and time the settlement was last updated. */
  updatedAt?: Maybe<Scalars['DateTimeTz']>
}

export type SettlementDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

export type SettlementItemsArgs = {
  after?: InputMaybe<Scalars['String']>
  first?: Scalars['Int']
}

/** A paginated list of Settlement edges. */
export type SettlementConnection = {
  __typename?: 'SettlementConnection'
  /** A list of Settlement edges. */
  edges: Array<SettlementEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type Settlement and a cursor. */
export type SettlementEdge = {
  __typename?: 'SettlementEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The Settlement node. */
  node: Settlement
}

export type SettlementFilter = {
  /** Filter on the `account` field. */
  account?: InputMaybe<AccountFilter>
  /** Filter on the `commodity` field. */
  commodity?: InputMaybe<CommodityFilter>
  /** Filter on the `createdAt` field. */
  createdAt?: InputMaybe<DateTimeTzFilter>
  /** Filter on the `status` field. */
  status?: InputMaybe<StringFilter>
}

export enum SettlementFilterField {
  /** Indicates filtering on the `account` field. */
  Account = 'ACCOUNT',
  /** Indicates filtering on the `commodity` field. */
  Commodity = 'COMMODITY',
  /** Indicates filtering on the `createdAt` field. */
  CreatedAt = 'CREATED_AT',
  /** Indicates filtering on the `status` field. */
  Status = 'STATUS'
}

export type SettlementItem = {
  __typename?: 'SettlementItem'
  /** The commodity connected to the settlement item. */
  commodity?: Maybe<Commodity>
  /** Settlement item display ID. */
  displayId: Scalars['ID']
  /** Unique settlement item ID. */
  id: Scalars['ID']
  /** The net payment for settlement item. */
  netPayment?: Maybe<Scalars['Float']>
  /** The settlement item's net units. */
  netUnits?: Maybe<Scalars['Float']>
}

/** A paginated list of SettlementItem edges. */
export type SettlementItemConnection = {
  __typename?: 'SettlementItemConnection'
  /** A list of SettlementItem edges. */
  edges: Array<SettlementItemEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type SettlementItem and a cursor. */
export type SettlementItemEdge = {
  __typename?: 'SettlementItemEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The SettlementItem node. */
  node: SettlementItem
}

export type SettlementOrderBy = {
  /** Sort on the `account` field. */
  account?: InputMaybe<AccountOrderBy>
  /** Sort on the `commodity` field. */
  commodity?: InputMaybe<CommodityOrderBy>
  /** Sort on the `createdAt` field. */
  createdAt?: InputMaybe<SortOrder>
}

export enum SettlementOrderByField {
  /** Indicates sorting on the `account` field. */
  Account = 'ACCOUNT',
  /** Indicates sorting on the `commodity` field. */
  Commodity = 'COMMODITY',
  /** Indicates sorting on the `createdAt` field. */
  CreatedAt = 'CREATED_AT'
}

export type SettlementOwner = {
  /** The settlements connected to the user. */
  settlements?: Maybe<SettlementConnection>
}

/** Settlement-specific settings. */
export type SettlementSettings = {
  __typename?: 'SettlementSettings'
  /** The fields settlements can be filtered on. */
  filterFields: Array<SettlementFilterField>
  /**
   * The fields settlements can be sorted on.
   * @deprecated Use `sortFields`.
   */
  orderByFields: Array<SettlementOrderByField>
  /** The fields settlements can be sorted on. */
  sortFields: Array<SettlementSortField>
}

export type SettlementSort = {
  /** Sort on the `account` field. */
  account?: InputMaybe<AccountSort>
  /** Sort on the `commodity` field. */
  commodity?: InputMaybe<CommoditySort>
  /** Sort on the `createdAt` field. */
  createdAt?: InputMaybe<SortOrder>
}

export enum SettlementSortField {
  /** Indicates sorting on the `account` field. */
  Account = 'ACCOUNT',
  /** Indicates sorting on the `commodity` field. */
  Commodity = 'COMMODITY',
  /** Indicates sorting on the `createdAt` field. */
  CreatedAt = 'CREATED_AT'
}

export type Signable = {
  /** The signature connected to the entity. */
  signature?: Maybe<Signature>
}

export type Signature = {
  /** The company the signature is connected to. */
  company?: Maybe<Company>
  /** The time the signature request was initiated. */
  createdAt?: Maybe<Scalars['DateTimeTz']>
  /** The customer the signature was requested for. */
  customer?: Maybe<Customer>
  /** A description of what the signature entails. */
  description?: Maybe<Scalars['String']>
  /** URL to download the signed PDF. */
  downloadUrl?: Maybe<Scalars['String']>
  /**
   * The elevator the signature is connected to.
   * @deprecated Use `company`.
   */
  elevator?: Maybe<Elevator>
  /** The date and time the signature request expires at. */
  expiresAt?: Maybe<Scalars['DateTimeTz']>
  /**
   * The date and time the signature request expires at.
   * @deprecated Use `expiresAt`
   */
  expiresOn?: Maybe<Scalars['Date']>
  /** Unique global ID. */
  id: Scalars['ID']
  /** The date and time the request was sent at. */
  sentAt?: Maybe<Scalars['DateTimeTz']>
  /** The entity the signature was made on. */
  signable?: Maybe<Signable>
  /** The date and time the contract was signed. */
  signedAt?: Maybe<Scalars['DateTimeTz']>
  /** The current status of the signature request. */
  status?: Maybe<SignatureStatus>
  /**
   * The user the signature was (or will be) made by.
   * @deprecated Use `customer`.
   */
  user?: Maybe<User>
}

export type SignatureDownloadUrlArgs = {
  ttl?: InputMaybe<Scalars['Int']>
}

/** A paginated list of Signature edges. */
export type SignatureConnection = {
  __typename?: 'SignatureConnection'
  /** A list of Signature edges. */
  edges: Array<SignatureEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type Signature and a cursor. */
export type SignatureEdge = {
  __typename?: 'SignatureEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The Signature node. */
  node: Signature
}

export type SignatureFilter = {
  /** Group filters with the `and` operator. */
  and?: InputMaybe<Array<InputMaybe<SignatureFilter>>>
  /** Filter on the `createdAt` field. */
  createdAt?: InputMaybe<DateTimeTzFilter>
  /** Filter on the `expiresAt` field. */
  expiresAt?: InputMaybe<DateTimeTzFilter>
  /** Group filters with the `or` operator. */
  or?: InputMaybe<Array<InputMaybe<SignatureFilter>>>
  /** Filter on the `sentAt` field. */
  sentAt?: InputMaybe<DateTimeTzFilter>
  /** Filter on the `signedAt` field. */
  signedAt?: InputMaybe<DateTimeTzFilter>
  /** Filter on the `status` field. */
  status?: InputMaybe<SignatureStatusFilter>
}

export type SignatureOrderBy = {
  /** Sort on the `createdAt` field. */
  createdAt?: InputMaybe<SortOrder>
  /** Sort on the `customer` field. */
  customer?: InputMaybe<CustomerOrderBy>
  /** Sort on the `expiresAt` field. */
  expiresAt?: InputMaybe<SortOrder>
  /** Sort on the `sentAt` field. */
  sentAt?: InputMaybe<SortOrder>
  /** Sort on the `signedAt` field. */
  signedAt?: InputMaybe<SortOrder>
  /** Sort on the `status` field. */
  status?: InputMaybe<SortOrder>
}

export type SignatureOwner = {
  /** The signatures connected to the user. */
  signatures?: Maybe<SignatureConnection>
}

export type SignatureRequest = {
  /** The account the signature request is for. */
  account?: Maybe<Account>
  /** The company the signature request is connected to. */
  company?: Maybe<Company>
  /** The date and time the request was completed. */
  completedAt?: Maybe<Scalars['DateTimeTz']>
  /** The date and time the request was created. */
  createdAt?: Maybe<Scalars['DateTimeTz']>
  /** The date and time the request was declined. */
  declinedAt?: Maybe<Scalars['DateTimeTz']>
  /** The document that the signature has been requested for. */
  document?: Maybe<Document>
  /** Timeline of events for the signature request. */
  events?: Maybe<SignatureRequestEventConnection>
  /** The date and time at which the request is no longer signable. */
  expiresAt?: Maybe<Scalars['DateTimeTz']>
  /** Unique global ID for the signature request. */
  id: Scalars['ID']
  /** The date and time the request was sent at. */
  sentAt?: Maybe<Scalars['DateTimeTz']>
  /** The current status of the request. */
  status?: Maybe<SignatureRequestStatus>
}

/** A paginated list of SignatureRequest edges. */
export type SignatureRequestConnection = {
  __typename?: 'SignatureRequestConnection'
  /** A list of SignatureRequest edges. */
  edges: Array<SignatureRequestEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type SignatureRequest and a cursor. */
export type SignatureRequestEdge = {
  __typename?: 'SignatureRequestEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The SignatureRequest node. */
  node: SignatureRequest
}

export type SignatureRequestEvent = {
  __typename?: 'SignatureRequestEvent'
  /** Unique global identifier for the event. */
  id: Scalars['ID']
  /** A human-readable version of the event. */
  message?: Maybe<Scalars['String']>
  /** Any notes made by the party when the event was triggered. */
  notes?: Maybe<Scalars['String']>
  /** The date and time the event happened at. */
  triggeredAt?: Maybe<Scalars['DateTimeTz']>
  /** The type of event. */
  type?: Maybe<SignatureRequestEventType>
  /** The user who triggered the event. */
  user?: Maybe<User>
}

export type SignatureRequestEventMessageArgs = {
  format?: InputMaybe<TextFormatType>
}

/** A paginated list of SignatureRequestEvent edges. */
export type SignatureRequestEventConnection = {
  __typename?: 'SignatureRequestEventConnection'
  /** A list of SignatureRequestEvent edges. */
  edges: Array<SignatureRequestEventEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type SignatureRequestEvent and a cursor. */
export type SignatureRequestEventEdge = {
  __typename?: 'SignatureRequestEventEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The SignatureRequestEvent node. */
  node: SignatureRequestEvent
}

export enum SignatureRequestEventType {
  /** Indicates the signature request has been completed by all parties. */
  Completed = 'COMPLETED',
  /** Indicates the signature request was created. */
  Created = 'CREATED',
  /** Indicates the signature request was declined by one of the parties. */
  Declined = 'DECLINED',
  /** Indicates the signature request was finalized and ready for review. */
  Finalized = 'FINALIZED',
  /** Indicates the signature request was sent. */
  Sent = 'SENT',
  /** Indicates the signature request was signed by the specified party. */
  Signed = 'SIGNED',
  /** Indicates the signature request was viewed. */
  Viewed = 'VIEWED'
}

export type SignatureRequestFilter = {
  /** Filter on the `account` field. */
  account?: InputMaybe<AccountFilter>
  /** Group filters with the `and` operator. */
  and?: InputMaybe<Array<InputMaybe<SignatureRequestFilter>>>
  /** Filter on the `completedAt` field. */
  completedAt?: InputMaybe<DateTimeTzFilter>
  /** Filter on the `declinedAt` field. */
  declinedAt?: InputMaybe<DateTimeTzFilter>
  /** Filter on the `expiresAt` field. */
  expiresAt?: InputMaybe<DateTimeTzFilter>
  /** Group filters with the `or` operator. */
  or?: InputMaybe<Array<InputMaybe<SignatureRequestFilter>>>
  /** Filter on the `sentAt` field. */
  sentAt?: InputMaybe<DateTimeTzFilter>
  /** Filter on the `status` field. */
  status?: InputMaybe<SignatureRequestStatusFilter>
}

export type SignatureRequestOrderBy = {
  /** Sort on the `completedAt` field. */
  completedAt?: InputMaybe<SortOrder>
  /** Sort on the `createdAt` field. */
  createdAt?: InputMaybe<SortOrder>
  /** Sort on the `declinedAt` field. */
  declinedAt?: InputMaybe<SortOrder>
  /** Sort on the `expiresAt` field. */
  expiresAt?: InputMaybe<SortOrder>
  /** Sort on the `sentAt` field. */
  sentAt?: InputMaybe<SortOrder>
  /** Sort on the `status` field. */
  status?: InputMaybe<SortOrder>
}

export type SignatureRequestSort = {
  /** Sort on the `completedAt` field. */
  completedAt?: InputMaybe<SortOrder>
  /** Sort on the `createdAt` field. */
  createdAt?: InputMaybe<SortOrder>
  /** Sort on the `declinedAt` field. */
  declinedAt?: InputMaybe<SortOrder>
  /** Sort on the `expiresAt` field. */
  expiresAt?: InputMaybe<SortOrder>
  /** Sort on the `sentAt` field. */
  sentAt?: InputMaybe<SortOrder>
  /** Sort on the `status` field. */
  status?: InputMaybe<SortOrder>
}

export enum SignatureRequestStatus {
  /** Indicates the signature request has been signed by all parties. */
  Completed = 'COMPLETED',
  /** Indicates the signature request has been declined by one of the parties. */
  Declined = 'DECLINED',
  /** Indicates the signature request has been created but not sent. */
  Draft = 'DRAFT',
  /** Indicates the signature request has expired and can no longer be signed. */
  Expired = 'EXPIRED',
  /** Indicates the signature request has been sent but not signed by all parties. */
  Pending = 'PENDING',
  /** Indicates the signature request needs to be reviewed and signed by the company. */
  Review = 'REVIEW'
}

export type SignatureRequestStatusFilter = {
  /** Equal to the given `SignatureRequestStatus`. */
  eq?: InputMaybe<SignatureRequestStatus>
  /** Equal to any of the given `SignatureRequestStatus`. */
  in?: InputMaybe<Array<SignatureRequestStatus>>
}

export type SignatureSort = {
  /** Sort on the `createdAt` field. */
  createdAt?: InputMaybe<SortOrder>
  /** Sort on the `customer` field. */
  customer?: InputMaybe<CustomerSort>
  /** Sort on the `expiresAt` field. */
  expiresAt?: InputMaybe<SortOrder>
  /** Sort on the `sentAt` field. */
  sentAt?: InputMaybe<SortOrder>
  /** Sort on the `signedAt` field. */
  signedAt?: InputMaybe<SortOrder>
  /** Sort on the `status` field. */
  status?: InputMaybe<SortOrder>
}

/** The current status of a signature request. */
export enum SignatureStatus {
  /** Indicates the signature request has expired. */
  Expired = 'EXPIRED',
  /** Indicates the signature request is in the process of being sent. */
  Sending = 'SENDING',
  /** Indicates the signature request has been sent but no other action has been taken. */
  Sent = 'SENT',
  /** Indicates the signature request was signed. */
  Signed = 'SIGNED',
  /** Indicates the request was signed but has not been processed yet. */
  Signing = 'SIGNING'
}

export type SignatureStatusFilter = {
  /** Equal to the given `SignatureStatus`. */
  eq?: InputMaybe<SignatureStatus>
  /** Equal to any of the given `SignatureStatus`. */
  in?: InputMaybe<Array<SignatureStatus>>
}

export type SkipAgreementInput = {
  /** The global ID of the agreement to skip. */
  id: Scalars['ID']
}

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export type StringAttributeValue = CustomAttributeValue & {
  __typename?: 'StringAttributeValue'
  /** The custom attribute. */
  customAttribute?: Maybe<CustomAttribute>
  /** The value normalized as a string. */
  normalizedValue: Scalars['Any']
  /** The actual value of the attribute. */
  value?: Maybe<Scalars['String']>
}

export type StringFilter = {
  /** Exact match to given string. */
  eq?: InputMaybe<Scalars['String']>
}

export type Subscription = {
  __typename?: 'Subscription'
  accountCreated?: Maybe<Account>
  accountDeleted?: Maybe<Account>
  accountUpdated?: Maybe<Account>
  balanceCreated?: Maybe<Balance>
  balanceDeleted?: Maybe<Balance>
  balanceUpdated?: Maybe<Balance>
  cashBidsCreated?: Maybe<Array<Maybe<CashBid>>>
  cashBidsDeleted?: Maybe<Array<Maybe<CashBid>>>
  cashBidsUpdated?: Maybe<Array<Maybe<CashBid>>>
  commodityCreated?: Maybe<Commodity>
  commodityDeleted?: Maybe<Commodity>
  commodityUpdated?: Maybe<Commodity>
  contractCreated?: Maybe<Contract>
  contractDeleted?: Maybe<Contract>
  contractUpdated?: Maybe<Contract>
  customerPresenceUpdated?: Maybe<Customer>
  documentCreated?: Maybe<Document>
  documentDeleted?: Maybe<Document>
  documentUpdated?: Maybe<Document>
  locationCreated?: Maybe<Location>
  locationDeleted?: Maybe<Location>
  locationUpdated?: Maybe<Location>
  messageLogged?: Maybe<LogMessage>
  offerCreated?: Maybe<Offer>
  offerUpdated?: Maybe<Offer>
  scaleTicketCreated?: Maybe<ScaleTicket>
  scaleTicketDeleted?: Maybe<ScaleTicket>
  scaleTicketUpdated?: Maybe<ScaleTicket>
  settlementCreated?: Maybe<Settlement>
  settlementDeleted?: Maybe<Settlement>
  settlementUpdated?: Maybe<Settlement>
  signatureRequestCreated?: Maybe<SignatureRequest>
  signatureRequestDeleted?: Maybe<SignatureRequest>
  signatureRequestUpdated?: Maybe<SignatureRequest>
}

export type SubscriptionAccountCreatedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionAccountDeletedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionAccountUpdatedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionBalanceCreatedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionBalanceDeletedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionBalanceUpdatedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionCashBidsCreatedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionCashBidsDeletedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionCashBidsUpdatedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionCommodityCreatedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionCommodityDeletedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionCommodityUpdatedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionContractCreatedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionContractDeletedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionContractUpdatedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionCustomerPresenceUpdatedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionDocumentCreatedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionDocumentDeletedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionDocumentUpdatedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionLocationCreatedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionLocationDeletedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionLocationUpdatedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionOfferCreatedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionOfferUpdatedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionScaleTicketCreatedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionScaleTicketDeletedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionScaleTicketUpdatedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionSettlementCreatedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionSettlementDeletedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export type SubscriptionSettlementUpdatedArgs = {
  callback?: InputMaybe<Scalars['String']>
  secret?: InputMaybe<Scalars['String']>
}

export enum TextFormatType {
  /** Indicates the text should be returned in HTML. */
  Html = 'HTML',
  /** Indicates the text should be returned in markdown. */
  Markdown = 'MARKDOWN',
  /** Indicates the text should be returned in plain text. */
  PlainText = 'PLAIN_TEXT'
}

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type UnitOfMeasure = {
  __typename?: 'UnitOfMeasure'
  /** The abbreviation for the unit of measure. */
  abbreviation?: Maybe<Scalars['String']>
  /** Unique global-identifier for the unit of measure. */
  id: Scalars['ID']
  /** The name of the unit of measure. */
  name?: Maybe<Scalars['String']>
  /** The type of measurement. */
  type?: Maybe<UnitOfMeasureType>
}

/** A paginated list of UnitOfMeasure edges. */
export type UnitOfMeasureConnection = {
  __typename?: 'UnitOfMeasureConnection'
  /** A list of UnitOfMeasure edges. */
  edges: Array<UnitOfMeasureEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type UnitOfMeasure and a cursor. */
export type UnitOfMeasureEdge = {
  __typename?: 'UnitOfMeasureEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The UnitOfMeasure node. */
  node: UnitOfMeasure
}

export enum UnitOfMeasureType {
  /** Indicates a unit that measures mass. */
  Mass = 'MASS',
  /** Indicates a unit that measures volume. */
  Volume = 'VOLUME'
}

export type UpdateCashBidInput = {
  /** Whether the cash bid is active or not. */
  active?: InputMaybe<Scalars['Boolean']>
  /** The basis to add to the futures price. */
  basis?: InputMaybe<Scalars['Float']>
  /** The end of the delivery period. */
  deliveryEnd?: InputMaybe<Scalars['Date']>
  /** The start of the delivery period. */
  deliveryStart?: InputMaybe<Scalars['Date']>
  /** The futures symbol the bid is based on. */
  futuresSymbol?: InputMaybe<Scalars['String']>
  /** The futures symbol the bid should hedge on. */
  hedgeSymbol?: InputMaybe<Scalars['String']>
  /** The global ID of the cash bid to update. */
  id: Scalars['ID']
  /** Whether the bid should be viewed publicly or only internally. */
  isPublic?: InputMaybe<Scalars['Boolean']>
  /** Additional notes relating to this cash bid. */
  notes?: InputMaybe<Scalars['String']>
  /** The types of offers that can be made on the bid. When none are specified, the bid will fall back to the company's offer types. */
  offerTypes?: InputMaybe<Array<OfferType>>
  /** The fraction of a cent where prices should be rounded up. */
  roundAt?: InputMaybe<Scalars['Float']>
}

export type UpdateCommodityInput = {
  /** The ID for the commodity in the company's ERP. */
  accountingId?: InputMaybe<Scalars['String']>
  /** The conversion settings for the commodity. */
  conversion?: InputMaybe<CommodityConversionInput>
  /** The global ID of the commodity to update. */
  id: Scalars['ID']
  /** The name of the commodity. */
  name?: InputMaybe<Scalars['String']>
  /** Quantity values for the commodity. */
  quantities?: InputMaybe<CommodityQuantityInput>
  /** Custom settings for the commodity. */
  settings?: InputMaybe<Array<CustomSettingInput>>
  /** The order in which the commodity should be displayed. */
  sortOrder?: InputMaybe<Scalars['Int']>
}

export type UpdateCompanyInput = {
  /** The settings for the company. */
  settings: CompanySettingsInput
}

export type UpdateContractInput = {
  /** The global ID for the account the contract should be assigned to. */
  account: Scalars['ID']
  /** The basis price for the contract. */
  basisPrice?: InputMaybe<Scalars['Float']>
  /** The global ID for the commodity the contract is based on. */
  commodity: Scalars['ID']
  /** The deferred payment date. */
  deferDate?: InputMaybe<Scalars['DateTimeTz']>
  /** The date and time the contract ends on. */
  deliveryEnd?: InputMaybe<Scalars['DateTimeTz']>
  /** The date and time the contract starts on. */
  deliveryStart?: InputMaybe<Scalars['DateTimeTz']>
  /** Free-form text to specify the delivery terms of the contract. */
  deliveryTerms?: InputMaybe<Scalars['String']>
  /** The expiration date for the contract. */
  expiration: Scalars['DateTimeTz']
  /** The third party ID for the contract. */
  externalId?: InputMaybe<Scalars['ID']>
  /** A fee added to the contract. */
  feePrice?: InputMaybe<Scalars['Float']>
  /** The freight price of the contract. */
  freightPrice?: InputMaybe<Scalars['Float']>
  /** The futures price contracted. */
  futuresPrice?: InputMaybe<Scalars['Float']>
  /** The futures symbol used for the contract. */
  futuresSymbol: Scalars['String']
  /** The global ID of the contract to update. */
  id: Scalars['ID']
  /** The global ID for the location the contract should be created with. */
  location: Scalars['ID']
  /** Free-form text about the contract. */
  notes?: InputMaybe<Array<ContractNoteInput>>
  /** The price of the contract. */
  price?: InputMaybe<Scalars['Float']>
  /** The number of bushels contracted. */
  quantity: Scalars['Float']
  /** The ID for the employee making the sale. **Currently only used by AGRIS.** */
  salesPerson?: InputMaybe<Scalars['ID']>
  /** The global ID for the contract type. */
  type: Scalars['String']
}

export type UpdateCustomAttributeInput = {
  /** A short description for what the custom attribute is for. */
  description?: InputMaybe<Scalars['String']>
  /** The unique global identifier for the custom attribute to update. */
  id: Scalars['ID']
  /** The label of the custom attribute. */
  label?: InputMaybe<Scalars['String']>
  /** Special options for the custom attribute. */
  options?: InputMaybe<CustomAttributeOptionsInput>
}

export type UpdateCustomerInput = {
  /** List of accounts for the customer. */
  accounts?: InputMaybe<Array<Scalars['ID']>>
  /** The first line of the customer's address. */
  addressOne?: InputMaybe<Scalars['String']>
  /** The third line of the customer's address. */
  addressThree?: InputMaybe<Scalars['String']>
  /** The second line of the customer's address. */
  addressTwo?: InputMaybe<Scalars['String']>
  /** Custom attributes for the customer. */
  attributes?: InputMaybe<Array<CustomAttributeInput>>
  /** The city the customer resides in. */
  city?: InputMaybe<Scalars['String']>
  /** The customer's email address. */
  email?: InputMaybe<Scalars['String']>
  /** The customer's first name. */
  firstName?: InputMaybe<Scalars['String']>
  /** The global ID of the customer to update. */
  id: Scalars['ID']
  /** The customer's last name. */
  lastName?: InputMaybe<Scalars['String']>
  /** List of locations for the customer. */
  locations?: InputMaybe<Array<Scalars['ID']>>
  /** The customer's mobile phone number. */
  mobilePhone?: InputMaybe<Scalars['String']>
  /** The customer's status for offer management. */
  offerStatus?: InputMaybe<CustomerOfferStatus>
  /** The state the customer resides in. */
  state?: InputMaybe<Scalars['String']>
  /** The customer's work phone number. */
  workPhone?: InputMaybe<Scalars['String']>
  /** The zip code for the city the customer resides in. */
  zipCode?: InputMaybe<Scalars['String']>
}

export type UpdateDocumentInput = {
  /** The unique global identifier for the document. */
  id: Scalars['ID']
  /** Whether or not the document is signed. */
  isSigned?: InputMaybe<Scalars['Boolean']>
  /** Whether or not the document is void. */
  isVoid?: InputMaybe<Scalars['Boolean']>
}

export type UpdateLocationInput = {
  /** The unique ID connected to the location within the elevator's accounting provider. */
  accountingId?: InputMaybe<Scalars['ID']>
  /** First line of the address for the location. */
  addressOne?: InputMaybe<Scalars['String']>
  /** Third line of the address for the location. */
  addressThree?: InputMaybe<Scalars['String']>
  /** Second line of the address for the location. */
  addressTwo?: InputMaybe<Scalars['String']>
  /** The city the location is in. */
  city?: InputMaybe<Scalars['String']>
  /** The email address for the location. */
  email?: InputMaybe<Scalars['String']>
  /** The global unique identifier for the location to update. */
  id: Scalars['ID']
  /** Indicates whether the location should be displayed to everyone or just employees. */
  isPublic?: Scalars['Boolean']
  /** The latitude of the location. */
  latitude?: InputMaybe<Scalars['Float']>
  /** The longitude of the location. */
  longitude?: InputMaybe<Scalars['Float']>
  /** The location's name. */
  name?: InputMaybe<Scalars['String']>
  /** The phone number for the location. */
  phoneNumber?: InputMaybe<Scalars['String']>
  /** Custom settings for the location. */
  settings?: InputMaybe<Array<CustomSettingInput>>
  /** The order in which the location should be sorted. If `null`, then sort by `name`. */
  sortOrder?: InputMaybe<Scalars['Int']>
  /** The 2-character abbreviation for the state the location is in. */
  state?: InputMaybe<Scalars['String']>
  /** The type of facility the location is. */
  type?: InputMaybe<Scalars['ID']>
  /** The postal code of the location. */
  zipCode?: InputMaybe<Scalars['String']>
}

export type UpdateOfferInput = {
  /** The global ID for the account the offer should be assigned to within the elevator's accounting provider. */
  account?: InputMaybe<Scalars['ID']>
  /** The `CashBid` global ID for the specific delivery range the offer is being made for. Must be for the same commodity and location as the original offer. */
  cashBid?: InputMaybe<Scalars['ID']>
  /** The date at which the offer is no longer valid at. */
  expiration?: InputMaybe<Scalars['Date']>
  /** Indicates whether the offer has matched. */
  hasMatched?: InputMaybe<Scalars['Boolean']>
  /** The ID of the account in a third party hedging system. */
  hedgeAccountId?: InputMaybe<Scalars['ID']>
  /** The date and time the hedge was filled at. */
  hedgeFilledAt?: InputMaybe<Scalars['DateTimeTz']>
  /** The associated offer ID in a third party hedging system. */
  hedgeId?: InputMaybe<Scalars['ID']>
  /** The ID of the account in a third party hedging system. */
  hedgeOrderAccountId?: InputMaybe<Scalars['ID']>
  /** If hedged, the ID of the hedge order. */
  hedgeOrderId?: InputMaybe<Scalars['ID']>
  /** The global ID of the offer to update. */
  id: Scalars['ID']
  /** Any miscellaneous information about the offer. */
  notes?: InputMaybe<Scalars['String']>
  /** The price the offer is being made at. */
  price?: InputMaybe<Scalars['Float']>
  /** The number of bushels the offer is being made for. */
  quantity?: InputMaybe<Scalars['Float']>
  /** Whether a contract should be created after offer is accepted. */
  shouldCreateContract?: InputMaybe<Scalars['Boolean']>
  /** The status to update the offer to. */
  status?: InputMaybe<OfferStatus>
}

export type UpdateSignatureInput = {
  /** The global ID of the signature request to update. */
  id: Scalars['ID']
  /** The desired status to update the request to. Can only update from SENT => SIGNING. */
  status: SignatureStatus
}

export type UploadCashBidsHeaderInput = {
  /** The field name for the basis price. */
  basisPrice?: Scalars['String']
  /** The field name for the commodity. */
  commodity?: Scalars['String']
  /** The field name for whether or not the commodity is priced in hundredweight. */
  cwt?: Scalars['String']
  /** The field name for the end of the delivery period. */
  deliveryEnd?: Scalars['String']
  /** The field name for the start of the delivery period. */
  deliveryStart?: Scalars['String']
  /** The field name for the futures symbol. */
  futuresSymbol?: Scalars['String']
  /** The field name for the hedge symbol. */
  hedgeSymbol?: Scalars['String']
  /** The field name for whether not the bid is public or not. */
  isPublic?: Scalars['String']
  /** The field name for the location. */
  location?: Scalars['String']
  /** Additional notes relating to this cash bid. */
  notes?: Scalars['String']
  /** The field name for the type of rounding. */
  roundAt?: Scalars['String']
}

export type UploadCashBidsInput = {
  /** Whether the basis is the actual price of the bids or it should be adjusted using the futures price.  */
  actualPrice?: Scalars['Boolean']
  /** Whether to actually update the bids or just show errors/warnings. */
  dryRun?: Scalars['Boolean']
  /** The CSV file to upload. */
  file: Scalars['Upload']
  /** The header names defined on the first line of the file. */
  header?: UploadCashBidsHeaderInput
  /** The field separator in the file. */
  separator?: Scalars['String']
}

export type UploadedDocument = Document &
  Node & {
    __typename?: 'UploadedDocument'
    /** The account connected to the document. */
    account?: Maybe<Account>
    /** Indicates whether the document can be signed. */
    canSign?: Maybe<Scalars['Boolean']>
    /** The file contents of the document. */
    content?: Maybe<Scalars['String']>
    /** The date and time the document was created. */
    createdAt?: Maybe<Scalars['DateTimeTz']>
    /** The ID to be used for display on the document. */
    displayId?: Maybe<Scalars['ID']>
    /** The data model the document is connected to. */
    documentable?: Maybe<Documentable>
    /** The file name of the document. */
    fileName?: Maybe<Scalars['String']>
    /** The URL to view the document. */
    fileUrl?: Maybe<Scalars['String']>
    /** Unique global ID for the document. */
    id: Scalars['ID']
    /** Indicates whether the document has been signed. */
    isSigned?: Maybe<Scalars['Boolean']>
    /** Indicates whether the document was voided. */
    isVoid?: Maybe<Scalars['Boolean']>
    /** The location connected to the document. */
    location?: Maybe<Location>
    /** The signature request for the document. */
    signatureRequest?: Maybe<SignatureRequest>
    /** The current state of the document's signature. */
    signatureState?: Maybe<DocumentSignatureState>
    /** The user that issued the account. */
    submitter?: Maybe<DocumentSubmitter>
    /** The title of the document. */
    title?: Maybe<Scalars['String']>
    /** The document type. */
    type?: Maybe<DocumentType>
  }

export type UploadedDocumentFileUrlArgs = {
  ttl?: InputMaybe<Scalars['Int']>
}

/** A user within the system, either an employee or customer. */
export type User = {
  /** The email address connected to the user. */
  email?: Maybe<Scalars['String']>
  /** The given and family name of the user. */
  fullName?: Maybe<Scalars['String']>
  /** Unique global ID. */
  id: Scalars['ID']
  /** The mobile number connected to the user in E.164 format. */
  mobilePhone?: Maybe<Scalars['String']>
}

export enum UserAbility {
  /** Indicates the user can create cash bids. */
  CreateCashBids = 'CREATE_CASH_BIDS',
  /** Indicates the user can create commodities. */
  CreateCommodities = 'CREATE_COMMODITIES',
  /** Indicates the user can create contracts. */
  CreateContracts = 'CREATE_CONTRACTS',
  /** Indicates the user can create customers. */
  CreateCustomers = 'CREATE_CUSTOMERS',
  /** Indicates the user can create custom attributes. */
  CreateCustomAttributes = 'CREATE_CUSTOM_ATTRIBUTES',
  /** Indicates the user can create documents. */
  CreateDocuments = 'CREATE_DOCUMENTS',
  /** Indicates the user can create locations. */
  CreateLocations = 'CREATE_LOCATIONS',
  /** Indicates the user can create notes. */
  CreateNotes = 'CREATE_NOTES',
  /** Indicates the user can create offers. */
  CreateOffers = 'CREATE_OFFERS',
  /** Indicates the user can create legacy eSign requests. */
  CreateSignatures = 'CREATE_SIGNATURES',
  /** Indicates the user can create eSign requests. */
  CreateSignatureRequests = 'CREATE_SIGNATURE_REQUESTS',
  /** Indicates the user can delete cash bids. */
  DeleteCashBids = 'DELETE_CASH_BIDS',
  /** Indicates the user can delete commodities. */
  DeleteCommodities = 'DELETE_COMMODITIES',
  /** Indicates the user can delete customers. */
  DeleteCustomers = 'DELETE_CUSTOMERS',
  /** Indicates the user can delete custom attributes. */
  DeleteCustomAttributes = 'DELETE_CUSTOM_ATTRIBUTES',
  /** Indicates the user can delete locations. */
  DeleteLocations = 'DELETE_LOCATIONS',
  /** Indicates the user can delete notes. */
  DeleteNotes = 'DELETE_NOTES',
  /** Indicates the user can withdraw legacy eSign requests. */
  DeleteSignatures = 'DELETE_SIGNATURES',
  /** Indicates the user can withdraw eSign requests. */
  DeleteSignatureRequests = 'DELETE_SIGNATURE_REQUESTS',
  /** Indicates the user can price contracts. */
  PriceContracts = 'PRICE_CONTRACTS',
  /** Indicates the user can update cash bids. */
  UpdateCashBids = 'UPDATE_CASH_BIDS',
  /** Indicates the user can update commodities. */
  UpdateCommodities = 'UPDATE_COMMODITIES',
  /** Indicates the user can update the company. */
  UpdateCompany = 'UPDATE_COMPANY',
  /** Indicates the user can update contracts. */
  UpdateContracts = 'UPDATE_CONTRACTS',
  /** Indicates the user can update customers. */
  UpdateCustomers = 'UPDATE_CUSTOMERS',
  /** Indicates the user can update custom attributes. */
  UpdateCustomAttributes = 'UPDATE_CUSTOM_ATTRIBUTES',
  /** Indicates the user can update documents. */
  UpdateDocuments = 'UPDATE_DOCUMENTS',
  /** Indicates the user can update locations. */
  UpdateLocations = 'UPDATE_LOCATIONS',
  /** Indicates the user can update offers. */
  UpdateOffers = 'UPDATE_OFFERS',
  /** Indicates the user can update legacy eSign requests. */
  UpdateSignatures = 'UPDATE_SIGNATURES',
  /** Indicates the user can update eSign requests. */
  UpdateSignatureRequests = 'UPDATE_SIGNATURE_REQUESTS',
  /** Indicates the user can view balances. */
  ViewBalances = 'VIEW_BALANCES',
  /** Indicates the user can view cash bids. */
  ViewCashBids = 'VIEW_CASH_BIDS',
  /** Indicates the user can view commodities. */
  ViewCommodities = 'VIEW_COMMODITIES',
  /** Indicates the user can view contracts. */
  ViewContracts = 'VIEW_CONTRACTS',
  /** Indicates the user can view custom attributes. */
  ViewCustomAttributes = 'VIEW_CUSTOM_ATTRIBUTES',
  /** Indicates the user can view documents. */
  ViewDocuments = 'VIEW_DOCUMENTS',
  /** Indicates the user can view locations. */
  ViewLocations = 'VIEW_LOCATIONS',
  /** Indicates the user can view notes. */
  ViewNotes = 'VIEW_NOTES',
  /** Indicates the user can view offers. */
  ViewOffers = 'VIEW_OFFERS',
  /** Indicates the user can view scale tickets. */
  ViewScaleTickets = 'VIEW_SCALE_TICKETS',
  /** Indicates the user can view settlements. */
  ViewSettlements = 'VIEW_SETTLEMENTS',
  /** Indicates the user can view legacy eSign requests. */
  ViewSignatures = 'VIEW_SIGNATURES',
  /** Indicates the user can view eSign requests. */
  ViewSignatureRequests = 'VIEW_SIGNATURE_REQUESTS'
}

export type UserAgreement = {
  __typename?: 'UserAgreement'
  /** The agreement details. */
  agreement?: Maybe<Agreement>
  /** Whether the agreement can be skipped or not. */
  canSkip?: Maybe<Scalars['Boolean']>
  /** Unique global ID for the user agreement. */
  id: Scalars['ID']
  /** The current status of the user agreement. */
  status?: Maybe<UserAgreementStatus>
  /** The time remaining, in seconds, before the user must accept the agreement. */
  timeRemaining?: Maybe<Scalars['Int']>
  /** The user the agreement pertains to. */
  user?: Maybe<User>
}

/** A paginated list of UserAgreement edges. */
export type UserAgreementConnection = {
  __typename?: 'UserAgreementConnection'
  /** A list of UserAgreement edges. */
  edges: Array<UserAgreementEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type UserAgreement and a cursor. */
export type UserAgreementEdge = {
  __typename?: 'UserAgreementEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The UserAgreement node. */
  node: UserAgreement
}

export type UserAgreementFilter = {
  /** Group filters with the `and` operator. */
  and?: InputMaybe<Array<InputMaybe<UserAgreementFilter>>>
  /** Filter on the `canSkip` field. */
  canSkip?: InputMaybe<BooleanFilter>
  /** Group filters with the `or` operator. */
  or?: InputMaybe<Array<InputMaybe<UserAgreementFilter>>>
  /** Filter on the `status` field. */
  status?: InputMaybe<UserAgreementStatusFilter>
  /** Filter on the `timeRemaining` field. */
  timeRemaining?: InputMaybe<IntFilter>
}

export enum UserAgreementStatus {
  /** Indicates the user has accepted the agreement. */
  Accepted = 'ACCEPTED',
  /** Indicates the user has yet to take action on the agreement. */
  Pending = 'PENDING',
  /** Indicates the user has skipped the agreement. */
  Skipped = 'SKIPPED'
}

export type UserAgreementStatusFilter = {
  /** Equal to the given `UserAgreementStatus`. */
  eq?: InputMaybe<UserAgreementStatus>
  /** Equal to any of the given `UserAgreementStatus`. */
  in?: InputMaybe<Array<UserAgreementStatus>>
}

export enum UserPresence {
  /** Indicates the user is currently active. */
  Active = 'ACTIVE',
  /** Indicates the user is currently away. */
  Away = 'AWAY'
}

export type UserPresenceFilter = {
  /** Equal to the given `UserPresence`. */
  eq?: InputMaybe<UserPresence>
  /** Equal to any of the given `UserPresence`. */
  in?: InputMaybe<Array<UserPresence>>
}

export type Vehicle = {
  __typename?: 'Vehicle'
  /** The company name for the vehicle. */
  companyName?: Maybe<Scalars['String']>
  /** The vehicle ID for display. */
  displayId?: Maybe<Scalars['ID']>
  /** The driver's name for the vehicle. */
  driverName?: Maybe<Scalars['String']>
  /** The license number for the vehicle. */
  licenseId?: Maybe<Scalars['ID']>
}

/** A webhook subscription for receiving events via HTTP POST. */
export type WebhookSubscription = {
  __typename?: 'WebhookSubscription'
  /** The callback URL events should be sent to. */
  callback: Scalars['String']
  /** The date and time the subscription was made. */
  createdAt: Scalars['DateTimeTz']
  /** Unique global ID for the webhook. */
  id: Scalars['ID']
  /** The query subscribed to. */
  query: Scalars['String']
  /** The topic subscribed to. */
  topic: Scalars['String']
  /** The date and time the subscription was last updated. */
  updatedAt: Scalars['DateTimeTz']
}

/** A paginated list of WebhookSubscription edges. */
export type WebhookSubscriptionConnection = {
  __typename?: 'WebhookSubscriptionConnection'
  /** A list of WebhookSubscription edges. */
  edges: Array<WebhookSubscriptionEdge>
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo
}

/** An edge that contains a node of type WebhookSubscription and a cursor. */
export type WebhookSubscriptionEdge = {
  __typename?: 'WebhookSubscriptionEdge'
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']
  /** The WebhookSubscription node. */
  node: WebhookSubscription
}

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type = {
  __typename?: '__Type'
  kind: __TypeKind
  name?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  specifiedByURL?: Maybe<Scalars['String']>
  fields?: Maybe<Array<__Field>>
  interfaces?: Maybe<Array<__Type>>
  possibleTypes?: Maybe<Array<__Type>>
  enumValues?: Maybe<Array<__EnumValue>>
  inputFields?: Maybe<Array<__InputValue>>
  ofType?: Maybe<__Type>
}

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>
}

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeEnumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>
}

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeInputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>
}

/** An enum describing what kind of type a given `__Type` is. */
export enum __TypeKind {
  /** Indicates this type is a scalar. */
  Scalar = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  Object = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  Interface = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  Union = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  Enum = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  InputObject = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  List = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NonNull = 'NON_NULL'
}

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field = {
  __typename?: '__Field'
  name: Scalars['String']
  description?: Maybe<Scalars['String']>
  args: Array<__InputValue>
  type: __Type
  isDeprecated: Scalars['Boolean']
  deprecationReason?: Maybe<Scalars['String']>
}

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __FieldArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>
}

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type __InputValue = {
  __typename?: '__InputValue'
  name: Scalars['String']
  description?: Maybe<Scalars['String']>
  type: __Type
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue?: Maybe<Scalars['String']>
  isDeprecated: Scalars['Boolean']
  deprecationReason?: Maybe<Scalars['String']>
}

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type __EnumValue = {
  __typename?: '__EnumValue'
  name: Scalars['String']
  description?: Maybe<Scalars['String']>
  isDeprecated: Scalars['Boolean']
  deprecationReason?: Maybe<Scalars['String']>
}

export type CancelOfferMutationVariables = Exact<{
  offerId: Scalars['ID']
}>

export type CancelOfferMutation = {
  __typename?: 'Mutation'
  cancelOffer?: { __typename?: 'Offer'; id: string } | null
}

export type RequestOfferAccessMutationVariables = Exact<{
  [key: string]: never
}>

export type RequestOfferAccessMutation = {
  __typename?: 'Mutation'
  requestOfferAccess?: {
    __typename?: 'Customer'
    offerStatus?: CustomerOfferStatus | null
  } | null
}

export type CreateOfferMutationVariables = Exact<{
  input: CreateOfferInput
}>

export type CreateOfferMutation = {
  __typename?: 'Mutation'
  createOffer?: { __typename?: 'Offer'; id: string } | null
}

export type LinkAccountsMutationVariables = Exact<{ [key: string]: never }>

export type LinkAccountsMutation = {
  __typename?: 'Mutation'
  linkAccounts: Array<{
    __typename?: 'Account'
    id: string
    displayId: string
    displayName?: string | null
  }>
}

export type RegisterDeviceMutationVariables = Exact<{
  input: RegisterDeviceInput
}>

export type RegisterDeviceMutation = {
  __typename?: 'Mutation'
  registerDevice?: { __typename?: 'Device'; token?: string | null } | null
}

export type RequestCashBidAccessMutationVariables = Exact<{
  input: RequestCashBidAccessInput
}>

export type RequestCashBidAccessMutation = {
  __typename?: 'Mutation'
  requestCashBidAccess?: {
    __typename?: 'CustomerLocationPreference'
    cashBidStatus?: CustomerCashBidStatus | null
    location?: { __typename?: 'Location'; name?: string | null } | null
  } | null
}

export type GetLocationsQueryVariables = Exact<{
  companyId: Scalars['ID']
  cursor?: InputMaybe<Scalars['String']>
  amount?: InputMaybe<Scalars['Int']>
}>

export type GetLocationsQuery = {
  __typename?: 'Query'
  node?:
    | { __typename?: 'Account' }
    | { __typename?: 'AccountingDocument' }
    | { __typename?: 'Booking' }
    | { __typename?: 'BookingItem' }
    | { __typename?: 'CashBid' }
    | { __typename?: 'Commodity' }
    | {
        __typename?: 'Company'
        id: string
        locations: {
          __typename?: 'LocationConnection'
          edges: Array<{
            __typename?: 'LocationEdge'
            node: {
              __typename?: 'Location'
              id: string
              name?: string | null
              city?: string | null
              state?: string | null
              hasCashBids?: boolean | null
              commodities?: Array<{
                __typename?: 'Commodity'
                id: string
                name?: string | null
              } | null> | null
            }
          }>
          pageInfo: {
            __typename?: 'PageInfo'
            endCursor?: string | null
            hasNextPage: boolean
          }
        }
      }
    | { __typename?: 'Contract' }
    | { __typename?: 'ContractPricing' }
    | { __typename?: 'Customer' }
    | { __typename?: 'DocuSealSignatureRequest' }
    | { __typename?: 'Elevator' }
    | { __typename?: 'Employee' }
    | { __typename?: 'EmployeeAccount' }
    | { __typename?: 'Farmer' }
    | { __typename?: 'HelloSignSignature' }
    | { __typename?: 'Location' }
    | { __typename?: 'Merchandiser' }
    | { __typename?: 'Offer' }
    | { __typename?: 'ScaleTicket' }
    | { __typename?: 'ScaleTicketSplit' }
    | { __typename?: 'UploadedDocument' }
    | null
}

export type GetUserQueryVariables = Exact<{ [key: string]: never }>

export type GetUserQuery = {
  __typename?: 'Query'
  viewer?:
    | { __typename?: 'Account' }
    | { __typename?: 'Anonymous' }
    | {
        __typename?: 'Customer'
        id: string
        fullName?: string | null
        email?: string | null
        mobilePhone?: string | null
        offerStatus?: CustomerOfferStatus | null
        accounts?: {
          __typename?: 'AccountConnection'
          edges: Array<{
            __typename?: 'AccountEdge'
            node: {
              __typename?: 'Account'
              id: string
              displayId: string
              displayName?: string | null
            }
          }>
        } | null
        company?: {
          __typename?: 'Company'
          id: string
          name?: string | null
          settings?: {
            __typename?: 'CompanySettings'
            offers?: {
              __typename?: 'OfferSettings'
              terms?: string | null
            } | null
          } | null
        } | null
        pendingSignatureRequests: {
          __typename?: 'SignatureRequestConnection'
          pageInfo: { __typename?: 'PageInfo'; total: number }
        }
      }
    | { __typename?: 'Employee' }
    | { __typename?: 'EmployeeAccount' }
    | { __typename?: 'Farmer' }
    | { __typename?: 'Merchandiser' }
    | null
}

export type GetContractsQueryVariables = Exact<{
  filter?: InputMaybe<ContractFilter>
}>

export type GetContractsQuery = {
  __typename?: 'Query'
  viewer?:
    | { __typename?: 'Account' }
    | { __typename?: 'Anonymous' }
    | {
        __typename?: 'Customer'
        id: string
        contracts?: {
          __typename?: 'ContractConnection'
          edges: Array<{
            __typename?: 'ContractEdge'
            node: { __typename?: 'Contract'; id: string }
          }>
          pageInfo: { __typename?: 'PageInfo'; total: number }
        } | null
      }
    | { __typename?: 'Employee' }
    | { __typename?: 'EmployeeAccount' }
    | { __typename?: 'Farmer' }
    | { __typename?: 'Merchandiser' }
    | null
}

export type GetScaleTicketsQueryVariables = Exact<{
  filter?: InputMaybe<ScaleTicketFilter>
}>

export type GetScaleTicketsQuery = {
  __typename?: 'Query'
  viewer?:
    | { __typename?: 'Account' }
    | { __typename?: 'Anonymous' }
    | {
        __typename?: 'Customer'
        id: string
        scaleTickets?: {
          __typename?: 'ScaleTicketConnection'
          edges: Array<{
            __typename?: 'ScaleTicketEdge'
            node: { __typename?: 'ScaleTicket'; id: string }
          }>
          pageInfo: { __typename?: 'PageInfo'; total: number }
        } | null
      }
    | { __typename?: 'Employee' }
    | { __typename?: 'EmployeeAccount' }
    | { __typename?: 'Farmer' }
    | { __typename?: 'Merchandiser' }
    | null
}

export type GetOutboundScaleTicketsQueryVariables = Exact<{
  filter?: InputMaybe<ScaleTicketFilter>
}>

export type GetOutboundScaleTicketsQuery = {
  __typename?: 'Query'
  viewer?:
    | { __typename?: 'Account' }
    | { __typename?: 'Anonymous' }
    | {
        __typename?: 'Customer'
        id: string
        outboundScaleTickets?: {
          __typename?: 'ScaleTicketConnection'
          edges: Array<{
            __typename?: 'ScaleTicketEdge'
            node: { __typename?: 'ScaleTicket'; id: string }
          }>
          pageInfo: { __typename?: 'PageInfo'; total: number }
        } | null
      }
    | { __typename?: 'Employee' }
    | { __typename?: 'EmployeeAccount' }
    | { __typename?: 'Farmer' }
    | { __typename?: 'Merchandiser' }
    | null
}

export type GetSettlementsQueryVariables = Exact<{
  filter?: InputMaybe<SettlementFilter>
}>

export type GetSettlementsQuery = {
  __typename?: 'Query'
  viewer?:
    | { __typename?: 'Account' }
    | { __typename?: 'Anonymous' }
    | {
        __typename?: 'Customer'
        id: string
        settlements?: {
          __typename?: 'SettlementConnection'
          edges: Array<{
            __typename?: 'SettlementEdge'
            node: { __typename?: 'Settlement'; id: string }
          }>
          pageInfo: { __typename?: 'PageInfo'; total: number }
        } | null
      }
    | { __typename?: 'Employee' }
    | { __typename?: 'EmployeeAccount' }
    | { __typename?: 'Farmer' }
    | { __typename?: 'Merchandiser' }
    | null
}

export type GetBookingsQueryVariables = Exact<{
  filter?: InputMaybe<BookingFilter>
}>

export type GetBookingsQuery = {
  __typename?: 'Query'
  viewer?:
    | { __typename?: 'Account' }
    | { __typename?: 'Anonymous' }
    | {
        __typename?: 'Customer'
        id: string
        bookings?: {
          __typename?: 'BookingConnection'
          edges: Array<{
            __typename?: 'BookingEdge'
            node: { __typename?: 'Booking'; id: string }
          }>
          pageInfo: { __typename?: 'PageInfo'; total: number }
        } | null
      }
    | { __typename?: 'Employee' }
    | { __typename?: 'EmployeeAccount' }
    | { __typename?: 'Farmer' }
    | { __typename?: 'Merchandiser' }
    | null
}

export type GetBalancesQueryVariables = Exact<{ [key: string]: never }>

export type GetBalancesQuery = {
  __typename?: 'Query'
  viewer?:
    | { __typename?: 'Account' }
    | { __typename?: 'Anonymous' }
    | {
        __typename?: 'Customer'
        id: string
        accounts?: {
          __typename?: 'AccountConnection'
          edges: Array<{
            __typename?: 'AccountEdge'
            node: {
              __typename?: 'Account'
              id: string
              displayId: string
              displayName?: string | null
            }
          }>
        } | null
        balancesBy?: Array<{
          __typename?: 'BalanceBy'
          id: string
          name?: string | null
          amount?: number | null
          commodities?: Array<{
            __typename?: 'BalanceBy'
            id: string
            name?: string | null
            amount?: number | null
            positions?: Array<{
              __typename?: 'BalanceBy'
              name?: string | null
              amount?: number | null
            } | null> | null
            locations?: Array<{
              __typename?: 'BalanceBy'
              id: string
              name?: string | null
              amount?: number | null
              positions?: Array<{
                __typename?: 'BalanceBy'
                name?: string | null
                amount?: number | null
              } | null> | null
            } | null> | null
          } | null> | null
        } | null> | null
      }
    | { __typename?: 'Employee' }
    | { __typename?: 'EmployeeAccount' }
    | { __typename?: 'Farmer' }
    | { __typename?: 'Merchandiser' }
    | null
}

export type GetSignaturesQueryVariables = Exact<{
  status?: InputMaybe<
    Array<InputMaybe<SignatureStatus>> | InputMaybe<SignatureStatus>
  >
  cursor?: InputMaybe<Scalars['String']>
}>

export type GetSignaturesQuery = {
  __typename?: 'Query'
  viewer?:
    | { __typename?: 'Account' }
    | { __typename?: 'Anonymous' }
    | {
        __typename?: 'Customer'
        id: string
        signatures: {
          __typename?: 'SignatureConnection'
          edges: Array<{
            __typename?: 'SignatureEdge'
            node: {
              __typename?: 'HelloSignSignature'
              id: string
              createdAt?: any | null
              signedAt?: any | null
              expiresAt?: any | null
              status?: SignatureStatus | null
              downloadUrl?: string | null
              description?: string | null
              user?:
                | { __typename?: 'Account'; fullName?: string | null }
                | { __typename?: 'Anonymous'; fullName?: string | null }
                | { __typename?: 'Customer'; fullName?: string | null }
                | { __typename?: 'Employee'; fullName?: string | null }
                | { __typename?: 'EmployeeAccount'; fullName?: string | null }
                | { __typename?: 'Farmer'; fullName?: string | null }
                | { __typename?: 'Merchandiser'; fullName?: string | null }
                | null
              signable?: {
                __typename: 'Contract'
                id: string
                displayId: string
              } | null
            }
          }>
          pageInfo: {
            __typename?: 'PageInfo'
            endCursor?: string | null
            hasNextPage: boolean
          }
        }
      }
    | { __typename?: 'Employee' }
    | { __typename?: 'EmployeeAccount' }
    | { __typename?: 'Farmer' }
    | { __typename?: 'Merchandiser' }
    | null
}

export type GetFiltersMetadataQueryVariables = Exact<{ [key: string]: never }>

export type GetFiltersMetadataQuery = {
  __typename?: 'Query'
  contractStatuses?: {
    __typename?: '__Type'
    enumValues?: Array<{ __typename?: '__EnumValue'; name: string }> | null
  } | null
  viewer?:
    | { __typename?: 'Account' }
    | { __typename?: 'Anonymous' }
    | {
        __typename?: 'Customer'
        id: string
        accounts?: {
          __typename?: 'AccountConnection'
          edges: Array<{
            __typename?: 'AccountEdge'
            node: {
              __typename?: 'Account'
              id: string
              displayId: string
              displayName?: string | null
            }
          }>
        } | null
        company?: {
          __typename?: 'Company'
          id: string
          commodities: {
            __typename?: 'CommodityConnection'
            edges: Array<{
              __typename?: 'CommodityEdge'
              node: {
                __typename?: 'Commodity'
                id: string
                name?: string | null
              }
            }>
          }
          locations: {
            __typename?: 'LocationConnection'
            edges: Array<{
              __typename?: 'LocationEdge'
              node: {
                __typename?: 'Location'
                id: string
                name?: string | null
              }
            }>
          }
          contractTypes?: {
            __typename?: 'ContractTypeConnection'
            edges: Array<{
              __typename?: 'ContractTypeEdge'
              node: { __typename?: 'ContractType'; id: string; name: string }
            }>
          } | null
          settings?: {
            __typename?: 'CompanySettings'
            contracts?: {
              __typename?: 'ContractSettings'
              filterFields: Array<ContractFilterField>
              sortFields: Array<ContractSortField>
            } | null
            scaleTickets?: {
              __typename?: 'ScaleTicketSettings'
              filterFields: Array<ScaleTicketFilterField>
              sortFields: Array<ScaleTicketSortField>
            } | null
            settlements?: {
              __typename?: 'SettlementSettings'
              filterFields: Array<SettlementFilterField>
              sortFields: Array<SettlementSortField>
            } | null
            bookings?: {
              __typename?: 'BookingSettings'
              filterFields: Array<BookingFilterField>
              sortFields: Array<BookingSortField>
            } | null
          } | null
        } | null
      }
    | { __typename?: 'Employee' }
    | { __typename?: 'EmployeeAccount' }
    | { __typename?: 'Farmer' }
    | { __typename?: 'Merchandiser' }
    | null
}

export type GetSignatureSignUrlQueryVariables = Exact<{
  signatureId: Scalars['ID']
}>

export type GetSignatureSignUrlQuery = {
  __typename?: 'Query'
  node?:
    | { __typename?: 'Account'; id: string }
    | { __typename?: 'AccountingDocument'; id: string }
    | { __typename?: 'Booking'; id: string }
    | { __typename?: 'BookingItem'; id: string }
    | { __typename?: 'CashBid'; id: string }
    | { __typename?: 'Commodity'; id: string }
    | { __typename?: 'Company'; id: string }
    | { __typename?: 'Contract'; id: string }
    | { __typename?: 'ContractPricing'; id: string }
    | { __typename?: 'Customer'; id: string }
    | { __typename?: 'DocuSealSignatureRequest'; id: string }
    | { __typename?: 'Elevator'; id: string }
    | { __typename?: 'Employee'; id: string }
    | { __typename?: 'EmployeeAccount'; id: string }
    | { __typename?: 'Farmer'; id: string }
    | { __typename?: 'HelloSignSignature'; signUrl?: string | null; id: string }
    | { __typename?: 'Location'; id: string }
    | { __typename?: 'Merchandiser'; id: string }
    | { __typename?: 'Offer'; id: string }
    | { __typename?: 'ScaleTicket'; id: string }
    | { __typename?: 'ScaleTicketSplit'; id: string }
    | { __typename?: 'UploadedDocument'; id: string }
    | null
}

export type GetCompaniesQueryVariables = Exact<{
  filter?: InputMaybe<CompanyFilter>
}>

export type GetCompaniesQuery = {
  __typename?: 'Query'
  companies: {
    __typename?: 'CompanyConnection'
    edges: Array<{
      __typename?: 'CompanyEdge'
      node: {
        __typename?: 'Company'
        id: string
        displayId?: string | null
        name?: string | null
        features?: Array<CompanyFeature | null> | null
        logo?: string | null
        website?: string | null
        links?: Array<{
          __typename?: 'Link'
          label?: string | null
          url?: string | null
        } | null> | null
        contact?: {
          __typename?: 'CompanyContact'
          phoneNumber?: string | null
          email?: string | null
          zipCode?: string | null
        } | null
        settings?: {
          __typename?: 'CompanySettings'
          marketplace?: {
            __typename?: 'MarketplaceSettings'
            appStoreUrl?: string | null
            googlePlayUrl?: string | null
            contractDesktopFields?: Array<{
              __typename?: 'MarketplaceField'
              label?: string | null
              query?: string | null
              jsonata?: string | null
              action?: string | null
              styles?: Array<string | null> | null
              display?: string | null
            } | null> | null
            contractDetailFields?: Array<{
              __typename?: 'MarketplaceField'
              label?: string | null
              query?: string | null
              jsonata?: string | null
              action?: string | null
              styles?: Array<string | null> | null
              display?: string | null
            } | null> | null
            contractPricingFields?: Array<{
              __typename?: 'MarketplaceField'
              label?: string | null
              query?: string | null
              jsonata?: string | null
              action?: string | null
              styles?: Array<string | null> | null
              display?: string | null
            } | null> | null
            contractPricingDetailFields?: Array<{
              __typename?: 'MarketplaceField'
              label?: string | null
              query?: string | null
              jsonata?: string | null
              action?: string | null
              styles?: Array<string | null> | null
              display?: string | null
            } | null> | null
            scaleTicketDesktopFields?: Array<{
              __typename?: 'MarketplaceField'
              label?: string | null
              query?: string | null
              jsonata?: string | null
              action?: string | null
              styles?: Array<string | null> | null
              display?: string | null
            } | null> | null
            scaleTicketDetailFields?: Array<{
              __typename?: 'MarketplaceField'
              label?: string | null
              query?: string | null
              jsonata?: string | null
              action?: string | null
              styles?: Array<string | null> | null
              display?: string | null
            } | null> | null
            scaleTicketFactorFields?: Array<{
              __typename?: 'MarketplaceField'
              label?: string | null
              query?: string | null
              jsonata?: string | null
              action?: string | null
              styles?: Array<string | null> | null
              display?: string | null
            } | null> | null
            scaleTicketNoteFields?: Array<{
              __typename?: 'MarketplaceField'
              label?: string | null
              query?: string | null
              jsonata?: string | null
              action?: string | null
              styles?: Array<string | null> | null
              display?: string | null
            } | null> | null
            scaleTicketSplitFields?: Array<{
              __typename?: 'MarketplaceField'
              label?: string | null
              query?: string | null
              jsonata?: string | null
              action?: string | null
              styles?: Array<string | null> | null
              display?: string | null
            } | null> | null
            outboundScaleTicketDesktopFields?: Array<{
              __typename?: 'MarketplaceField'
              label?: string | null
              query?: string | null
              jsonata?: string | null
              action?: string | null
              styles?: Array<string | null> | null
              display?: string | null
            } | null> | null
            outboundScaleTicketDetailFields?: Array<{
              __typename?: 'MarketplaceField'
              label?: string | null
              query?: string | null
              jsonata?: string | null
              action?: string | null
              styles?: Array<string | null> | null
              display?: string | null
            } | null> | null
            settlementDesktopFields?: Array<{
              __typename?: 'MarketplaceField'
              label?: string | null
              query?: string | null
              jsonata?: string | null
              action?: string | null
              styles?: Array<string | null> | null
              display?: string | null
            } | null> | null
            offerDesktopFields?: Array<{
              __typename?: 'MarketplaceField'
              label?: string | null
              query?: string | null
              jsonata?: string | null
              action?: string | null
              styles?: Array<string | null> | null
              display?: string | null
            } | null> | null
            signatureRequestsDesktopFields?: Array<{
              __typename?: 'MarketplaceField'
              label?: string | null
              query?: string | null
              jsonata?: string | null
              action?: string | null
              styles?: Array<string | null> | null
              display?: string | null
            } | null> | null
            bookingsDesktopFields?: Array<{
              __typename?: 'MarketplaceField'
              label?: string | null
              query?: string | null
              jsonata?: string | null
              action?: string | null
              styles?: Array<string | null> | null
              display?: string | null
            } | null> | null
            bookingsHeaderFields?: Array<{
              __typename?: 'MarketplaceField'
              label?: string | null
              query?: string | null
              jsonata?: string | null
              action?: string | null
              styles?: Array<string | null> | null
              display?: string | null
            } | null> | null
            bookingsDetailsFields?: Array<{
              __typename?: 'MarketplaceField'
              label?: string | null
              query?: string | null
              jsonata?: string | null
              action?: string | null
              styles?: Array<string | null> | null
              display?: string | null
            } | null> | null
            bookingsItemsFields?: Array<{
              __typename?: 'MarketplaceField'
              label?: string | null
              query?: string | null
              jsonata?: string | null
              action?: string | null
              styles?: Array<string | null> | null
              display?: string | null
            } | null> | null
            bookingsItemsHeaderFields?: Array<{
              __typename?: 'MarketplaceField'
              label?: string | null
              query?: string | null
              jsonata?: string | null
              action?: string | null
              styles?: Array<string | null> | null
              display?: string | null
            } | null> | null
            bookingItemsDetailsFields?: Array<{
              __typename?: 'MarketplaceField'
              label?: string | null
              query?: string | null
              jsonata?: string | null
              action?: string | null
              styles?: Array<string | null> | null
              display?: string | null
            } | null> | null
            cashBidsDesktopFields?: Array<{
              __typename?: 'MarketplaceField'
              label?: string | null
              query?: string | null
              jsonata?: string | null
              action?: string | null
              styles?: Array<string | null> | null
              display?: string | null
            } | null> | null
          } | null
        } | null
      }
    }>
  }
}

export const CancelOfferDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelOffer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'offerId' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelOffer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'offerId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CancelOfferMutation, CancelOfferMutationVariables>
export const RequestOfferAccessDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RequestOfferAccess' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestOfferAccess' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'offerStatus' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  RequestOfferAccessMutation,
  RequestOfferAccessMutationVariables
>
export const CreateOfferDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateOffer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateOfferInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createOffer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CreateOfferMutation, CreateOfferMutationVariables>
export const LinkAccountsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'LinkAccounts' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'linkAccounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  LinkAccountsMutation,
  LinkAccountsMutationVariables
>
export const RegisterDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RegisterDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RegisterDeviceInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registerDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'token' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  RegisterDeviceMutation,
  RegisterDeviceMutationVariables
>
export const RequestCashBidAccessDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RequestCashBidAccess' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RequestCashBidAccessInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestCashBidAccess' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cashBidStatus' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  RequestCashBidAccessMutation,
  RequestCashBidAccessMutationVariables
>
export const GetLocationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetLocations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'companyId' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cursor' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'amount' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'node' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'companyId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Company' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'locations' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'amount' }
                            }
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'after' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'cursor' }
                            }
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'node' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'city' }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'state' }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'commodities'
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'name'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'hasCashBids'
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pageInfo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'endCursor' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasNextPage' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetLocationsQuery, GetLocationsQueryVariables>
export const GetUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUser' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Customer' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullName' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mobilePhone' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'offerStatus' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accounts' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '100' }
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'node' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'displayId'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'displayName'
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'company' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'settings' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'offers' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'terms' }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        alias: {
                          kind: 'Name',
                          value: 'pendingSignatureRequests'
                        },
                        name: { kind: 'Name', value: 'signatureRequests' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'status' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'eq' },
                                        value: {
                                          kind: 'EnumValue',
                                          value: 'PENDING'
                                        }
                                      }
                                    ]
                                  }
                                }
                              ]
                            }
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pageInfo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'total' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>
export const GetContractsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetContracts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' }
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ContractFilter' }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Customer' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contracts' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'filter' }
                            }
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'node' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pageInfo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'total' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetContractsQuery, GetContractsQueryVariables>
export const GetScaleTicketsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetScaleTickets' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' }
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ScaleTicketFilter' }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Customer' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scaleTickets' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'filter' }
                            }
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'node' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pageInfo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'total' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetScaleTicketsQuery,
  GetScaleTicketsQueryVariables
>
export const GetOutboundScaleTicketsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetOutboundScaleTickets' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' }
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ScaleTicketFilter' }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Customer' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outboundScaleTickets' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'filter' }
                            }
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'node' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pageInfo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'total' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetOutboundScaleTicketsQuery,
  GetOutboundScaleTicketsQueryVariables
>
export const GetSettlementsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSettlements' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' }
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SettlementFilter' }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Customer' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'settlements' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'filter' }
                            }
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'node' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pageInfo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'total' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetSettlementsQuery, GetSettlementsQueryVariables>
export const GetBookingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBookings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' }
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'BookingFilter' }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Customer' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bookings' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'filter' }
                            }
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'node' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pageInfo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'total' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetBookingsQuery, GetBookingsQueryVariables>
export const GetBalancesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBalances' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Customer' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accounts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'node' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'displayId'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'displayName'
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'balancesBy' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'type' },
                            value: { kind: 'EnumValue', value: 'ACCOUNT' }
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' }
                            },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'commodities' },
                              name: { kind: 'Name', value: 'items' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'type' },
                                  value: {
                                    kind: 'EnumValue',
                                    value: 'COMMODITY'
                                  }
                                }
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'amount' }
                                  },
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'positions' },
                                    name: { kind: 'Name', value: 'items' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'type' },
                                        value: {
                                          kind: 'EnumValue',
                                          value: 'POSITION'
                                        }
                                      }
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'amount'
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'locations' },
                                    name: { kind: 'Name', value: 'items' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'type' },
                                        value: {
                                          kind: 'EnumValue',
                                          value: 'LOCATION'
                                        }
                                      }
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'amount'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value: 'positions'
                                          },
                                          name: {
                                            kind: 'Name',
                                            value: 'items'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'type'
                                              },
                                              value: {
                                                kind: 'EnumValue',
                                                value: 'POSITION'
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'name'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'amount'
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetBalancesQuery, GetBalancesQueryVariables>
export const GetSignaturesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSignatures' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'status' }
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SignatureStatus' }
            }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cursor' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Customer' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'signatures' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'status' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'status' }
                            }
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '100' }
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'after' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'cursor' }
                            }
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'node' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'createdAt'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'signedAt'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'expiresAt'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'status'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'downloadUrl'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'ttl'
                                              },
                                              value: {
                                                kind: 'IntValue',
                                                value: '60'
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'user' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'fullName'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'description'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'signable'
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: '__typename'
                                                }
                                              },
                                              {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                  kind: 'NamedType',
                                                  name: {
                                                    kind: 'Name',
                                                    value: 'Contract'
                                                  }
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'id'
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'displayId'
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pageInfo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'endCursor' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasNextPage' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetSignaturesQuery, GetSignaturesQueryVariables>
export const GetFiltersMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFiltersMetadata' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'contractStatuses' },
            name: { kind: 'Name', value: '__type' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: {
                  kind: 'StringValue',
                  value: 'ContractStatus',
                  block: false
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'enumValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Customer' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accounts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'node' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'displayId'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'displayName'
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'company' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'commodities' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'first' },
                                  value: { kind: 'IntValue', value: '100' }
                                }
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'node' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'name'
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'locations' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'first' },
                                  value: { kind: 'IntValue', value: '100' }
                                }
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'node' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'name'
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contractTypes' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'first' },
                                  value: { kind: 'IntValue', value: '100' }
                                }
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'node' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'name'
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'settings' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'contracts' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'filterFields'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'sortFields'
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'scaleTickets'
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'filterFields'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'sortFields'
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'settlements'
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'filterFields'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'sortFields'
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bookings' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'filterFields'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'sortFields'
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetFiltersMetadataQuery,
  GetFiltersMetadataQueryVariables
>
export const GetSignatureSignUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSignatureSignUrl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'signatureId' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'node' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'signatureId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HelloSignSignature' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'signUrl' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'hosted' },
                            value: { kind: 'BooleanValue', value: false }
                          }
                        ]
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetSignatureSignUrlQuery,
  GetSignatureSignUrlQueryVariables
>
export const GetCompaniesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCompanies' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' }
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'CompanyFilter' }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companies' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'features' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'logo' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'links' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'label' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contact' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'phoneNumber' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'email' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'zipCode' }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'website' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'settings' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'marketplace'
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'appStoreUrl'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'googlePlayUrl'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value: 'contractDesktopFields'
                                          },
                                          name: {
                                            kind: 'Name',
                                            value: 'fields'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'view'
                                              },
                                              value: {
                                                kind: 'StringValue',
                                                value: 'contracts.desktop',
                                                block: false
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'query'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'jsonata'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'action'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'styles'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'display'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value: 'contractDetailFields'
                                          },
                                          name: {
                                            kind: 'Name',
                                            value: 'fields'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'view'
                                              },
                                              value: {
                                                kind: 'StringValue',
                                                value: 'contracts.details-v2',
                                                block: false
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'query'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'jsonata'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'action'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'styles'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'display'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value: 'contractPricingFields'
                                          },
                                          name: {
                                            kind: 'Name',
                                            value: 'fields'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'view'
                                              },
                                              value: {
                                                kind: 'StringValue',
                                                value: 'contracts.pricing',
                                                block: false
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'query'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'jsonata'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'action'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'styles'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'display'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value: 'contractPricingDetailFields'
                                          },
                                          name: {
                                            kind: 'Name',
                                            value: 'fields'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'view'
                                              },
                                              value: {
                                                kind: 'StringValue',
                                                value:
                                                  'contracts.pricingDetails-v2',
                                                block: false
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'query'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'jsonata'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'action'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'styles'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'display'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value: 'scaleTicketDesktopFields'
                                          },
                                          name: {
                                            kind: 'Name',
                                            value: 'fields'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'view'
                                              },
                                              value: {
                                                kind: 'StringValue',
                                                value: 'scaleTickets.desktop',
                                                block: false
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'query'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'jsonata'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'action'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'styles'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'display'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value: 'scaleTicketDetailFields'
                                          },
                                          name: {
                                            kind: 'Name',
                                            value: 'fields'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'view'
                                              },
                                              value: {
                                                kind: 'StringValue',
                                                value:
                                                  'scaleTickets.details-v2',
                                                block: false
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'query'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'jsonata'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'action'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'styles'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'display'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value: 'scaleTicketFactorFields'
                                          },
                                          name: {
                                            kind: 'Name',
                                            value: 'fields'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'view'
                                              },
                                              value: {
                                                kind: 'StringValue',
                                                value:
                                                  'scaleTickets.gradeFactors',
                                                block: false
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'query'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'jsonata'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'action'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'styles'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'display'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value: 'scaleTicketNoteFields'
                                          },
                                          name: {
                                            kind: 'Name',
                                            value: 'fields'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'view'
                                              },
                                              value: {
                                                kind: 'StringValue',
                                                value: 'scaleTickets.notes',
                                                block: false
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'query'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'jsonata'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'action'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'styles'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'display'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value: 'scaleTicketSplitFields'
                                          },
                                          name: {
                                            kind: 'Name',
                                            value: 'fields'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'view'
                                              },
                                              value: {
                                                kind: 'StringValue',
                                                value: 'scaleTickets.splits',
                                                block: false
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'query'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'jsonata'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'action'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'styles'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'display'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value:
                                              'outboundScaleTicketDesktopFields'
                                          },
                                          name: {
                                            kind: 'Name',
                                            value: 'fields'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'view'
                                              },
                                              value: {
                                                kind: 'StringValue',
                                                value:
                                                  'outboundScaleTickets.desktop',
                                                block: false
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'query'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'jsonata'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'action'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'styles'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'display'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value:
                                              'outboundScaleTicketDetailFields'
                                          },
                                          name: {
                                            kind: 'Name',
                                            value: 'fields'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'view'
                                              },
                                              value: {
                                                kind: 'StringValue',
                                                value:
                                                  'outboundScaleTickets.details',
                                                block: false
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'query'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'jsonata'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'action'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'styles'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'display'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value: 'settlementDesktopFields'
                                          },
                                          name: {
                                            kind: 'Name',
                                            value: 'fields'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'view'
                                              },
                                              value: {
                                                kind: 'StringValue',
                                                value: 'settlements.desktop',
                                                block: false
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'query'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'jsonata'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'action'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'styles'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'display'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value: 'offerDesktopFields'
                                          },
                                          name: {
                                            kind: 'Name',
                                            value: 'fields'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'view'
                                              },
                                              value: {
                                                kind: 'StringValue',
                                                value: 'offers.desktop',
                                                block: false
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'query'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'jsonata'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'action'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'styles'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'display'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value:
                                              'signatureRequestsDesktopFields'
                                          },
                                          name: {
                                            kind: 'Name',
                                            value: 'fields'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'view'
                                              },
                                              value: {
                                                kind: 'StringValue',
                                                value: 'signatureRequests',
                                                block: false
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'query'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'jsonata'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'action'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'styles'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'display'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value: 'bookingsDesktopFields'
                                          },
                                          name: {
                                            kind: 'Name',
                                            value: 'fields'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'view'
                                              },
                                              value: {
                                                kind: 'StringValue',
                                                value: 'bookings.desktop',
                                                block: false
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'query'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'jsonata'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'action'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'styles'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'display'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value: 'bookingsHeaderFields'
                                          },
                                          name: {
                                            kind: 'Name',
                                            value: 'fields'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'view'
                                              },
                                              value: {
                                                kind: 'StringValue',
                                                value: 'bookings.header',
                                                block: false
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'query'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'jsonata'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'action'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'styles'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'display'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value: 'bookingsDetailsFields'
                                          },
                                          name: {
                                            kind: 'Name',
                                            value: 'fields'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'view'
                                              },
                                              value: {
                                                kind: 'StringValue',
                                                value: 'bookings.details',
                                                block: false
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'query'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'jsonata'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'action'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'styles'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'display'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value: 'bookingsItemsFields'
                                          },
                                          name: {
                                            kind: 'Name',
                                            value: 'fields'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'view'
                                              },
                                              value: {
                                                kind: 'StringValue',
                                                value: 'bookings.items',
                                                block: false
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'query'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'jsonata'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'action'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'styles'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'display'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value: 'bookingsItemsHeaderFields'
                                          },
                                          name: {
                                            kind: 'Name',
                                            value: 'fields'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'view'
                                              },
                                              value: {
                                                kind: 'StringValue',
                                                value: 'bookingItems.header',
                                                block: false
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'query'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'jsonata'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'action'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'styles'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'display'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value: 'bookingItemsDetailsFields'
                                          },
                                          name: {
                                            kind: 'Name',
                                            value: 'fields'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'view'
                                              },
                                              value: {
                                                kind: 'StringValue',
                                                value: 'bookingItems.details',
                                                block: false
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'query'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'jsonata'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'action'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'styles'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'display'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          alias: {
                                            kind: 'Name',
                                            value: 'cashBidsDesktopFields'
                                          },
                                          name: {
                                            kind: 'Name',
                                            value: 'fields'
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'view'
                                              },
                                              value: {
                                                kind: 'StringValue',
                                                value: 'cashBids.desktop',
                                                block: false
                                              }
                                            }
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'query'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'jsonata'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'action'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'styles'
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'display'
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetCompaniesQuery, GetCompaniesQueryVariables>
